export const translations = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      portfolio: 'Cases',
      articles: 'Articles',
      about: 'About',
      contact: 'Contact',
      getConsultation: 'Get a quote',
      getConsultationShort: 'Get a quote',
      bookCall: 'Book a call',
      openMenu: 'Menu',
      closeMenu: 'Close'
    },
    seo: {
      home: {
        title: 'Byteet | Web Design & Development for SMBs',
        description: 'Byteet designs and builds websites, webshops and web applications for Dutch SMBs, and runs the IT behind them: managed support, cloud, security, data & AI.'
      },
      about: {
        title: 'About Byteet | IT Partner & Managed Services Provider',
        description: 'About Byteet, the IT partner for Dutch SMBs: who we are, how we work, and our managed IT support, cloud, cybersecurity, data, AI and software services.'
      },
      contact: {
        title: 'Contact Byteet | IT Services Consultation Netherlands',
        description: 'Contact Byteet for a personalized quote on managed IT, cloud, cybersecurity, data, AI automation or custom software for your SMB in the Netherlands.'
      },
      book: {
        title: 'Book a Free IT Advisory Call | Byteet',
        description: 'Book a free {minutes}-minute advisory call with Byteet on Google Meet. Pick a time that suits you and the calendar invite arrives by email. No obligation.'
      },
      services: {
        title: 'IT Services for SMBs | Managed IT, Cloud & Security | Byteet',
        description: 'Byteet\'s IT services for Dutch SMBs: managed IT support, cloud & infrastructure, cybersecurity, data & databases, AI & automation and custom software.'
      },
      portfolio: {
        title: 'Client Cases & Success Stories | IT for SMBs | Byteet',
        description: 'Byteet client cases: real results for Dutch SMBs across managed IT, cloud, cybersecurity, data and custom software. See how we delivered measurable impact.'
      },
      privacy: {
        title: 'Privacy Policy - Byteet | GDPR Compliance in the Netherlands',
        description: 'Byteet\'s Privacy Policy explains how we collect, use and protect your personal data in line with the GDPR and EU data protection rules.'
      },
      terms: {
        title: 'Terms of Service - Byteet | Legal Terms',
        description: 'Read Byteet\'s Terms of Service to understand the legal terms and conditions governing your use of our website and IT services in the Netherlands.'
      },
      notFound: {
        title: 'Page Not Found - Byteet',
        description: 'The page you are looking for could not be found. Return to Byteet\'s homepage to explore our IT services.'
      }
    },
    serviceSeo: {
      'managed-it-support': {
        title: 'Managed IT Support for SMBs in the Netherlands | Byteet',
        description: 'Outsource your IT to Byteet: managed helpdesk, endpoint management, service desk and 24/7 monitoring for Dutch SMBs. Fixed monthly fee, no surprises.'
      },
      'cloud-infrastructure': {
        title: 'Cloud Migration & Microsoft 365 for SMBs | Byteet',
        description: 'Migrate safely to Microsoft 365 and Azure with Byteet. Cloud migration, server & virtualization management and managed cloud for Dutch SMBs.'
      },
      'cybersecurity-identity': {
        title: 'Cybersecurity & NIS2 Compliance for SMBs | Byteet',
        description: 'Protect your SMB with Byteet: cybersecurity, identity & access management, pentesting and NIS2/ISO 27001 compliance. Book a free security scan.'
      },
      'data-databases': {
        title: 'Database Management & Data Platforms for SMBs | Byteet',
        description: 'Reliable database management by Byteet: proactive administration, low-downtime migration, backup & recovery, plus data platforms and Power BI for SMBs.'
      },
      'ai-automation': {
        title: 'AI Automation & AI Agents for SMBs | Byteet',
        description: 'Automate your business with Byteet: AI workflow automation, AI agents and chatbots on your own data, and document AI, compliant with the GDPR and EU AI Act.'
      },
      'web-software-development': {
        title: 'Web Design & Development | Websites & Web Apps | Byteet',
        description: 'Websites, webshops and web applications designed and built by Byteet with React and Next.js, plus custom software. You own the source code: no vendor lock-in.'
      },
      'mobile-app-development': {
        title: 'Mobile App Development for iOS & Android | Byteet',
        description: 'Byteet builds iOS and Android apps for SMBs: native or cross-platform with React Native or Flutter, plus the backend, App Store publishing and maintenance.'
      },
      'crm-development': {
        title: 'Custom CRM Development & Integration | Byteet',
        description: 'A CRM that fits how you sell: Byteet builds custom CRMs or extends HubSpot, Salesforce and Dynamics 365, linked to email, invoicing and your website.'
      },
      'erp-systems': {
        title: 'ERP Integration & Custom Modules for SMBs | Byteet',
        description: 'Byteet connects and extends ERP systems such as Exact Online, AFAS and Odoo: custom modules, links to your webshop, CRM and accounting, and data migration.'
      },
      'automation-devops': {
        title: 'Automation & DevOps Services | CI/CD & Infrastructure as Code | Byteet',
        description: 'Expert automation & DevOps services in the Netherlands. CI/CD pipelines, infrastructure as code (IaC), process automation and efficiency optimization. Transform your IT operations with modern DevOps practices.'
      },
      'cloud-workspace': {
        title: 'Cloud Workspace Solutions | Modern Workplace & Remote Work | Byteet',
        description: 'Professional cloud workspace solutions in the Netherlands. Microsoft 365, Azure, AWS and Google Workspace setup and administration. Modern workplace solutions for remote and hybrid teams.'
      },
      'device-management': {
        title: 'Device Management Services | Intune & MDM Solutions | Byteet',
        description: 'Expert device management (MDM) services in the Netherlands. Microsoft Intune, mobile device management, endpoint security and compliance. Secure and manage all your devices efficiently.'
      },
      'identity-access': {
        title: 'Identity & Access Management | IAM & SSO Solutions | Byteet',
        description: 'Professional identity & access management (IAM) services in the Netherlands. SSO, zero trust, Active Directory, Okta and CyberArk implementation. Secure access management for your organization.'
      },
      'infrastructure-management': {
        title: 'Infrastructure Management | Hybrid Cloud & Server Management | Byteet',
        description: 'Expert infrastructure management services in the Netherlands. Hybrid cloud solutions, server management, virtualization and infrastructure optimization. Reliable infrastructure operations.'
      },
      'database-management': {
        title: 'Database Management Services | SQL & Data Optimization | Byteet',
        description: 'Professional database management services in the Netherlands. SQL optimization, database administration, data integrity, migration and 24/7 database support. Ensure reliable database operations.'
      },
      'service-desk': {
        title: 'Service Desk Implementation | IT Support & Helpdesk | Byteet',
        description: 'Expert service desk implementation in the Netherlands. IT support, helpdesk setup, SLA management, ticket systems and IT support optimization. Streamline your IT support operations.'
      },
      'knowledge-management': {
        title: 'Knowledge Management Solutions | Documentation & Knowledge Base | Byteet',
        description: 'Professional knowledge management services in the Netherlands. Documentation systems, knowledge base implementation, Confluence setup and information management. Improve knowledge sharing.'
      },
      'web-development': {
        title: 'Web Development Services | Full-stack & React/Next.js | Byteet',
        description: 'Expert web development services in the Netherlands. Full-stack development, React, Next.js, custom web applications and modern web solutions. Build powerful web applications for your business.'
      },
      'it-support': {
        title: 'IT Support Services | 24/7 Support | Byteet',
        description: 'Professional IT support services in the Netherlands. 24/7 technical support, helpdesk services and IT troubleshooting. Reliable IT support when you need it.'
      },
      'data-engineering': {
        title: 'Data Engineering Services | Pipelines & ETL Solutions | Byteet',
        description: 'Expert data engineering services in the Netherlands. Data pipelines, ETL processes, big data solutions, data infrastructure and analytics. Transform data into actionable insights.'
      }
    },
    hero: {
      titleLead: 'Websites and web apps',
      titleTail: 'for Dutch SMBs.',
      title: 'Websites and web apps for Dutch SMBs.',
      subtitle: 'We design and build websites, webshops and web applications, and the same team can run the IT behind them: managed support, cloud, cybersecurity, data & AI.',
      cta: {
        title: 'Need a new website or web application, or help with your IT?',
        consultation: 'Plan a free advisory call',
        call: 'Call now'
      }
    },
    home: {
      scroll: 'Scroll',
      statementLabel: 'What we do',
      statement: 'Byteet designs and builds websites, webshops and web applications for Dutch SMBs, from first design to launch and upkeep. Alongside that, we build apps, CRM and ERP, and run the IT behind it all: support, cloud, security, data and AI.',
      servicesLabel: 'Services',
      servicesLead: 'Build it.',
      servicesTail: 'Run it.',
      servicesIntro: 'Nine services from one team, led by web design and development: we build what you need online and keep the systems behind it running.',
      explore: 'Explore',
      allServices: 'All services',
      workLabel: 'Selected work',
      workLead: 'Live',
      workTail: 'and in use',
      workIntro: 'Websites and platforms we designed and built, live today.',
      visit: 'Visit site',
      allCases: 'All cases',
      engagementsLabel: 'IT engagements',
      engagementsTitle: 'Behind the screen',
      engagementsIntro: 'Infrastructure, identity and device projects that do not fit in a screenshot.',
      toolsLabel: 'Tools we work with',
      ctaLabel: 'Contact',
      ctaLead: "Let's talk",
      ctaTail: 'about your project',
      email: 'Email',
      phone: 'Phone'
    },
    work: {
      label: 'Cases',
      lead: 'Work',
      tail: 'that runs',
      intro: 'Client websites and platforms we built, and the IT projects behind the scenes, from device fleets to identity and cloud migrations.',
      sitesLabel: 'Websites & platforms',
      stack: 'Stack',
      delivered: 'Delivered',
      challenge: 'Challenge',
      approach: 'Approach',
      outcome: 'Outcome',
      all: 'All'
    },
    cookieBanner: {
      title: 'Cookies',
      text: 'We use cookies to improve the site and measure traffic. Accept them all, reject everything that is not essential, or choose per category. Details in our',
      policy: 'cookie policy',
      reject: 'Reject all',
      accept: 'Accept all',
      rejectLabel: 'Reject all non-essential cookies',
      acceptLabel: 'Accept all cookies',
      manage: 'Manage preferences'
    },
    stats: {
      clients: 'Clients Served',
      uptime: 'SLA Rate',
      support: 'Support'
    },
    products: {
      title: 'SOME OF OUR SOLUTIONS',
      subtitle: 'IT services for small and mid-sized businesses.',
      viewAll: 'View all services'
    },
    partners: {
      title: 'SOME OF THE TOOLS WE USE',
      subtitle: 'The platforms and tools we work with every day.'
    },
    services: {
      title: 'OUR IT SERVICES',
      subtitle: 'Nine areas of IT, delivered by one partner, so your systems, security and software stay in sync.',
      learnMore: 'Learn more',
      managedItSupport: {
        title: 'Managed IT & Support',
        subtitle: 'Helpdesk, endpoints, service desk & monitoring'
      },
      cloudInfrastructure: {
        title: 'Cloud & Infrastructure',
        subtitle: 'Cloud migration, Microsoft 365 & servers'
      },
      cybersecurityIdentity: {
        title: 'Cybersecurity & Identity',
        subtitle: 'Identity, endpoint security, pentest & NIS2'
      },
      dataDatabases: {
        title: 'Data & Databases',
        subtitle: 'Database management, migration, pipelines & analytics'
      },
      aiAutomation: {
        title: 'AI & Automation',
        subtitle: 'AI agents, workflow automation & document AI'
      },
      webSoftwareDevelopment: {
        title: 'Web Design & Development',
        subtitle: 'Websites, webshops, web apps & custom software'
      },
      mobileAppDevelopment: {
        title: 'Mobile App Development',
        subtitle: 'iOS & Android apps, backend & store publishing'
      },
      crmDevelopment: {
        title: 'CRM Systems',
        subtitle: 'Custom CRM, configuration & integrations'
      },
      erpSystems: {
        title: 'ERP Systems',
        subtitle: 'ERP integrations, custom modules & migration'
      },
      deviceManagement: {
        title: 'Device Management',
        subtitle: 'Windows, macOS, Linux, ChromeOS, iOS, Android',
        description: 'End-to-end device lifecycle management for Windows and macOS, leveraging Microsoft Intune and SCCM for Windows, and Jamf Pro for macOS.',
        features: [
          'Windows: Microsoft Intune',
          'Windows: SCCM/ConfigMgr',
          'macOS: Jamf Pro',
          'Compliance & Policy Enforcement',
          'Software Packaging & Deployment'
        ]
      },
      infrastructureManagement: {
        title: 'Infrastructure Management',
        subtitle: 'Server, device & VM management',
        description: 'Comprehensive infrastructure management including server administration, device management and virtual machine optimization.',
        features: ['Server Administration', 'Device Management', 'VM Optimization', 'Performance Monitoring', 'Backup & Recovery']
      },
      databaseManagement: {
        title: 'Database Management',
        subtitle: 'Setup, migration & administration',
        description: 'Professional database management services including setup, migration, optimization and ongoing administration.',
        features: ['Database Setup', 'Data Migration', 'Performance Optimization', '24/7 Administration', 'Backup & Recovery']
      },
      cloudWorkspace: {
        title: 'Cloud Workspace Solutions',
        subtitle: 'Microsoft 365 & Google Workspace',
        description: 'Complete cloud workspace setup and administration for Microsoft 365 and Google Workspace environments.',
        features: ['M365 Setup', 'Google Workspace Admin', 'User Management', 'Security Configuration', 'Migration Support']
      },
      identityAccess: {
        title: 'Identity & Access Management',
        subtitle: 'Active Directory, Okta & CyberArk',
        description: 'Identity and access management with Active Directory, Okta and CyberArk.',
        features: ['Active Directory', 'Okta Integration', 'CyberArk PAM', 'SSO Implementation', 'Access Control']
      },
      automationDevops: {
        title: 'IT Automation & DevOps',
        subtitle: 'Scripting, CI/CD & process automation',
        description: 'Automate IT processes and implement DevOps practices for improved efficiency.',
        features: ['Process Automation', 'CI/CD Pipelines', 'Scripting Solutions', 'Workflow Optimization', 'Monitoring Tools']
      },
      serviceDesk: {
        title: 'Service Desk Implementation',
        subtitle: 'Service desk setup & configuration',
        description: 'Professional service desk setup and configuration for efficient IT support operations.',
        features: ['Jira Service Desk', 'Jira Service Management', 'ServiceNow Setup', 'YouTrack Setup', 'Zammad Configuration', 'Workflow Design', 'Integration Support']
      },
      knowledgeManagement: {
        title: 'Knowledge Management',
        subtitle: 'Confluence & knowledge base systems',
        description: 'Comprehensive knowledge management solutions for better documentation and information sharing.',
        features: ['Confluence Setup', 'Knowledge Base Design', 'Documentation Standards', 'Search Optimization', 'Content Management']
      },
      webDevelopment: {
        title: 'Web Development',
        subtitle: 'Custom web applications & sites',
        description: 'Professional web development, maintenance and optimization services. Expert web development solutions tailored for businesses.',
        features: ['Custom Web Apps', 'Website Development', 'Maintenance & Updates', 'Performance Optimization', 'Security Implementation']
      },
      itSupport: {
        title: 'IT Support',
        subtitle: 'Helpdesk & technical support',
        description: 'Comprehensive IT helpdesk and technical support services ensuring rapid issue resolution and optimal system performance.',
        features: ['24/7 Technical Support', 'Helpdesk Services', 'Incident Response', 'System Monitoring', 'Troubleshooting & Resolution']
      },
      dataEngineering: {
        title: 'Data Engineering',
        subtitle: 'Data pipelines & analytics infrastructure',
        description: 'Build robust data pipelines, ETL processes and analytics infrastructure that transform raw data into actionable insights for data-driven decision-making.',
        features: ['Data Pipeline Development', 'ETL/ELT Processes', 'Data Warehouse & Lake', 'Real-Time Processing', 'Data Quality & Governance']
      }
    },
    serviceOptions: {
      managedItSupport: 'Managed IT & Support',
      cloudInfrastructure: 'Cloud & Infrastructure',
      cybersecurityIdentity: 'Cybersecurity & Identity',
      dataDatabases: 'Data & Databases',
      aiAutomation: 'AI & Automation',
      webSoftwareDevelopment: 'Web Design & Development',
      mobileAppDevelopment: 'Mobile App Development',
      crmDevelopment: 'CRM Systems',
      erpSystems: 'ERP Systems',
      other: 'Other',
      otherLabel: 'What else do you need?',
      otherPlaceholder: 'Tell us briefly what you need…',
      otherRequired: 'Please describe what you need',
      otherRequiredDesc: 'You selected “Other”. Add a short description so we can help.'
    },
    about: {
      title: 'ABOUT BYTEET - IT SERVICES IN THE NETHERLANDS',
      subtitle: 'We are an IT services company that runs and modernizes IT for small and mid-sized businesses.',
      description: 'With over a decade of experience, our team of certified professionals specializes in web development, device management, cloud administration and automation.',
      yearsExperience: 'Years of Experience',
      yearsExperienceSubtitle: 'Expert engineers staying current with the latest technologies',
      projectsCompleted: 'Projects Completed',
      excellence: {
        title: 'Quality',
        description: 'We document, test and hand over everything we build.'
      },
      partnership: {
        title: 'Partnership',
        description: 'Building long-term relationships through trust and collaboration.'
      },
      efficiency: {
        title: 'Efficiency',
        description: 'We automate repetitive work and keep processes simple.'
      },
      security: {
        title: 'Security',
        description: 'Security measures that fit the size of your business.'
      }
    },
    contact: {
      title: 'GET IN TOUCH - IT SERVICES IN THE NETHERLANDS',
      subtitle: 'Tell us what you need and we\'ll get back to you with a proposal.',
      form: {
        name: 'Full name',
        email: 'Email address',
        company: 'Company name',
        phone: 'Phone number',
        services: 'Services needed',
        budget: 'Budget range',
        timeline: 'Project timeline',
        teamSize: 'Team size',
        message: 'Project details',
        submit: 'Send message',
        submitting: 'Sending…',
        success: 'Message sent successfully!',
        error: 'Please fill in all required fields.'
      },
      budgetRanges: {
        under5k: 'Under €5K',
        '5k-10k': '€5K - €10K',
        '10k-20k': '€10K - €20K',
        '20k-30k': '€20K - €30K',
        '30k+': '€30K+'
      },
      timelines: {
        asap: 'ASAP (within 1 month)',
        '1-3months': '1-3 months',
        '3-6months': '3-6 months',
        '6months+': '6+ months'
      },
      teamSizes: {
        '1-5': '1-5 people',
        '6-20': '6-20 people',
        '21-50': '21-50 people',
        '50+': '50+ people'
      },
      contactInfo: {
        email: 'Email',
        phone: 'Phone',
        location: 'Location'
      }
    },
    footer: {
      description: 'Professional IT services in the Netherlands for modern businesses. We specialize in device management, cloud administration and automation solutions.',
      services: 'SERVICES',
      pages: 'PAGES',
      company: 'COMPANY',
      copyright: 'All rights reserved.',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service'
    },
    forms: {
      alerts: {
        selectService: 'Please select at least one service',
        selectServiceDesc: 'You must select at least one service to continue.',
        selectBudget: 'Please select a budget range',
        selectBudgetDesc: 'You must select a budget range to continue.',
        success: 'You\'ve submitted your request successfully!',
        successDesc: 'We\'ll analyze your requirements and get back to you within 24 hours with a personalized solution and quote.'
      },
      serviceInquiry: {
        title: 'Get a quote',
        subtitle: 'A few short questions. A call is optional.',
        previous: 'Back',
        next: 'Next',
        send: 'Send',
        sending: 'Sending…',
        steps: {
          need: { rail: 'What you need', title: 'What do you need?', desc: 'Pick everything that applies.' },
          project: { rail: 'Your project', title: 'Your project', desc: 'A rough idea is enough. We will ask about the rest.' },
          contact: { rail: 'Contact', title: 'How do we reach you?', desc: 'We reply by email. A phone number is optional.' },
          call: { rail: 'A call', title: 'Want to talk it through?', desc: '{minutes} minutes on Google Meet, free and with no obligation.' }
        },
        projectLabel: 'In a few sentences',
        projectPlaceholder: 'What you want to build, fix or improve, and why.',
        aiHint: 'Not sure how to put it? Let your AI assistant draft it.',
        aiSteps: 'Paste this into your AI assistant, answer its three questions and paste the result in the field above.',
        showPrompt: 'Show prompt',
        hidePrompt: 'Hide prompt',
        copyPrompt: 'Copy prompt',
        copied: 'Copied',
        copySelected: 'Selected. Press Ctrl+C (or Cmd+C) to copy.',
        budget: 'Budget',
        timeline: 'Timeline',
        callYes: 'Yes, book a call',
        callNo: 'No, just send it',
        callUnavailable: 'Online booking isn\'t available right now; we\'ll email you to agree on a time.',
        pickTime: 'Pick a time for the call, or choose “No, just send it”.',
        alreadySent: 'We already have your message.',
        bookingFailed: 'We have your message, but the call could not be booked. Try again, or choose “No, just send it” and we will email you to agree on a time.',
        nameRequired: 'Please enter your name.',
        emailInvalid: 'Please enter a valid email address.',
        servicesLabel: 'Services',
        sendFailed: 'Your request could not be sent. Try again, or email us at {email}.',
        received: 'Received.',
        receivedNext: 'We\'ll read your request and reply to {email}.',
        receivedNextCall: 'We\'ll read your request before the call.',
        aiPrompt: 'I want to contact an IT company about a project. Ask me these three questions one at a time, and wait for each answer:\n1) What do you want to build, fix or improve?\n2) What do you use today, and what isn\'t working?\n3) What would a good result look like for you?\nThen write a clear project description of at most 120 words, in the first person and in plain language, without adding anything I didn\'t say.',
        formLabels: {
          fullName: 'Full name',
          emailAddress: 'Email address',
          company: 'Company',
          phoneNumber: 'Phone number',
          servicesOfInterest: 'Services of interest',
          servicesOfInterestDesc: '(Select all that apply)',
          budgetRange: 'Budget range',
          projectTimeline: 'Project timeline',
          teamSize: 'Team size',
          projectDetails: 'Project details & requirements'
        },
        placeholders: {
          enterFullName: 'Enter your full name',
          enterEmail: 'Enter your email',
          enterCompany: 'Enter your company name',
          enterPhone: 'Enter your phone number',
          selectTimeline: 'Select timeline',
          selectTeamSize: 'Select team size',
          projectDetailsPlaceholder: 'Tell us about your project, specific requirements, challenges and any other details that would help us provide a better quote…'
        }
      }
    },
    contactPage: {
      serviceInquiryForm: 'Personalized Quote',
      serviceInquirySubtitle: 'Get a personalized quote for your IT project',
      contactInformation: 'Contact Information',
      followUs: 'Follow Us',
      quickContact: 'Quick Contact',
      quickContactDesc: 'Need immediate assistance? Reach out to us directly.',
      sendEmail: 'Send email',
      selectTimeline: 'Select timeline',
      selectTeamSize: 'Select team size',
      projectDetailsPlaceholder: 'Tell us about your project, specific requirements, challenges and any other details that would help us provide a better quote…',
      privacyConsent: 'By submitting this form, you agree to our privacy policy and consent to being contacted regarding your inquiry.',
      servicesSelectAll: '(Select all that apply)'
    },
    booking: {
      label: 'Book a call',
      lead: 'Book',
      tail: 'a call',
      intro: '{minutes} minutes on Google Meet about your IT or the software you need. Pick a time below and the invite comes straight from our calendar.',
      expectLabel: 'What to expect',
      lengthTerm: 'Length',
      lengthValue: '{minutes} minutes',
      whereTerm: 'Where',
      whereValue: 'Google Meet. The link is in the calendar invite.',
      costTerm: 'Cost',
      costValue: 'Free, with no obligation.',
      aboutTerm: 'What we discuss',
      aboutValue: 'Your current setup, what you want to change and whether we are the right team for it.',
      languageTerm: 'Language',
      languageValue: 'English or Dutch.',
      preferContact: 'Prefer email or phone?',
      schedulerLabel: 'Scheduler',
      pickDay: 'Pick a day',
      pickTime: 'Pick a time',
      timezoneNote: 'Times shown in Amsterdam time',
      timezoneShort: 'Amsterdam time',
      loading: 'Loading open times…',
      dayFull: 'No times',
      noSlotsDay: 'No open times on this day. Try another day.',
      noSlotsAll: 'There are no open times in the coming weeks.',
      yourDetails: 'Your details',
      selected: 'Selected time',
      changeTime: 'Change time',
      name: 'Name',
      email: 'Email',
      company: 'Company',
      topic: 'What would you like to discuss?',
      optional: 'optional',
      honeypot: 'Leave this field empty',
      confirm: 'Confirm booking',
      submitting: 'Booking…',
      privacyBefore: 'Your details go into the calendar invite for this call. See our ',
      privacyLink: 'privacy policy',
      privacyAfter: '.',
      errors: {
        load: 'The calendar could not be loaded.',
        retry: 'Try again',
        taken: 'That time was just taken. Pick another one.',
        invalid: 'Please check your name and email address, and leave links out of the company and topic fields.',
        unavailable: 'Online booking is not available right now.',
        rateLimited: 'Too many attempts from this connection.',
        generic: 'The booking did not go through.',
        fallbackBefore: 'Email us at ',
        fallbackAfter: ' and we will find a time.'
      },
      success: {
        label: 'Confirmed',
        title: 'Booked.',
        when: 'When',
        meet: 'Google Meet',
        meetPending: 'The Meet link is in the invite.',
        invite: 'A calendar invite has been sent to {email}, with the Meet link in it.',
        back: 'Back to home'
      }
    },
    floatingHelp: {
      needHelp: 'Need help?',
      weAreHere: 'We\'re here to assist you!',
      getServiceQuote: 'Get a quote',
      backToTop: 'Back to top',
      close: 'Close',
      tooltip: 'Need help? Click here!'
    },
    portfolio: {
      title: 'Client Cases & Success Stories',
      subtitle: 'Real results for Dutch SMBs. See how we delivered measurable impact across managed IT, cloud, cybersecurity, data and custom software.',
      viewAll: 'View all projects',
      technologiesUsed: 'Technologies Used:',
      keyResults: 'Key Results:',
      viewProject: 'View details',
      openWebsite: 'Open website',
      viewDetails: 'View details',
      recentWork: 'RECENT WORK',
      recentWorkSubtitle: 'A showcase of our latest projects and successful implementations across various industries and technologies.',
      categories: {
        infrastructure: 'Infrastructure',
        deviceManagement: 'Device Management',
        security: 'Security',
        automation: 'Automation',
        cloudInfrastructure: 'Cloud Infrastructure',
        devopsAutomation: 'DevOps Automation',
        securityIAM: 'Security & IAM',
        itOperations: 'IT Operations',
        documentation: 'Documentation',
        webDevelopment: 'Web Development',
        serviceDesk: 'Service Desk'
      },
      projects: {
        mundusCrasWebsite: {
          title: 'Mundus Cras - Senior Management Advisory',
          description: 'Bilingual website and content platform for Mundus Cras, a senior management advisory practice working across the Netherlands and the United Arab Emirates. Thirteen pages in English and Dutch, a headless CMS with an admin panel for the firm\'s articles, a structured inquiry intake and a consent system for analytics.',
          results: ['Thirteen pages in English and Dutch', 'Headless CMS with an admin panel', 'Structured inquiry intake', 'Consent management for analytics']
        },
        deHorecaBrigadeWebsite: {
          title: 'De Horeca Brigade - Legal Services for Hospitality',
          description: 'Brand identity and bilingual website for De Horeca Brigade, a Dutch firm that handles legal and regulatory matters for hospitality entrepreneurs, from permits to compliance. The team manages knowledge-base articles, prices and quote requests through a custom admin, and visitors can book a call directly on the site.',
          results: ['Brand identity and style guide', 'Bilingual site (NL/EN) with localized URLs', 'Interactive guide that routes visitors to the right service', 'Custom admin for articles, prices and quote requests']
        },
        ironLadyWebsite: {
          title: 'The Iron Lady - Steakhouse Website, Rotterdam',
          description: 'Bilingual website for The Iron Lady, a steakhouse and cocktail bar in Rotterdam city center. The full food and drinks menu is structured content the owners edit themselves, with online table reservations built in.',
          results: ['Bilingual site (NL/EN)', 'Owner admin for menu, photos and content', 'Full food and drinks menu', 'Online reservations']
        },
        fatFoxWebsite: {
          title: 'The Fat Fox - Pub & Steakhouse Website, Rotterdam',
          description: 'Bilingual website for The Fat Fox, an English pub and charcoal-grill steakhouse in Rotterdam\'s Witte de With area. The owners manage the menu, including more than 150 drinks, from their own admin, and guests book a table online.',
          results: ['Bilingual site (NL/EN)', 'Owner admin for menu and content', 'Food and drinks menu with 150+ drinks', 'Online reservations']
        },
        morenaWebsite: {
          title: 'Morena - Latin Restaurant & Cocktail Bar, Rotterdam',
          description: 'Complete rebuild of the website for Morena, a pan-Latin American restaurant and cocktail bar in Rotterdam\'s MaHo district. The owners edit the menu and pick the dishes highlighted on the homepage themselves.',
          results: ['Full rebuild of morenarotterdam.nl', 'Bilingual site (NL/EN)', 'Owner admin for menu and featured dishes', 'Online reservations']
        },
        nouraWebsite: {
          title: 'Noura - Levantine Restaurant, Rotterdam',
          description: 'Bilingual website for Noura, a Levantine restaurant in Rotterdam, designed around the restaurant\'s brand identity. The owners manage opening hours, the menu and page content from a console on its own admin subdomain.',
          results: ['Bilingual site (NL/EN)', 'Design built on the Noura brand identity', 'Admin console for hours, menu and pages', 'Menu with Arabic dish names and diet labels']
        },
        sportaMdWebsite: {
          title: 'Sporta MD - Sports Booking Platform Website',
          description: 'Website for Sporta MD, a mobile app for booking friendly football, basketball, volleyball, tennis and padel matches in Chișinău. The trilingual site (RO/RU/EN) carries sport pages, a stadium directory with maps, the legal documents and the public API documentation, plus the deep links and email confirmation that hand users over to the app.',
          results: ['Trilingual site (RO/RU/EN)', 'Stadium directory with Google Maps', 'API documentation at docs.sporta.md', 'App deep links and store redirects']
        },
        jamfDeviceManagement: {
          title: 'Enterprise Device Management',
          description: 'Successfully enrolled and configured 150+ devices through the Jamf Pro MDM solution, establishing comprehensive device management and security policies for enterprise-level deployment.',
          problem: {
            title: 'The Challenge',
            description: 'The organization struggled with managing a growing fleet of macOS devices across multiple locations:',
            challenges: [
              'Manual device configuration causing inconsistencies',
              'No centralized way to enforce security policies',
              'Time-consuming device enrollment and setup processes',
              'Difficulty tracking and managing device inventory',
              'Lack of automated software deployment capabilities'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Implemented Jamf Pro MDM to centralize device management and automate deployment processes.',
            process: [
              { step: 'Assessment', icon: 'clipboard', description: 'Evaluated device inventory and requirements' },
              { step: 'Jamf Setup', icon: 'server', description: 'Configured Jamf Pro server and policies' },
              { step: 'Enrollment', icon: 'users', description: 'Automated enrollment of 150+ devices' },
              { step: 'Policy Deployment', icon: 'shield', description: 'Applied security and management policies' }
            ]
          },
          results: ['150+ devices enrolled', 'Centralized management', 'Security policies applied', 'Enterprise-grade solution']
        },
        activeDirectoryManagement: {
          title: 'Active Directory Infrastructure',
          description: 'Implemented comprehensive Active Directory management including group policy configuration, user lifecycle management, automated onboarding processes and custom PowerShell automation scripts.',
          problem: {
            title: 'The Challenge',
            description: 'The organization faced inefficiencies in user and device management:',
            challenges: [
              'Manual user provisioning taking hours per employee',
              'Inconsistent security policies across departments',
              'No automated way to manage user lifecycle',
              'Time-consuming group policy configuration',
              'Lack of centralized identity management'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Designed and implemented a comprehensive Active Directory infrastructure with automation.',
            process: [
              { step: 'Architecture Design', icon: 'layout', description: 'Designed AD structure and OU hierarchy' },
              { step: 'Group Policy Setup', icon: 'settings', description: 'Configured security and management policies' },
              { step: 'Automation Scripts', icon: 'terminal', description: 'Developed PowerShell automation workflows' },
              { step: 'User Lifecycle', icon: 'refresh-cw', description: 'Automated onboarding/offboarding processes' }
            ]
          },
          results: ['Group policy implementation', 'Automated user onboarding', 'PowerShell automation', 'Infrastructure optimization']
        },
        googleWorkspaceSetup: {
          title: 'Google Workspace Setup & Management',
          description: 'Comprehensive Google Workspace implementation for 150+ employees including organizational units, security policies, Google Groups configuration and user lifecycle management with automated provisioning.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed to migrate to Google Workspace but faced several obstacles:',
            challenges: [
              'Complex migration from legacy email systems',
              'Need for organizational structure alignment',
              'Security and compliance requirements',
              'User training and adoption concerns',
              'Integration with existing systems'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Delivered a complete Google Workspace implementation with automated provisioning and security.',
            process: [
              { step: 'Planning', icon: 'map', description: 'Designed OU structure and migration plan' },
              { step: 'Configuration', icon: 'cog', description: 'Set up security policies and groups' },
              { step: 'Migration', icon: 'arrow-right', description: 'Migrated 150+ users' },
              { step: 'Automation', icon: 'zap', description: 'Implemented automated provisioning workflows' }
            ]
          },
          results: ['150+ employees configured', 'OU structure designed', 'Security policies applied', 'Google Groups implementation', 'Automated provisioning']
        },
        jiraServiceManagement: {
          title: 'Jira Service Management Implementation',
          description: 'Implemented a comprehensive helpdesk service using Atlassian JSM with advanced automation workflows, custom ticket routing, SLA management and integrated reporting dashboards for streamlined IT support operations.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed a unified service desk solution but faced operational challenges:',
            challenges: [
              'Fragmented support channels causing ticket loss and delays',
              'No standardized process for handling IT requests',
              'Difficulty tracking SLA compliance and performance metrics',
              'Lack of self-service options increasing support workload',
              'Manual ticket routing leading to inefficiencies'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Implemented Jira Service Management with automation, a self-service portal and comprehensive reporting.',
            process: [
              { step: 'Requirements Analysis', icon: 'clipboard', description: 'Analyzed support workflows and requirements' },
              { step: 'JSM Configuration', icon: 'settings', description: 'Set up multi-region JSM instance and workflows' },
              { step: 'Automation Setup', icon: 'zap', description: 'Configured automated routing and workflows' },
              { step: 'Portal & Training', icon: 'users', description: 'Launched self-service portal and trained agents' }
            ]
          },
          results: ['10 IT support agents', 'Multi-region configuration', 'Self-service portal', 'Automated workflows', 'SLA management','Reporting dashboards']
        },
        zammadServiceDesk: {
          title: 'Zammad Service Desk with LDAP Integration',
          description: 'Created a robust service desk solution using Zammad with LDAP integration, automated user provisioning, role-based access control and custom workflow automation for enhanced support efficiency.',
          problem: {
            title: 'The Challenge',
            description: 'The organization required an open-source service desk with directory integration:',
            challenges: [
              'Need for a cost-effective service desk solution',
              'Requirement for LDAP/Active Directory integration',
              'Manual user management consuming IT resources',
              'Lack of role-based access controls',
              'No automated workflow capabilities'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Deployed Zammad with LDAP integration and automated user provisioning workflows.',
            process: [
              { step: 'Zammad Deployment', icon: 'server', description: 'Installed and configured Zammad platform' },
              { step: 'LDAP Integration', icon: 'link', description: 'Connected to Active Directory via LDAP' },
              { step: 'RBAC Setup', icon: 'shield', description: 'Configured role-based access controls' },
              { step: 'Automation', icon: 'zap', description: 'Implemented automated user provisioning' }
            ]
          },
          results: ['LDAP integration', 'Automated user provisioning', 'Role-based access control', 'Custom workflow automation', 'Enhanced support efficiency']
        },
        gravlDocumentation: {
          title: 'Gravl Documentation Website',
          description: 'Developed a modern, responsive documentation website using Gravl CMS with advanced search capabilities, version control, multi-language support and intuitive navigation for comprehensive technical documentation.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed a modern documentation platform but faced documentation challenges:',
            challenges: [
              'Scattered documentation across multiple locations',
              'Outdated content management system',
              'Poor search functionality making information hard to find',
              'No version control for documentation changes',
              'Limited multi-language support'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Built a modern documentation website using Gravl CMS with advanced features.',
            process: [
              { step: 'Content Audit', icon: 'search', description: 'Analyzed existing documentation structure' },
              { step: 'Gravl Setup', icon: 'code', description: 'Configured Gravl CMS platform' },
              { step: 'Migration', icon: 'arrow-right', description: 'Migrated content with version control' },
              { step: 'Enhancement', icon: 'rocket', description: 'Added search and multi-language support' }
            ]
          },
          results: ['Modern documentation platform', 'Advanced search capabilities', 'Version control', 'Multi-language support', 'Intuitive navigation']
        },
        activeDirectoryEnrollment: {
          title: 'Enterprise Device Enrollment via Active Directory',
          description: 'Successfully enrolled and configured 80+ company devices through Active Directory domain joining, implementing comprehensive group policies, security configurations and centralized management for enhanced IT governance.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed to enroll devices into Active Directory but faced enrollment challenges:',
            challenges: [
              'Manual device enrollment process taking too long',
              'Inconsistent security configurations across devices',
              'No centralized way to manage device policies',
              'Difficulty enforcing compliance standards',
              'Lack of automated device provisioning'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Automated device enrollment through Active Directory with comprehensive policy management.',
            process: [
              { step: 'AD Preparation', icon: 'server', description: 'Prepared Active Directory for device enrollment' },
              { step: 'Policy Design', icon: 'settings', description: 'Designed group policies and security configs' },
              { step: 'Enrollment', icon: 'users', description: 'Enrolled 80+ devices into the domain' },
              { step: 'Governance', icon: 'shield', description: 'Applied centralized management policies' }
            ]
          },
          results: ['80+ devices enrolled', 'Comprehensive group policies', 'Security configurations applied', 'Centralized management', 'Enhanced IT governance']
        },
        windowsInstallationAutomation: {
          title: 'Automated Windows Installation Process',
          description: 'Engineered an automated Windows installation system using bootable USB drives with custom deployment scripts, driver integration, software pre-installation and unattended setup for rapid device provisioning.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed to streamline Windows installations but faced deployment challenges:',
            challenges: [
              'Manual Windows installation taking hours per device',
              'Inconsistent software installations across devices',
              'Time-consuming driver installation and configuration',
              'No standardized deployment process',
              'Difficulty managing software pre-installation'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Created an automated Windows installation system with custom deployment scripts.',
            process: [
              { step: 'Script Development', icon: 'terminal', description: 'Developed custom deployment scripts' },
              { step: 'USB Creation', icon: 'server', description: 'Created a bootable USB drive with drivers and software' },
              { step: 'Testing', icon: 'settings', description: 'Tested unattended installation process' },
              { step: 'Deployment', icon: 'rocket', description: 'Deployed rapid device provisioning system' }
            ]
          },
          results: ['Automated installation', 'Custom deployment scripts', 'Driver integration', 'Software pre-installation', 'Rapid device provisioning']
        },
        googleWorkspaceManagement: {
          title: 'Google Workspace Setup and Management',
          description: 'Comprehensive Google Workspace implementation including user provisioning, security policy configuration, data migration, application integration and ongoing administration for optimal productivity and collaboration.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed comprehensive Google Workspace management but faced operational challenges:',
            challenges: [
              'Complex user provisioning and lifecycle management',
              'Need for security policy configuration and compliance',
              'Data migration from legacy systems',
              'Application integration requirements',
              'Ongoing administration and optimization needs'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Delivered a complete Google Workspace implementation with automated provisioning and ongoing management.',
            process: [
              { step: 'Planning', icon: 'map', description: 'Designed implementation and migration strategy' },
              { step: 'Configuration', icon: 'cog', description: 'Configured security policies and integrations' },
              { step: 'Migration', icon: 'arrow-right', description: 'Migrated data and users' },
              { step: 'Management', icon: 'refresh-cw', description: 'Established ongoing administration processes' }
            ]
          },
          results: ['User provisioning', 'Security policies configured', 'Data migration completed', 'Application integration', 'Ongoing administration']
        },
        wordpressPlatform: {
          title: 'WordPress Platform',
          description: 'High-performance WordPress multi-site network implementation.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed a scalable WordPress platform but faced infrastructure challenges:',
            challenges: [
              'Need for multi-site network capability',
              'Performance and scalability requirements',
              'Centralized management of multiple sites',
              'Resource optimization and cost efficiency',
              'Security and maintenance concerns'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Implemented a high-performance WordPress multi-site network with optimized infrastructure.',
            process: [
              { step: 'Architecture Design', icon: 'layout', description: 'Designed multi-site network architecture' },
              { step: 'Infrastructure Setup', icon: 'server', description: 'Configured high-performance hosting' },
              { step: 'Optimization', icon: 'zap', description: 'Optimized performance and resources' },
              { step: 'Deployment', icon: 'rocket', description: 'Deployed multi-site network platform' }
            ]
          },
          results: ['Multi-site network', 'High performance', 'Scalable infrastructure', 'Centralized management', 'Optimized resources']
        },
        caseCloudWorkspace: {
        title: 'Cloud Workspace Solutions',
          description: 'Modernized collaboration by migrating to Microsoft 365 with secure file sharing, Teams for communication and granular access controls. Implemented MFA and DLP policies for data safety and standardized onboarding templates for new users.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed to modernize collaboration but faced workspace challenges:',
            challenges: [
              'Legacy email and file sharing systems limiting collaboration',
              'Security concerns with data sharing and access controls',
              'Lack of a unified communication platform',
              'Inconsistent file structures and permissions',
              'No standardized onboarding process for new users'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Migrated to Microsoft 365 with comprehensive security and collaboration features.',
            process: [
              { step: 'Migration Planning', icon: 'map', description: 'Designed zero-downtime migration strategy' },
              { step: 'M365 Setup', icon: 'server', description: 'Configured M365 with Teams and SharePoint' },
              { step: 'Security Implementation', icon: 'shield', description: 'Implemented MFA and DLP policies' },
              { step: 'Standardization', icon: 'settings', description: 'Created standardized templates and processes' }
            ]
          },
          results: ['M365 migration with zero downtime', '2FA/MFA enforced for all users', 'Standardized file structure and permissions', 'Reduced email attachments by 80%']
        },
        caseDatabaseManagement: {
          title: 'Database Management Modernization',
          description: 'Consolidated fragmented operational data into a managed Oracle instance with scheduled backups, monitoring and role-based access. Built lightweight dashboards for near real-time reporting.',
          problem: {
            title: 'The Challenge',
            description: 'The organization struggled with database management and data fragmentation:',
            challenges: [
              'Fragmented data across multiple systems and locations',
              'Slow query performance affecting operations',
              'No automated backup and recovery processes',
              'Lack of role-based access controls',
              'Difficulty generating real-time reports and dashboards'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Consolidated data into a managed Oracle instance with automation and monitoring.',
            process: [
              { step: 'Data Assessment', icon: 'clipboard', description: 'Analyzed fragmented data sources' },
              { step: 'Oracle Setup', icon: 'server', description: 'Deployed managed Oracle instance' },
              { step: 'Migration & Optimization', icon: 'arrow-right', description: 'Migrated and optimized data' },
              { step: 'Monitoring & Dashboards', icon: 'settings', description: 'Set up monitoring and reporting dashboards' }
            ]
          },
          results: ['Oracle in the cloud with automated backups', 'RBAC for managers/ops', 'Query time reduced from minutes to seconds', 'Operational dashboards for KPIs']
        },
        caseDeviceManagement: {
          title: 'Centralized Device Management',
          description: 'Rolled out Microsoft Intune with baseline security policies, device encryption and application catalogs. Implemented automated enrollment to speed up provisioning and remote wipe for lost devices.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed centralized device management but faced device challenges:',
            challenges: [
              'No centralized way to manage company devices',
              'Inconsistent security policies across devices',
              'Time-consuming device provisioning process',
              'Lack of device encryption and security controls',
              'Difficulty managing approved software and applications'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Implemented Microsoft Intune for centralized device management and security.',
            process: [
              { step: 'Intune Planning', icon: 'map', description: 'Designed Intune deployment strategy' },
              { step: 'Policy Configuration', icon: 'settings', description: 'Configured security policies and encryption' },
              { step: 'Enrollment Automation', icon: 'zap', description: 'Set up automated device enrollment' },
              { step: 'App Catalog Setup', icon: 'server', description: 'Created approved software catalog' }
            ]
          },
          results: ['Company-wide Intune enrollment', 'Full-disk encryption enforced', 'App catalog with approved software', 'Onboarding time reduced by 60%']
        },
        caseWindowsAutomatedDeployment: {
          title: 'Automated Windows Device Deployment',
          description: 'Created a bootable USB drive solution that automatically installs Windows, joins devices to the Active Directory domain and installs necessary tools and drivers for an accounting company managing 30+ devices.',
          problem: {
            title: 'The Challenge',
            description: 'An accounting company needed the easiest and cheapest way to manage 30+ Windows devices that came without Windows installed:',
            challenges: [
              'Devices arrived without a Windows operating system installed',
              'Manual installation process would be time-consuming for 30+ devices',
              'Need to join devices to the Active Directory domain automatically',
              'Required installation of necessary tools and drivers on each device',
              'Cost-effective solution needed for a small accounting company'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Developed a bootable USB drive that automates the entire Windows installation and configuration process.',
            process: [
              { step: 'USB Drive Creation', icon: 'server', description: 'Created a bootable USB drive with Windows installation media' },
              { step: 'Automation Scripting', icon: 'code', description: 'Developed scripts for automatic Windows installation' },
              { step: 'Domain Integration', icon: 'link', description: 'Configured automatic Active Directory domain joining' },
              { step: 'Driver & Tools Setup', icon: 'settings', description: 'Automated installation of drivers and necessary tools' }
            ]
          },
          results: ['Automated Windows installation for 30+ devices', 'Automatic Active Directory domain joining', 'Pre-configured drivers and tools', 'Significant time and cost savings']
        },
        caseIdentityAccess: {
          title: 'Identity & Access Consolidation',
          description: 'Implemented SSO and MFA through Okta with directory sync to Azure AD. Standardized access requests using groups and lifecycle policies across core SaaS applications.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed to consolidate identity and access management:',
            challenges: [
              'Multiple authentication systems causing user frustration',
              'No single sign-on across business applications',
              'Inconsistent access management processes',
              'Manual user lifecycle management',
              'Difficulty maintaining audit compliance'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Implemented Okta with SSO, MFA and automated lifecycle management.',
            process: [
              { step: 'Okta Planning', icon: 'map', description: 'Designed identity consolidation strategy' },
              { step: 'Directory Integration', icon: 'link', description: 'Integrated Okta with Azure AD' },
              { step: 'SSO & MFA Setup', icon: 'shield', description: 'Configured SSO and MFA policies' },
              { step: 'Lifecycle Automation', icon: 'zap', description: 'Automated user lifecycle workflows' }
            ]
          },
          results: ['SSO for 12+ business apps', 'MFA by role and risk', 'Automated joiner/mover/leaver flows', 'Audit-ready access reviews']
        },
        caseInfrastructure: {
          title: 'Infrastructure Cloud Migration',
          description: 'Moved file services and selected workloads to AWS using EC2 and S3. Defined the infrastructure with Terraform for reproducibility and set up CloudWatch alarms for proactive monitoring.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed to migrate infrastructure to the cloud but faced challenges:',
            challenges: [
              'High infrastructure costs with on-premises systems',
              'Lack of infrastructure as code for reproducibility',
              'No automated monitoring and alerting',
              'Difficulty scaling resources as needed',
              'Complex disaster recovery and backup processes'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Migrated infrastructure to AWS with Terraform IaC and comprehensive monitoring.',
            process: [
              { step: 'Migration Planning', icon: 'map', description: 'Designed cloud migration strategy' },
              { step: 'Terraform Setup', icon: 'code', description: 'Created infrastructure as code with Terraform' },
              { step: 'AWS Migration', icon: 'arrow-right', description: 'Migrated workloads to EC2 and S3' },
              { step: 'Monitoring Setup', icon: 'settings', description: 'Configured CloudWatch alarms and monitoring' }
            ]
          },
          results: ['50% lower infra costs', 'Terraform IaC baselines', 'S3 lifecycle policies for cost control', 'Improved reliability and recovery RTO/RPO']
        },
        caseDevOpsAutomation: {
          title: 'CI/CD and Automation',
          description: 'Built a GitLab CI pipeline with Docker-based builds, test automation and environment promotions. Added chat notifications and release tags for traceability.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed to automate development and deployment processes:',
            challenges: [
              'Manual deployment processes causing delays and errors',
              'No automated testing in the development workflow',
              'Time-consuming build and deployment cycles',
              'Lack of rollback capabilities during deployments',
              'No visibility into deployment status and notifications'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Implemented a GitLab CI/CD pipeline with Docker, automated testing and notifications.',
            process: [
              { step: 'Pipeline Design', icon: 'layout', description: 'Designed CI/CD pipeline architecture' },
              { step: 'GitLab CI Setup', icon: 'code', description: 'Configured GitLab CI with Docker builds' },
              { step: 'Test Automation', icon: 'zap', description: 'Integrated automated testing per PR' },
              { step: 'Deployment & Monitoring', icon: 'rocket', description: 'Set up deployment automation and notifications' }
            ]
          },
          results: ['Deployment time cut to 10 minutes', 'Automated tests per PR', 'Rollback-ready releases', 'Fewer downtime incidents during deploys']
        },
        caseKnowledgeManagement: {
          title: 'Knowledge Management Platform',
          description: 'Launched a knowledge base using Confluence with page templates, approval workflows and structured tagging. Integrated SSO and trained teams to keep content current.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed a centralized knowledge management system but faced information challenges:',
            challenges: [
              'Knowledge scattered across multiple locations and formats',
              'No standardized templates for documentation',
              'Lack of approval workflows for content quality',
              'Difficulty finding information due to poor organization',
              'No structured tagging or categorization system'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Implemented a Confluence knowledge base with templates, workflows and structured organization.',
            process: [
              { step: 'Confluence Setup', icon: 'server', description: 'Configured Confluence platform with SSO' },
              { step: 'Template Creation', icon: 'layout', description: 'Created standardized page templates' },
              { step: 'Workflow Design', icon: 'settings', description: 'Set up approval workflows and tagging' },
              { step: 'Training & Launch', icon: 'users', description: 'Trained teams and launched knowledge base' }
            ]
          },
          results: ['Centralized policies and SOPs', 'Template-driven content', 'Searchable tagging and labels', 'Onboarding time decreased significantly']
        },
        caseServiceDesk: {
        title: 'Service Desk Implementation',
          description: 'Introduced a unified helpdesk with ticket categories, SLAs, self-service knowledge and automation rules for routing. Added CSAT surveys to measure user satisfaction.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed a unified service desk but faced support challenges:',
            challenges: [
              'Multiple support channels causing confusion and delays',
              'No standardized SLA tracking and management',
              'Lack of self-service options increasing ticket volume',
              'Manual ticket routing leading to inefficiencies',
              'No way to measure and improve user satisfaction'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Implemented a unified service desk with automation, self-service and satisfaction tracking.',
            process: [
              { step: 'Service Desk Setup', icon: 'server', description: 'Configured unified helpdesk platform' },
              { step: 'SLA Configuration', icon: 'settings', description: 'Set up SLA tracking and categories' },
              { step: 'Automation & Self-Service', icon: 'zap', description: 'Implemented routing automation and knowledge base' },
              { step: 'CSAT Integration', icon: 'users', description: 'Added satisfaction surveys and tracking' }
            ]
          },
          results: ['SLA adherence improved', 'Self-service deflected common tickets', 'Automated routing reduced backlog', 'CSAT tracked and improved quarter over quarter']
        }
      }
    },
    homepageFeaturedWork: {
      title: 'FEATURED SOLUTIONS',
      subtitle: 'A selection of recent IT projects.',
      technologiesUsed: 'Technologies Used:',
      keyResults: 'Key Results:',
      learnMore: 'Learn more',
      viewAllProjects: 'View all projects',
      categories: {
        cloudSolutions: 'Cloud Solutions',
        securityIAM: 'Security & IAM',
        infrastructure: 'Infrastructure'
      },
      projects: {
        microsoft365Migration: {
          title: 'Microsoft 365 Enterprise Migration',
          description: 'Led a comprehensive Microsoft 365 migration for a 200+ employee organization, including email migration, SharePoint setup, Teams deployment and security configuration, resulting in improved collaboration and productivity.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed to migrate to Microsoft 365 but faced migration challenges:',
            challenges: [
              'Legacy email systems limiting collaboration capabilities',
              'Need for zero-downtime migration for 200+ users',
              'Complex data migration from multiple sources',
              'Security and compliance requirements',
              'User training and adoption concerns'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Executed a comprehensive M365 migration with zero downtime and enhanced security.',
            process: [
              { step: 'Migration Planning', icon: 'map', description: 'Designed zero-downtime migration strategy' },
              { step: 'Email Migration', icon: 'arrow-right', description: 'Migrated 200+ users' },
              { step: 'Platform Setup', icon: 'server', description: 'Configured SharePoint, Teams and security' },
              { step: 'Training & Support', icon: 'users', description: 'Provided training and ongoing support' }
            ]
          },
          results: ['200+ users migrated', 'Zero-downtime migration', 'Enhanced security policies', 'Improved collaboration tools']
        },
        oktaImplementation: {
          title: 'Okta Identity Management Implementation',
          description: 'Implemented Okta as the primary identity provider for a multi-tenant organization, enabling single sign-on across 15+ applications and enhancing security posture with multi-factor authentication.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed unified identity management but faced authentication challenges:',
            challenges: [
              'Multiple authentication systems causing user frustration',
              'No single sign-on across 15+ business applications',
              'Security concerns with password-based authentication',
              'Complex multi-tenant identity requirements',
              'Difficulty managing user access across applications'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Implemented Okta as the primary identity provider with SSO and MFA across all applications.',
            process: [
              { step: 'Okta Planning', icon: 'map', description: 'Designed identity management strategy' },
              { step: 'Application Integration', icon: 'link', description: 'Integrated 15+ applications with SSO' },
              { step: 'MFA Configuration', icon: 'shield', description: 'Configured multi-factor authentication' },
              { step: 'Multi-Tenant Setup', icon: 'users', description: 'Set up multi-tenant architecture' }
            ]
          },
          results: ['15+ applications integrated', 'SSO implementation', 'MFA enforcement', 'Security compliance']
        },
        serverInfrastructure: {
          title: 'Enterprise Server Infrastructure Setup',
          description: 'Designed and implemented a complete enterprise server infrastructure including Windows Server deployment, VMware virtualization, Active Directory configuration, automated backup solutions and comprehensive monitoring systems for a growing organization.',
          problem: {
            title: 'The Challenge',
            description: 'The organization needed enterprise server infrastructure but faced infrastructure challenges:',
            challenges: [
              'No centralized server infrastructure for a growing organization',
              'Lack of virtualization capabilities limiting efficiency',
              'No Active Directory for identity management',
              'Manual backup processes risking data loss',
              'No monitoring system for infrastructure health'
            ]
          },
          solution: {
            title: 'Our Solution',
            description: 'Designed and implemented a complete enterprise infrastructure with virtualization and automation.',
            process: [
              { step: 'Infrastructure Design', icon: 'layout', description: 'Designed server architecture and topology' },
              { step: 'VMware Deployment', icon: 'server', description: 'Deployed VMware virtualization platform' },
              { step: 'AD & Services Setup', icon: 'settings', description: 'Configured Active Directory and services' },
              { step: 'Automation & Monitoring', icon: 'zap', description: 'Implemented backups and 24/7 monitoring' }
            ]
          },
          results: ['Complete server infrastructure', 'VMware virtualization', 'Active Directory setup', 'Automated backup solutions', '24/7 monitoring system']
        }
      }
    },
    solutions: {
      title: 'OUR SOLUTIONS',
      subtitle: 'IT for Dutch SMBs, from managed support and cloud to security, data, AI and custom software.',
      exploreAllSolutions: 'Explore all solutions',
      exploreSolution: 'Explore solution',
      technologies: 'Technologies',
      keyBenefits: 'Key Benefits',
      managedItSupport: {
        title: 'Who runs and manages our IT?',
        subtitle: 'Managed IT support, helpdesk & endpoints',
        description: 'Helpdesk, endpoint management, service desk and monitoring as one managed operation, with a maintained knowledge base behind every fix.'
      },
      cloudInfrastructure: {
        title: 'How do we move to the cloud safely?',
        subtitle: 'Cloud migration, Microsoft 365 & servers',
        description: 'Microsoft 365 and Azure migration, server and virtualization management, and cloud administration with monitoring and cost control.'
      },
      cybersecurityIdentity: {
        title: 'How do I protect my business from cyberattacks?',
        subtitle: 'Cybersecurity, NIS2, pentest & identity',
        description: 'Identity and access management, endpoint protection, pentesting and NIS2/ISO 27001 compliance that keep accounts and devices secure.'
      },
      dataDatabases: {
        title: 'How do I get value from my business data?',
        subtitle: 'Database management, migration & Power BI',
        description: 'Database administration, migration and tuning alongside pipelines, data platforms and Power BI dashboards that turn data into decisions.'
      },
      aiAutomation: {
        title: 'Which processes can I automate with AI?',
        subtitle: 'AI automation, agents & document AI',
        description: 'Workflow automation, AI agents and chatbots on your own data, and automated document processing, all built GDPR- and EU AI Act-compliant.'
      },
      webSoftwareDevelopment: {
        title: 'Is our website still doing its job?',
        subtitle: 'Websites, webshops & web apps, designed and built',
        description: 'Websites, webshops and web applications with UX design, performance and security built in, plus custom software. You own the source code: no vendor lock-in.'
      },
      mobileAppDevelopment: {
        title: 'Do we need our own app?',
        subtitle: 'iOS & Android apps, backend & store release',
        description: 'Native-feeling iOS and Android apps built with React Native, Flutter or native code, with the backend, store publishing and maintenance covered.'
      },
      crmDevelopment: {
        title: 'How do we keep track of customers and deals?',
        subtitle: 'Custom CRM, CRM setup & integrations',
        description: 'A custom CRM or a configured HubSpot, Salesforce or Dynamics 365, linked to email, invoicing and your website, with spreadsheet data migrated.'
      },
      erpSystems: {
        title: 'How do we connect our ERP to everything else?',
        subtitle: 'ERP integrations, custom modules & migration',
        description: 'Integrations between Exact Online, AFAS, Business Central or Odoo and your webshop, CRM and accounting, plus custom modules and data migration.'
      },
      infrastructureManagement: {
        title: 'Infrastructure Management',
        subtitle: 'Server, device & VM management',
        description: 'Complete endpoint, server and VM management with 24/7 monitoring and support.',
        benefits: ['24/7 Monitoring', 'Automated Updates', 'Performance Optimization', 'Backup & Recovery']
      },
      cloudSolutions: {
        title: 'Cloud Solutions',
        subtitle: 'Microsoft 365 & Google Workspace',
        description: 'Expert administration of Microsoft 365 and Google Workspace environments.',
        benefits: ['User Management', 'Security Configuration', 'Migration Services', 'Training & Support']
      },
      securityIdentity: {
        title: 'Security & Identity',
        subtitle: 'Active Directory, Okta & CyberArk',
        description: 'Enterprise-level identity and access management with AD, Okta and CyberArk.',
        benefits: ['Single Sign-On', 'Multi-Factor Authentication', 'Privileged Access', 'Compliance Reporting']
      },
      webDevelopment: {
        title: 'Web Development',
        subtitle: 'Custom web applications & sites',
        description: 'Custom web applications, modern websites and digital solutions that drive your business forward.',
        benefits: ['Custom Development', 'Performance Optimization', 'Security Implementation', 'Maintenance & Updates']
      }
    },
    articles: {
      detail: {
        backToArticles: 'Back to articles',
        articleNotFound: 'Article Not Found',
        articleNotFoundDescription: "The article you're looking for doesn't exist.",
        relatedArticles: 'Related Articles',
        readMore: 'Read more',
        needHelp: 'Need Help with Your IT Infrastructure?',
        needHelpDescription: "Let's talk about your IT setup.",
        getStarted: 'Get started'
      },
      page: {
        seo: {
          title: 'Articles & Field Notes | Byteet Insights',
          description: "Practical IT guides for Dutch SMBs from Byteet: managed IT costs, cloud migration, cybersecurity and NIS2, Microsoft 365, data, AI automation and software.",
          keywords: 'Byteet articles, IT playbooks, automation insights, infrastructure strategy, identity and access management guides, web development Netherlands',
          schemaName: 'Articles & Insights',
          schemaDescription: 'Articles, blueprints and field notes from Byteet covering cloud solutions, web development, device management, automation, identity and modern IT infrastructure.'
        },
        hero: {
          eyebrow: 'Byteet Articles',
          title: 'Articles, Playbooks &',
          highlight: 'Field Notes',
          description: 'Articles on automation, endpoints, infrastructure and web development.',
          cta: 'Explore articles'
        },
        stats: {
          averageReadTime: {
            label: 'Average read time',
            value: '8 min',
            detail: 'Written for people who run IT'
          },
          articlesPublished: {
            label: 'Articles published',
            detail: 'Guides and practical checklists'
          },
          categoriesCovered: {
            label: 'Categories covered',
            detail: 'From device management to data engineering'
          }
        },
        latest: {
          eyebrow: 'Latest releases',
          title: 'Latest articles',
          description: 'New guides and notes on running IT for small and mid-sized businesses.'
        },
        cards: {
          continueReading: 'Continue reading'
        },
        series: {
          eyebrow: 'Series',
          title: 'Pick a format',
          description: 'Short strategy notes or step-by-step guides, depending on what you need.',
          cards: {
            fieldNotes: {
              title: 'Field Notes',
              summary: 'Short notes from projects: what we tried and what we learned.'
            },
            playbooks: {
              title: 'Playbooks',
              summary: 'Step-by-step guides for onboarding, governance and rollouts.'
            },
            strategyCapsules: {
              title: 'Strategy Capsules',
              summary: 'Short explanations of when an infrastructure, automation or UX choice is worth making.'
            }
          }
        }
      }
    },
    servicePageCommon: {
      backToServices: 'Back to services',
      backToAllServices: 'Back to all services',
      relatedArticles: 'Guides on this service',
      serviceNotFound: 'Service Not Found',
      serviceNotFoundDescription: 'The service you are looking for does not exist.',
      coreCapabilities: 'Core Capabilities',
      deliverables: 'Deliverables',
      businessImpact: 'Business Impact',
      coreCapabilitiesDescription: 'What this service covers.',
      projectInformation: 'Project Information',
      projectInformationDescription: 'This page provides detailed information about our service offerings. For project inquiries or custom solutions, please contact us through our consultation form.'
    },
    servicePages: {
      managedItSupport: {
        title: 'Managed IT & Support',
        subtitle: 'Outsourced IT management: helpdesk, endpoints, service desk & monitoring',
        description: 'Outsource your IT management to one team: helpdesk with clear SLAs, endpoint management via Intune and Jamf, service desk setup, and proactive monitoring behind every resolution.'
      },
      cloudInfrastructure: {
        title: 'Cloud & Infrastructure',
        subtitle: 'Cloud migration, Microsoft 365, servers & virtualization',
        description: 'Move to the cloud safely and run it well: Microsoft 365 and Google Workspace administration, server and virtualization management, and planned migration to Azure and AWS with monitoring and cost control.'
      },
      cybersecurityIdentity: {
        title: 'Cybersecurity & Identity',
        subtitle: 'Identity, access, endpoint protection & NIS2 compliance',
        description: 'Secure who gets in and what runs on your endpoints: SSO and MFA, privileged access control, EDR endpoint protection and pentesting, aligned to zero trust and NIS2/ISO 27001.'
      },
      dataDatabases: {
        title: 'Data & Databases',
        subtitle: 'Database management, migration, pipelines & Power BI',
        description: 'Keep your databases healthy and your data moving: administration, migration and tuning for PostgreSQL, MySQL and SQL Server, plus pipelines, data platforms and Power BI reporting, with backup and recovery built in.'
      },
      aiAutomation: {
        title: 'AI & Automation',
        subtitle: 'AI agents, workflow automation & document AI',
        description: 'Put AI to work on real operations: automate workflows across your tools with n8n and Make, build AI agents and chatbots with retrieval over your own documents, and process documents automatically, all deployed GDPR- and EU AI Act-compliant.'
      },
      webSoftwareDevelopment: {
        title: 'Web Design & Development',
        subtitle: 'Websites, webshops, web apps & custom software',
        description: 'Design and build fast, secure websites, webshops and web applications with React, Next.js and TypeScript, plus custom software from portals to internal tools, with the source code in your hands and no vendor lock-in.'
      },
      mobileAppDevelopment: {
        title: 'Mobile App Development',
        subtitle: 'iOS & Android apps, backend and store publishing',
        description: 'Design and build iOS and Android apps for your customers or your own team, native or cross-platform with React Native or Flutter, together with the backend and API, publication in the App Store and Google Play, and maintenance after launch.',
        heroContent: {
          mainTitle: 'Mobile App Development',
          subtitle: 'Apps for iOS and Android, from first prototype to store release and beyond',
          keyPoints: [
            'Native-feeling apps for iOS and Android',
            'Cross-platform builds with React Native or Flutter, or native Swift and Kotlin where needed',
            'Backend, API and admin panel built alongside the app',
            'App Store and Google Play publishing and ongoing updates'
          ]
        },
        problemSolution: {
          problem: {
            title: 'An App Idea Without a Clear Route to the Store',
            description: 'A customer app or field-staff app often stalls between idea and release: two platforms to support, a backend nobody planned for, store review to get through, and no one lined up to keep it working after the next iOS or Android update.',
            challenges: [
              'Unclear whether to build native or cross-platform',
              'No backend or API for the app to talk to',
              'Store submission, signing and privacy declarations left until the end',
              'Apps that break after operating system updates because nobody maintains them'
            ]
          },
          solution: {
            title: 'One Team From Prototype to Store and Updates',
            description: 'We scope the app around the tasks your users actually do, pick the platform approach that fits, build the app and its backend together, take it through store review and keep it current afterwards.',
            benefits: [
              'A platform choice explained and agreed before building starts',
              'App and backend designed as one system',
              'Store release prepared from the first sprint, not the last week',
              'A maintenance plan for OS updates, libraries and bug fixes'
            ]
          }
        },
        features: [
          {
            title: 'iOS & Android Apps',
            description: 'Apps that look and behave the way users expect on each platform, built cross-platform with React Native or Flutter, or natively in Swift and Kotlin when the app needs deep access to the device.',
            capabilities: [
              'Cross-platform development with React Native or Flutter',
              'Native iOS (Swift) and Android (Kotlin) development',
              'Offline use, camera, location and push notifications',
              'Accessible interfaces for phones and tablets'
            ]
          },
          {
            title: 'Backend & API',
            description: 'The server side the app depends on: APIs, user accounts, databases and an admin panel for your team, or a connection to systems you already run. Personal data is handled with the GDPR in mind.',
            capabilities: [
              'REST or GraphQL API development',
              'Authentication and user management',
              'Admin panel for content and users',
              'Integration with existing business systems'
            ]
          },
          {
            title: 'App Store & Google Play Publishing',
            description: 'We prepare and submit the release: developer accounts, signing, store listings and the privacy and permission information both stores ask for.',
            capabilities: [
              'Developer account and signing setup',
              'Store listings, screenshots and descriptions',
              'Privacy and permission declarations',
              'Test releases via TestFlight and Google Play testing tracks'
            ]
          },
          {
            title: 'Maintenance & Updates',
            description: 'Apps need regular work to keep running on new iOS and Android versions. We handle updates, monitoring and new features after launch.',
            capabilities: [
              'Updates for new operating system versions',
              'Dependency and security updates',
              'Crash reporting and monitoring',
              'Planned feature releases'
            ]
          }
        ],
        technologies: {
          title: 'Mobile Technology',
          description: 'Frameworks and languages we use to build and run mobile apps.',
          platforms: [
            { name: 'React Native', category: 'Cross-Platform Framework' },
            { name: 'Flutter', category: 'Cross-Platform Framework' },
            { name: 'Swift', category: 'Native iOS' },
            { name: 'Kotlin', category: 'Native Android' },
            { name: 'Node.js', category: 'Backend & API' },
            { name: 'Firebase', category: 'Push Notifications & Auth' }
          ]
        },
        implementation: {
          title: 'App Development Process',
          description: 'From a scoped idea to a published app, in short iterations with test builds you can install on your own phone.',
          phases: [
            {
              phase: 'Discovery & Prototype',
              duration: '2-3 weeks',
              description: 'Define users, core tasks and platform approach, and test the main flows in a clickable prototype.',
              deliverables: ['Feature scope and user flows', 'Native or cross-platform recommendation', 'Clickable prototype', 'Technical architecture']
            },
            {
              phase: 'Development & Testing',
              duration: '6-12 weeks',
              description: 'Build the app and backend in short iterations, with a test build on real devices after each one.',
              deliverables: ['iOS and Android app builds', 'Backend and API', 'Test builds via TestFlight and Google Play testing', 'Automated and on-device testing']
            },
            {
              phase: 'Store Release',
              duration: '1-2 weeks',
              description: 'Prepare listings, privacy information and release builds, and take the app through App Store and Google Play review.',
              deliverables: ['Store listings and screenshots', 'Privacy and permission declarations', 'Signed release builds', 'Crash reporting setup']
            },
            {
              phase: 'Maintenance & Updates',
              duration: 'Ongoing',
              description: 'Keep the app working on new OS versions and ship improvements in planned releases.',
              deliverables: ['OS and dependency updates', 'Bug fixes and monitoring', 'Feature releases', 'Store listing updates']
            }
          ]
        },
        benefits: {
          title: 'Business Impact',
          description: 'What a well-built, maintained app gives your business.',
          outcomes: [
            {
              label: 'One Codebase, Two Platforms',
              description: 'With a cross-platform approach, iOS and Android share most of the code, so new features reach both at the same time.'
            },
            {
              label: 'Source Code You Own',
              description: 'You receive the source code of the app and the backend, so you are not tied to one supplier.'
            },
            {
              label: 'Fewer Surprises at Release',
              description: 'Store requirements are handled during development, so review issues come up early.'
            },
            {
              label: 'Kept Up to Date',
              description: 'Regular maintenance keeps the app working as iOS and Android change.'
            }
          ]
        }
      },
      crmDevelopment: {
        title: 'CRM Systems',
        subtitle: 'Custom CRM, CRM configuration and integrations',
        description: 'Get a CRM that matches how your team sells and serves customers: a custom-built CRM, or HubSpot, Salesforce or Microsoft Dynamics 365 configured and extended, connected to your email, invoicing and website, with your spreadsheet data migrated across.',
        heroContent: {
          mainTitle: 'CRM Systems',
          subtitle: 'Customer data, pipelines and follow-up in one system that fits your process',
          keyPoints: [
            'Custom CRM built around your sales and service process',
            'Configuration and extension of an existing CRM',
            'Integrations with email, invoicing and your website',
            'Migration from spreadsheets and old tools'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Customer Data Spread Across Spreadsheets and Inboxes',
            description: 'Leads arrive by email, web form and phone, quotes are tracked in a spreadsheet, and invoices live in another system. Follow-ups get missed and nobody has the full picture of a customer.',
            challenges: [
              'Leads and deals tracked in spreadsheets or personal inboxes',
              'A CRM license the team does not use because it does not fit the process',
              'Double data entry between CRM, invoicing and website',
              'No reliable overview of the pipeline and open follow-ups'
            ]
          },
          solution: {
            title: 'A CRM Shaped Around Your Process',
            description: 'We map how customers move through your business, then either build a CRM for that process or configure and extend the one you have, and connect it to the tools your team already uses.',
            benefits: [
              'Pipelines, fields and stages that match your sales process',
              'Web forms and email flowing straight into the CRM',
              'Customer and invoice data kept in sync',
              'Existing data cleaned and imported, not retyped'
            ]
          }
        },
        features: [
          {
            title: 'Custom CRM Development',
            description: 'A CRM built for your process when off-the-shelf tools fit poorly, with the screens, fields and permissions your team needs and nothing it does not.',
            capabilities: [
              'Custom data model for customers, deals and projects',
              'Role-based access and retention settings with the GDPR in mind',
              'Dashboards and pipeline reports',
              'Works in the browser and on mobile'
            ]
          },
          {
            title: 'CRM Configuration & Extension',
            description: 'Configuration and extension of HubSpot, Salesforce, Microsoft Dynamics 365 or Odoo: pipelines, custom fields, automations and extensions where the standard setup falls short.',
            capabilities: [
              'Pipeline and stage design',
              'Custom fields, objects and views',
              'Workflow automations and reminders',
              'Custom extensions via the platform API'
            ]
          },
          {
            title: 'Integrations',
            description: 'Connections between the CRM and the rest of your tools, so data is entered once and shows up where it is needed.',
            capabilities: [
              'Email and calendar integration',
              'Invoicing and accounting links',
              'Lead capture from your website and web forms',
              'Two-way sync with other business systems'
            ]
          },
          {
            title: 'Migration From Spreadsheets',
            description: 'Your existing customer data moved into the CRM: cleaned, deduplicated, mapped to the new structure and checked before go-live.',
            capabilities: [
              'Inventory of spreadsheets and tools',
              'Cleaning and deduplication',
              'Field mapping and trial imports',
              'Verification with your team before go-live'
            ]
          }
        ],
        technologies: {
          title: 'CRM Platforms & Tools',
          description: 'Platforms we configure and extend, and the tools we use for custom builds and integrations.',
          platforms: [
            { name: 'HubSpot', category: 'CRM Platform' },
            { name: 'Salesforce', category: 'CRM Platform' },
            { name: 'Microsoft Dynamics 365', category: 'CRM & Business Apps' },
            { name: 'Odoo', category: 'Open-Source CRM & ERP' },
            { name: 'PostgreSQL', category: 'Custom CRM Database' },
            { name: 'n8n', category: 'Integration Workflows' }
          ]
        },
        implementation: {
          title: 'CRM Implementation Process',
          description: 'A step-by-step route from scattered customer data to a CRM your team uses.',
          phases: [
            {
              phase: 'Process Mapping',
              duration: '1-2 weeks',
              description: 'Map how leads, deals and customers move through your business today, and decide whether to build or configure.',
              deliverables: ['Sales and service process map', 'Inventory of current data and tools', 'Build or configure recommendation', 'Scope and plan']
            },
            {
              phase: 'Build & Configure',
              duration: '3-8 weeks',
              description: 'Set up or build the CRM, then connect it to email, invoicing and your website.',
              deliverables: ['Pipelines, fields and roles', 'Custom screens or extensions', 'Integrations', 'Automations and reminders']
            },
            {
              phase: 'Migration & Training',
              duration: '1-3 weeks',
              description: 'Import cleaned data, check it with your team and train each role on daily use.',
              deliverables: ['Cleaned and deduplicated data import', 'Trial migration and sign-off', 'Training per role', 'Go-live support']
            },
            {
              phase: 'Support & Improvement',
              duration: 'Ongoing',
              description: 'Adjust pipelines, reports and integrations as your process changes.',
              deliverables: ['User support', 'Changes to fields and workflows', 'Integration monitoring', 'New reports and automations']
            }
          ]
        },
        benefits: {
          title: 'Business Impact',
          description: 'What a CRM that fits your process gives your team.',
          outcomes: [
            {
              label: 'One View of Each Customer',
              description: 'Contacts, deals, emails and invoices for a customer are in one place.'
            },
            {
              label: 'Fewer Missed Follow-Ups',
              description: 'Reminders and pipeline stages make open actions visible.'
            },
            {
              label: 'Less Double Entry',
              description: 'Integrations move data between systems instead of people retyping it.'
            },
            {
              label: 'Built for Daily Use',
              description: 'Screens and fields follow your process, which makes the CRM easier to keep up to date.'
            }
          ]
        }
      },
      erpSystems: {
        title: 'ERP Systems',
        subtitle: 'ERP integrations, custom modules & data migration',
        description: 'Connect and extend the ERP your business runs on, such as Exact Online, AFAS, Microsoft Dynamics 365 Business Central or Odoo: custom modules, integrations with your webshop, CRM and accounting, and data migration that is tested and checked step by step.',
        heroContent: {
          mainTitle: 'ERP Systems',
          subtitle: 'Your ERP connected to the rest of your business, extended where the standard setup falls short',
          keyPoints: [
            'Integrations between your ERP and your webshop, CRM and accounting',
            'Custom modules and extensions for processes the standard ERP does not cover',
            'Data migration from old systems with reconciliation checks',
            'Support when ERP versions and APIs change'
          ]
        },
        problemSolution: {
          problem: {
            title: 'An ERP That Stands on Its Own',
            description: 'Orders are copied from the webshop by hand, stock levels differ between systems, and the processes that make your business different are handled in spreadsheets alongside the ERP.',
            challenges: [
              'Manual copying of orders, customers and invoices between systems',
              'Stock and price differences between ERP and webshop',
              'Processes the standard ERP does not support, handled in spreadsheets',
              'A planned ERP switch with years of data to move'
            ]
          },
          solution: {
            title: 'An ERP Connected to the Rest of Your Business',
            description: 'We map how data flows between your systems, build the integrations and modules that close the gaps, and move data across with trial runs and checks before anything goes live.',
            benefits: [
              'Orders, customers and stock synchronized automatically',
              'Custom modules that follow your own processes',
              'Integrations with logging and error alerts, so problems surface',
              'Data migration tested before cut-over'
            ]
          }
        },
        features: [
          {
            title: 'ERP Connection & Extension',
            description: 'We work with the ERP you already use, such as Exact Online, AFAS, Business Central or Odoo, through its APIs and extension options.',
            capabilities: [
              'Review of your current ERP setup',
              'Use of standard APIs and connectors',
              'Configuration of existing modules',
              'Documentation of every change'
            ]
          },
          {
            title: 'Custom Modules',
            description: 'Modules or companion applications for processes your ERP does not cover, such as planning, production steps, service visits or customer portals, working on the same data.',
            capabilities: [
              'Custom Odoo or Business Central modules',
              'Companion web apps on top of ERP data',
              'Customer and supplier portals',
              'Reports and dashboards from ERP data'
            ]
          },
          {
            title: 'Integrations',
            description: 'Links between the ERP and your webshop, CRM, accounting and logistics tools, with logging and alerts so a failed sync does not go unnoticed.',
            capabilities: [
              'Webshop integration for orders, stock and prices',
              'Customer and order sync between CRM and ERP',
              'Accounting and invoicing links',
              'Monitoring, logging and error alerts'
            ]
          },
          {
            title: 'Data Migration',
            description: 'Customers, items, open ledger entries and history moved from an old system into the new ERP, with trial migrations and reconciliation before go-live.',
            capabilities: [
              'Data inventory and quality assessment',
              'Mapping and conversion scripts',
              'Trial migrations in a test environment',
              'Reconciliation of totals with the old system'
            ]
          }
        ],
        technologies: {
          title: 'ERP Platforms & Integration Tools',
          description: 'ERP systems common among Dutch SMBs that we connect and extend, and the tools we use to integrate them.',
          platforms: [
            { name: 'Exact Online', category: 'Accounting & ERP' },
            { name: 'AFAS', category: 'ERP & HR Suite' },
            { name: 'Microsoft Dynamics 365 Business Central', category: 'ERP' },
            { name: 'Odoo', category: 'Modular ERP' },
            { name: 'n8n', category: 'Integration Workflows' },
            { name: 'PostgreSQL', category: 'Staging & Reporting Database' }
          ]
        },
        implementation: {
          title: 'ERP Integration Process',
          description: 'A careful sequence for changing the system your finances and operations depend on.',
          phases: [
            {
              phase: 'Analysis',
              duration: '2-3 weeks',
              description: 'Map your systems, data flows and the processes the ERP does not cover today.',
              deliverables: ['System and data-flow map', 'Integration and module requirements', 'Data quality assessment', 'Implementation plan']
            },
            {
              phase: 'Build & Integrate',
              duration: '4-10 weeks',
              description: 'Develop integrations and custom modules and test them in a test environment, not in your live ERP.',
              deliverables: ['API integrations', 'Custom modules or extensions', 'Logging and error handling', 'Test runs with real scenarios']
            },
            {
              phase: 'Migration & Go-Live',
              duration: '2-4 weeks',
              description: 'Run trial migrations, reconcile the results with the old system and plan the cut-over with your team.',
              deliverables: ['Migration scripts and trial runs', 'Reconciliation reports', 'Cut-over plan', 'Go-live support']
            },
            {
              phase: 'Support & Maintenance',
              duration: 'Ongoing',
              description: 'Monitor integrations and update them when the ERP or connected systems change.',
              deliverables: ['Integration monitoring', 'Updates for ERP and API changes', 'Fixes and extensions', 'Up-to-date documentation']
            }
          ]
        },
        benefits: {
          title: 'Business Impact',
          description: 'What a connected ERP that fits your processes gives your business.',
          outcomes: [
            {
              label: 'Less Manual Data Entry',
              description: 'Orders, customers and invoices move between systems automatically.'
            },
            {
              label: 'Consistent Stock and Prices',
              description: 'Webshop and ERP work from the same figures.'
            },
            {
              label: 'Processes That Fit',
              description: 'Custom modules cover the steps that make your business different.'
            },
            {
              label: 'Controlled Migration',
              description: 'Trial runs and reconciliation catch data problems before go-live.'
            }
          ]
        }
      },
      itSupport: {
        title: 'IT Support',
        subtitle: 'Helpdesk & technical support',
        description: 'Comprehensive IT helpdesk and technical support services ensuring rapid issue resolution and optimal system performance.',
        heroContent: {
          mainTitle: 'IT Support',
          subtitle: 'Professional IT helpdesk and technical support services for stable operations and quick issue resolution',
          keyPoints: [
            '24/7 technical support and helpdesk services',
            'Rapid incident response and resolution',
            'Proactive system monitoring and maintenance',
            'Expert troubleshooting and problem resolution'
          ]
        },
        problemSolution: {
          problem: {
            title: 'IT Support Challenges',
            description: 'Organizations struggle with IT issues causing downtime, productivity loss and user frustration due to slow response times and a lack of expert support.',
            challenges: [
              'Slow response times affecting productivity',
              'Lack of expert technical support resources',
              'Inconsistent issue resolution processes',
              'Limited visibility into IT system health'
            ]
          },
          solution: {
            title: 'Comprehensive IT Support Solutions',
            description: 'We provide professional IT support services that ensure rapid issue resolution, proactive monitoring and expert technical assistance.',
            benefits: [
              'Rapid incident response and resolution',
              'Expert technical support and troubleshooting',
              'Proactive system monitoring and maintenance',
              'Comprehensive support documentation and knowledge base'
            ]
          }
        },
        features: [
          {
            title: 'Helpdesk Services',
            description: 'Professional helpdesk services providing first-line support for IT issues, user inquiries and technical assistance.',
            capabilities: [
              'Ticket management and tracking',
              'First-line technical support',
              'User assistance and guidance',
              'Issue escalation and routing'
            ]
          },
          {
            title: 'Technical Support',
            description: 'Expert technical support for complex IT issues, system troubleshooting and problem resolution.',
            capabilities: [
              'Advanced troubleshooting and diagnostics',
              'System configuration and optimization',
              'Hardware and software support',
              'Remote assistance and support'
            ]
          },
          {
            title: 'Proactive Monitoring',
            description: 'Continuous system monitoring and proactive maintenance to prevent issues before they impact users.',
            capabilities: [
              '24/7 system monitoring and alerting',
              'Proactive issue detection and prevention',
              'Performance monitoring and optimization',
              'Health checks and maintenance'
            ]
          },
          {
            title: 'Knowledge Management',
            description: 'Comprehensive knowledge base and documentation ensuring consistent support quality and faster resolution times.',
            capabilities: [
              'Knowledge base development and maintenance',
              'Support documentation and procedures',
              'Training and knowledge transfer',
              'Best practices and guidelines'
            ]
          }
        ],
        technologies: {
          title: 'Support Tools & Platforms',
          description: 'Expertise across IT support platforms and tools.',
          platforms: [
            { name: 'Zammad', category: 'Helpdesk Platform' },
            { name: 'Jira Service Desk', category: 'ITSM Platform' },
            { name: 'ServiceNow', category: 'Enterprise ITSM' },
            { name: 'Freshservice', category: 'Cloud Helpdesk' },
            { name: 'ManageEngine', category: 'IT Management' },
            { name: 'TeamViewer', category: 'Remote Support' }
          ]
        },
        implementation: {
          title: 'Support Setup Process',
          description: 'Structured approach to establishing comprehensive IT support services.',
          phases: [
            {
              phase: 'Assessment & Planning',
              duration: '1-2 weeks',
              description: 'Comprehensive assessment of current IT support needs and development of support strategy.',
              deliverables: ['Support requirements analysis', 'Support strategy document', 'Tool selection and planning', 'Implementation roadmap']
            },
            {
              phase: 'Setup & Configuration',
              duration: '2-3 weeks',
              description: 'Helpdesk platform setup, workflow configuration and support process implementation.',
              deliverables: ['Platform configuration', 'Workflow setup', 'Knowledge base structure', 'Support procedures']
            },
            {
              phase: 'Training & Launch',
              duration: '1-2 weeks',
              description: 'Staff training, process documentation and go-live support for IT support services.',
              deliverables: ['Support team training', 'User documentation', 'Go-live support', 'Performance monitoring setup']
            },
            {
              phase: 'Ongoing Support',
              duration: 'Ongoing',
              description: 'Continuous support delivery, process optimization and service improvement.',
              deliverables: ['24/7 support delivery', 'Performance monitoring', 'Process optimization', 'Continuous improvement']
            }
          ]
        },
        benefits: {
          title: 'Support Impact',
          description: 'Deliver measurable improvements in support quality and user satisfaction.',
          outcomes: [
            {
              label: 'Faster Resolution Times',
              description: 'Expert support and efficient processes significantly reduce issue resolution times.'
            },
            {
              label: 'User Satisfaction',
              description: 'Professional support services and rapid response times increase user satisfaction.'
            },
            {
              label: 'Reduction in Downtime',
              description: 'Proactive monitoring and rapid response reduce system downtime and productivity loss.'
            },
            {
              label: 'First Contact Resolution',
              description: 'Expert support and a comprehensive knowledge base enable high first-contact resolution rates.'
            }
          ]
        }
      },
      dataEngineering: {
        title: 'Data Engineering',
        subtitle: 'Data pipelines & analytics infrastructure',
        description: 'Build robust data pipelines, ETL processes and analytics infrastructure that transform raw data into actionable insights for data-driven decision-making.',
        heroContent: {
          mainTitle: 'Data Engineering',
          subtitle: 'Comprehensive data engineering services for building scalable data pipelines, ETL processes and analytics infrastructure',
          keyPoints: [
            'Scalable data pipeline development',
            'ETL/ELT process design and implementation',
            'Data warehouse and lake architecture',
            'Real-time data processing and analytics'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Data Infrastructure Challenges',
            description: 'Organizations struggle with fragmented data sources, inefficient data processing and a lack of scalable infrastructure to support analytics and business intelligence.',
            challenges: [
              'Fragmented data sources and silos',
              'Inefficient data processing and transformation',
              'Lack of scalable data infrastructure',
              'Limited real-time data processing capabilities'
            ]
          },
          solution: {
            title: 'Comprehensive Data Engineering Solutions',
            description: 'We deliver scalable data engineering solutions that enable efficient data processing, transformation and analytics infrastructure.',
            benefits: [
              'Scalable data pipeline architecture',
              'Efficient ETL/ELT processes',
              'Unified data infrastructure',
              'Real-time data processing capabilities'
            ]
          }
        },
        features: [
          {
            title: 'Data Pipeline Development',
            description: 'Design and implement scalable data pipelines for efficient data ingestion, transformation and processing.',
            capabilities: [
              'Data pipeline architecture design',
              'ETL/ELT process implementation',
              'Data ingestion and integration',
              'Pipeline monitoring and optimization'
            ]
          },
          {
            title: 'Data Warehouse & Lake',
            description: 'Build and optimize data warehouses and data lakes for centralized data storage and analytics.',
            capabilities: [
              'Data warehouse architecture design',
              'Data lake implementation and optimization',
              'Data modeling and schema design',
              'Storage optimization and partitioning'
            ]
          },
          {
            title: 'Real-Time Processing',
            description: 'Implement real-time data processing and streaming analytics for immediate insights and decision-making.',
            capabilities: [
              'Stream processing architecture',
              'Real-time data transformation',
              'Event-driven data processing',
              'Stream analytics and monitoring'
            ]
          },
          {
            title: 'Data Quality & Governance',
            description: 'Implement data quality frameworks, governance policies and monitoring to ensure reliable and trustworthy data.',
            capabilities: [
              'Data quality frameworks and validation',
              'Data governance and compliance',
              'Data lineage and cataloging',
              'Data quality monitoring and reporting'
            ]
          }
        ],
        technologies: {
          title: 'Technology Stack',
          description: 'Expertise across data engineering platforms and tools.',
          platforms: [
            { name: 'Apache Airflow', category: 'Workflow Orchestration' },
            { name: 'Apache Spark', category: 'Data Processing' },
            { name: 'Snowflake', category: 'Data Warehouse' },
            { name: 'AWS Glue', category: 'ETL Service' },
            { name: 'Apache Kafka', category: 'Stream Processing' },
            { name: 'dbt', category: 'Data Transformation' }
          ]
        },
        implementation: {
          title: 'Implementation Methodology',
          description: 'Structured approach to data engineering implementation ensuring scalable and reliable data infrastructure.',
          phases: [
            {
              phase: 'Assessment & Design',
              duration: '2-3 weeks',
              description: 'Comprehensive data assessment, architecture design and implementation planning.',
              deliverables: ['Data assessment report', 'Architecture design', 'Technology recommendations', 'Implementation roadmap']
            },
            {
              phase: 'Infrastructure Setup',
              duration: '2-4 weeks',
              description: 'Data infrastructure setup, platform configuration and initial pipeline development.',
              deliverables: ['Infrastructure deployment', 'Platform configuration', 'Initial pipelines', 'Security setup']
            },
            {
              phase: 'Pipeline Development',
              duration: '3-6 weeks',
              description: 'Data pipeline development, ETL processes and data transformation implementation.',
              deliverables: ['Data pipelines', 'ETL processes', 'Data quality frameworks', 'Monitoring setup']
            },
            {
              phase: 'Optimization & Support',
              duration: 'Ongoing',
              description: 'Continuous optimization, performance tuning and ongoing support for data infrastructure.',
              deliverables: ['Performance optimization', 'Monitoring and alerting', '24/7 support', 'Continuous improvement']
            }
          ]
        },
        benefits: {
          title: 'Business Impact',
          description: 'Deliver measurable improvements in data processing efficiency and analytics capabilities.',
          outcomes: [
            {
              label: 'Faster Data Processing',
              description: 'Optimized pipelines and infrastructure significantly reduce data processing times.'
            },
            {
              label: 'Cost Reduction',
              description: 'Efficient data infrastructure and optimization reduce data processing and storage costs.'
            },
            {
              label: 'Data Quality Improvement',
              description: 'Comprehensive data quality frameworks ensure reliable and trustworthy data for analytics.'
            },
            {
              label: 'Faster Time to Insights',
              description: 'Streamlined data pipelines and real-time processing accelerate time to actionable insights.'
            }
          ]
        }
      }
    }
  },
  nl: {
    nav: {
      home: 'Home',
      services: 'Diensten',
      portfolio: 'Klantcases',
      about: 'Over ons',
      articles: 'Artikelen',
      contact: 'Contact',
      getConsultation: 'Offerte aanvragen',
      getConsultationShort: 'Offerte',
      bookCall: 'Plan een gesprek',
      openMenu: 'Menu',
      closeMenu: 'Sluiten'
    },
    seo: {
      home: {
        title: 'Byteet | Webdesign & website laten maken voor het MKB',
        description: 'Byteet ontwerpt en bouwt websites, webshops en webapplicaties voor het MKB, en beheert de IT erachter: managed IT, cloud, security, data & AI. Zonder gedoe.'
      },
      about: {
        title: 'Over Byteet | IT-partner en managed services provider',
        description: 'Over Byteet, de IT-partner voor het MKB: wie we zijn, hoe we werken en onze diensten in IT-beheer, cloud, cybersecurity, data, AI en maatwerksoftware.'
      },
      contact: {
        title: 'Contact Byteet | Advies over IT-diensten in Nederland',
        description: 'Neem contact op met Byteet voor een offerte op maat voor IT-beheer, cloud, cybersecurity, data, AI-automatisering of maatwerksoftware voor uw MKB-bedrijf.'
      },
      book: {
        title: 'Plan een gratis IT-adviesgesprek | Byteet',
        description: 'Plan een vrijblijvend adviesgesprek van {minutes} minuten met Byteet via Google Meet. Kies een moment dat u uitkomt; de uitnodiging ontvangt u per e-mail.'
      },
      services: {
        title: 'IT-diensten voor het MKB | Beheer, cloud & security | Byteet',
        description: 'De IT-diensten van Byteet voor het MKB: managed IT-beheer, cloud & infrastructuur, cybersecurity, data & databases, AI & automatisering en maatwerksoftware.'
      },
      portfolio: {
        title: 'Klantcases & succesverhalen | IT voor het MKB | Byteet',
        description: 'Klantcases van Byteet: echte resultaten voor het MKB in managed IT-beheer, cloud, cybersecurity, data en maatwerksoftware. Bekijk hoe we het aanpakten.'
      },
      privacy: {
        title: 'Privacybeleid – Byteet | GDPR-naleving in Nederland',
        description: 'Het privacybeleid van Byteet legt uit hoe wij uw persoonsgegevens verzamelen, gebruiken en beschermen, in lijn met de AVG (GDPR) en EU-privacyregels.'
      },
      terms: {
        title: 'Servicevoorwaarden – Byteet | Juridische voorwaarden',
        description: 'Lees de servicevoorwaarden van Byteet om de juridische voorwaarden te begrijpen die het gebruik van onze website en IT-diensten in Nederland bepalen.'
      },
      notFound: {
        title: 'Pagina niet gevonden – Byteet',
        description: 'De pagina die u zoekt is niet gevonden. Ga terug naar de homepage van Byteet om onze IT-diensten te bekijken.'
      }
    },
    serviceSeo: {
      'managed-it-support': {
        title: 'IT-beheer uitbesteden voor het mkb | Byteet',
        description: 'IT-beheer uitbesteden aan Byteet: helpdesk, werkplekbeheer, servicedesk en 24/7 monitoring voor het mkb. Een vast bedrag per maand, zonder verrassingen.'
      },
      'cloud-infrastructure': {
        title: 'Cloudmigratie en Microsoft 365 voor het mkb | Byteet',
        description: 'Stap veilig over op Microsoft 365 en Azure met Byteet: cloudmigratie, beheer van servers en virtualisatie, en managed cloud voor het mkb.'
      },
      'cybersecurity-identity': {
        title: 'Cybersecurity & NIS2 voor het MKB | Byteet',
        description: 'Bescherm uw MKB-bedrijf met Byteet: cybersecurity, identity- en toegangsbeheer, pentesten en NIS2/ISO 27001-compliance. Vraag een gratis securityscan aan.'
      },
      'data-databases': {
        title: 'Databasebeheer en dataplatform voor het mkb | Byteet',
        description: 'Betrouwbaar databasebeheer door Byteet: proactief beheer, datamigratie zonder downtime, back-up en herstel, plus een dataplatform en Power BI voor het mkb.'
      },
      'ai-automation': {
        title: 'AI-automatisering en AI-agents voor het mkb | Byteet',
        description: 'AI-automatisering voor het mkb: bedrijfsprocessen automatiseren met AI-agents, chatbots op uw eigen data en document-AI, conform de AVG en de AI-verordening.'
      },
      'web-software-development': {
        title: 'Website laten maken | Webdesign & webapps | Byteet',
        description: 'Website, webshop of webapplicatie laten maken bij Byteet: webdesign en ontwikkeling met React en Next.js, ook maatwerksoftware. U krijgt de broncode.'
      },
      'mobile-app-development': {
        title: 'App laten maken voor iOS en Android | Byteet',
        description: 'App laten maken voor iOS en Android: Byteet bouwt native of cross-platform apps met React Native of Flutter, met backend, publicatie in de stores en onderhoud.'
      },
      'crm-development': {
        title: 'CRM op maat laten maken voor het MKB | Byteet',
        description: 'Een CRM dat past bij hoe u verkoopt: Byteet bouwt CRM op maat of breidt HubSpot, Salesforce en Dynamics 365 uit, gekoppeld aan e-mail, facturatie en website.'
      },
      'erp-systems': {
        title: 'ERP-koppelingen & maatwerkmodules voor het MKB | Byteet',
        description: 'Byteet koppelt en breidt ERP-systemen als Exact Online, AFAS en Odoo uit: maatwerkmodules, koppelingen met webshop, CRM en boekhouding, en datamigratie.'
      },
      'automation-devops': {
        title: 'Automation & DevOps | CI/CD en Infrastructure as Code | Byteet',
        description: 'Deskundige diensten voor Automation & DevOps in Nederland. CI/CD-pipelines, Infrastructure as Code (IaC), procesautomatisering en efficiëntieoptimalisatie. Verbeter uw IT-processen met moderne DevOps-praktijken.'
      },
      'cloud-workspace': {
        title: 'Cloud Workspace | Modern Workplace en werken op afstand | Byteet',
        description: 'Professionele oplossingen voor de cloudwerkplek in Nederland. Inrichting en beheer van Microsoft 365, Azure, AWS en Google Workspace. Modern Workplace-oplossingen voor teams die op afstand of hybride werken.'
      },
      'device-management': {
        title: 'Device Management | Intune- en MDM-oplossingen | Byteet',
        description: 'Deskundige diensten voor Device Management (MDM) in Nederland. Microsoft Intune, Mobile Device Management, endpointbeveiliging en compliance. Beveilig en beheer al uw apparaten efficiënt.'
      },
      'identity-access': {
        title: 'Identity & Access Management | IAM- en SSO-oplossingen | Byteet',
        description: 'Professionele diensten voor Identity & Access Management (IAM) in Nederland. Implementatie van SSO, Zero Trust, Active Directory, Okta en CyberArk. Veilig toegangsbeheer voor uw organisatie.'
      },
      'infrastructure-management': {
        title: 'Infrastructure Management | Hybride cloud en serverbeheer | Byteet',
        description: 'Deskundige diensten voor Infrastructure Management in Nederland. Hybride cloudoplossingen, serverbeheer, virtualisatie en infrastructuuroptimalisatie. Betrouwbaar beheer van uw infrastructuur.'
      },
      'database-management': {
        title: 'Database Management | SQL- en data-optimalisatie | Byteet',
        description: 'Professionele diensten voor Database Management in Nederland. SQL-optimalisatie, databaseadministratie, data-integriteit, migratie en 24/7 databaseondersteuning. Zorg dat uw databases betrouwbaar draaien.'
      },
      'service-desk': {
        title: 'Servicedesk implementeren | IT-support en helpdesk | Byteet',
        description: 'Deskundige implementatie van servicedesks in Nederland. IT-support, inrichting van de helpdesk, SLA-management, ticketsystemen en optimalisatie van IT-support. Stroomlijn uw IT-support.'
      },
      'knowledge-management': {
        title: 'Knowledge Management | Documentatie en kennisbank | Byteet',
        description: 'Professionele diensten voor Knowledge Management in Nederland. Documentatiesystemen, implementatie van een kennisbank, inrichting van Confluence en informatiebeheer. Verbeter het delen van kennis.'
      },
      'web-development': {
        title: 'Web Development | Full-stack en React/Next.js | Byteet',
        description: 'Deskundige diensten voor Web Development in Nederland. Full-stackontwikkeling, React, Next.js, webapplicaties op maat en moderne weboplossingen. Laat krachtige webapplicaties voor uw bedrijf bouwen.'
      },
      'it-support': {
        title: 'IT-support | 24/7 support | Byteet',
        description: 'Professionele IT-support in Nederland. 24/7 technische ondersteuning, helpdeskdiensten en het oplossen van IT-storingen. Betrouwbare IT-support wanneer u die nodig heeft.'
      },
      'data-engineering': {
        title: 'Data Engineering | Pipelines en ETL-oplossingen | Byteet',
        description: 'Deskundige diensten voor Data Engineering in Nederland. Datapipelines, ETL-processen, big data, data-infrastructuur en analytics. Zet data om in bruikbare inzichten.'
      }
    },
    articles: {
      detail: {
        backToArticles: 'Terug naar artikelen',
        articleNotFound: 'Artikel niet gevonden',
        articleNotFoundDescription: 'Het artikel dat u zoekt, bestaat niet.',
        relatedArticles: 'Gerelateerde artikelen',
        readMore: 'Lees meer',
        needHelp: 'Hulp nodig bij uw IT-infrastructuur?',
        needHelpDescription: 'We bespreken graag hoe we uw IT-beheer kunnen moderniseren.',
        getStarted: 'Aan de slag'
      },
      page: {
        seo: {
          title: 'Artikelen en veldnotities | Inzichten van Byteet',
          description: 'Praktische IT-artikelen voor het MKB: wat IT-beheer kost, cloudmigratie, cybersecurity en NIS2, Microsoft 365, data, AI-automatisering en software.',
          keywords: 'Byteet-artikelen, IT-playbooks, inzichten over automatisering, infrastructuurstrategie, gidsen voor Identity & Access Management, Web Development Nederland',
          schemaName: 'Artikelen en inzichten',
          schemaDescription: 'Artikelen, blauwdrukken en veldnotities van Byteet over cloudoplossingen, Web Development, Device Management, automatisering, Identity & Access Management en moderne IT-infrastructuur.'
        },
        hero: {
          eyebrow: 'Artikelen van Byteet',
          title: 'Artikelen, playbooks en',
          highlight: 'veldnotities',
          description: 'Artikelen over automatisering, endpoints, infrastructuur en webontwikkeling.',
          cta: 'Bekijk artikelen'
        },
        stats: {
          averageReadTime: {
            label: 'Gemiddelde leestijd',
            value: '8 min',
            detail: 'Geschreven voor drukbezette IT-beslissers'
          },
          articlesPublished: {
            label: 'Gepubliceerde artikelen',
            detail: 'Uitgebreide handleidingen en best practices'
          },
          categoriesCovered: {
            label: 'Categorieën',
            detail: 'Van apparaatbeheer tot data-engineering'
          }
        },
        latest: {
          eyebrow: 'Nieuwste artikelen',
          title: 'Vers uit de praktijk',
          description: 'Verhalen uit projecten, automatiseringswerk en ontwerpreviews, geschreven voor wie beslist over IT en digitalisering.'
        },
        cards: {
          continueReading: 'Verder lezen'
        },
        series: {
          eyebrow: 'Reeksen',
          title: 'Kies wat u wilt lezen',
          description: 'Of u nu beknopte strategiestukken zoekt of gedetailleerde handleidingen voor automatisering: de artikelen sluiten aan op het tempo van uw roadmap.',
          cards: {
            fieldNotes: {
              title: 'Praktijkverhalen',
              summary: 'Wekelijks korte stukken uit lopende projecten, proeven met nieuwe tools en lessen die we onderweg leren.'
            },
            playbooks: {
              title: 'Playbooks',
              summary: 'Stapsgewijze handleidingen voor onboarding, governance en een snellere ingebruikname.'
            },
            strategyCapsules: {
              title: 'Strategie in het kort',
              summary: 'Korte stukken over waarom bepaalde keuzes in infrastructuur, automatisering of UX er nu toe doen.'
            }
          }
        }
      }
    },
    hero: {
      titleLead: 'Websites en webapps',
      titleTail: 'voor het MKB.',
      title: 'Websites en webapps voor het MKB.',
      subtitle: 'Managed IT-beheer, cloud & infrastructuur, cybersecurity, data & AI en maatwerksoftware, persoonlijk geregeld voor het mkb. Veilig, proactief en zonder gedoe.',
      cta: {
        title: 'Een nieuwe website of webapplicatie nodig, of hulp bij uw IT?',
        consultation: 'Plan een vrijblijvend adviesgesprek',
        call: 'Bel nu'
      }
    },
    home: {
      scroll: 'Scroll',
      statementLabel: 'Wat we doen',
      statement: 'Byteet ontwerpt en bouwt websites, webshops en webapplicaties voor het MKB, van eerste ontwerp tot lancering en onderhoud. Daarnaast bouwen we apps, CRM en ERP, en beheren we de IT erachter: support, cloud, security, data en AI.',
      servicesLabel: 'Diensten',
      servicesLead: 'Bouwen.',
      servicesTail: 'Beheren.',
      servicesIntro: 'Negen diensten uit één team, met webdesign en webontwikkeling voorop: we bouwen wat u online nodig heeft en houden de systemen erachter draaiende.',
      explore: 'Bekijk',
      allServices: 'Alle diensten',
      workLabel: 'Geselecteerd werk',
      workLead: 'Live',
      workTail: 'en in gebruik',
      workIntro: 'Websites en platforms die we ontwierpen en bouwden, vandaag online.',
      visit: 'Bekijk site',
      allCases: 'Alle cases',
      engagementsLabel: 'IT-projecten',
      engagementsTitle: 'Achter het scherm',
      engagementsIntro: 'Infrastructuur-, identiteits- en apparaatprojecten die niet in een screenshot passen.',
      toolsLabel: 'Tools waarmee we werken',
      ctaLabel: 'Contact',
      ctaLead: 'Laten we praten',
      ctaTail: 'over uw project',
      email: 'E-mail',
      phone: 'Telefoon'
    },
    work: {
      label: 'Cases',
      lead: 'Werk',
      tail: 'dat draait',
      intro: 'Websites en platforms die we voor klanten bouwden, en de IT-projecten achter de schermen, van apparaatbeheer tot identiteit en cloudmigraties.',
      sitesLabel: 'Websites & platforms',
      stack: 'Stack',
      delivered: 'Opgeleverd',
      challenge: 'Uitdaging',
      approach: 'Aanpak',
      outcome: 'Resultaat',
      all: 'Alles'
    },
    cookieBanner: {
      title: 'Cookies',
      text: 'We gebruiken cookies om de site te verbeteren en bezoek te meten. Accepteer ze allemaal, weiger alles wat niet noodzakelijk is, of kies per categorie. Meer in ons',
      policy: 'cookiebeleid',
      reject: 'Alles weigeren',
      accept: 'Alles accepteren',
      rejectLabel: 'Alle niet-noodzakelijke cookies weigeren',
      acceptLabel: 'Alle cookies accepteren',
      manage: 'Voorkeuren beheren'
    },
    stats: {
      clients: 'Klanten geholpen',
      uptime: 'SLA-percentage',
      support: 'Ondersteuning'
    },
    products: {
      title: 'EEN GREEP UIT ONZE OPLOSSINGEN',
      subtitle: 'Praktische IT-oplossingen die uw infrastructuur moderniseren en uw bedrijfsvoering efficiënter maken.',
      viewAll: 'Bekijk alle diensten'
    },
    partners: {
      title: 'EEN GREEP UIT DE TOOLS DIE WE GEBRUIKEN',
      subtitle: 'We werken met gevestigde platforms en tools om complete IT-oplossingen te leveren die uw bedrijf verder helpen.'
    },
    services: {
      title: 'ONZE IT-DIENSTEN VOOR HET MKB',
      subtitle: 'Zes IT-gebieden bij één partner, zodat uw systemen, beveiliging en software op elkaar aansluiten.',
      learnMore: 'Meer informatie',
      managedItSupport: {
        title: 'IT-beheer & support',
        subtitle: 'Helpdesk, werkplekbeheer, servicedesk & monitoring'
      },
      cloudInfrastructure: {
        title: 'Cloud & infrastructuur',
        subtitle: 'Cloudmigratie, Microsoft 365 & servers'
      },
      cybersecurityIdentity: {
        title: 'Cybersecurity & identiteit',
        subtitle: 'Toegangsbeheer, endpointbeveiliging, pentest & NIS2'
      },
      dataDatabases: {
        title: 'Data & databases',
        subtitle: 'Databasebeheer, datamigratie & analytics'
      },
      aiAutomation: {
        title: 'AI & automatisering',
        subtitle: 'AI-agents, procesautomatisering & document-AI'
      },
      webSoftwareDevelopment: {
        title: 'Webdesign & webontwikkeling',
        subtitle: 'Website, webshop, webapp of maatwerksoftware laten maken'
      },
      mobileAppDevelopment: {
        title: 'App-ontwikkeling',
        subtitle: 'Apps voor iOS & Android laten maken'
      },
      crmDevelopment: {
        title: 'CRM-systemen',
        subtitle: 'CRM op maat, inrichting & koppelingen'
      },
      erpSystems: {
        title: 'ERP-systemen',
        subtitle: 'ERP-koppelingen, maatwerkmodules & migratie'
      },
      deviceManagement: {
        title: 'Apparaatbeheer',
        subtitle: 'Windows, macOS, Linux, ChromeOS, iOS, Android',
        description: 'Volledig apparaatbeheer voor Windows en macOS: Microsoft Intune en SCCM voor Windows, Jamf Pro voor macOS.',
        features: [
          'Windows: Microsoft Intune',
          'Windows: SCCM/ConfigMgr',
          'macOS: Jamf Pro',
          'Compliance en afdwingen van beleid',
          'Software verpakken en uitrollen'
        ]
      },
      infrastructureManagement: {
        title: 'Infrastructuurbeheer',
        subtitle: 'Beheer van servers, apparaten en VM\'s',
        description: 'Volledig infrastructuurbeheer: serverbeheer, apparaatbeheer en optimalisatie van virtuele machines.',
        features: ['Serverbeheer', 'Apparaatbeheer', 'VM-optimalisatie', 'Prestatiebewaking', 'Back-up en herstel']
      },
      databaseManagement: {
        title: 'Databasebeheer',
        subtitle: 'Inrichting, migratie en beheer',
        description: 'Databasebeheer van begin tot eind: inrichting, migratie, optimalisatie en doorlopend beheer.',
        features: ['Databases inrichten', 'Datamigratie', 'Prestatieoptimalisatie', '24/7 beheer', 'Back-up en herstel']
      },
      cloudWorkspace: {
        title: 'Cloudwerkplek',
        subtitle: 'Microsoft 365 & Google Workspace',
        description: 'Volledige inrichting en beheer van Microsoft 365- en Google Workspace-omgevingen.',
        features: ['M365 inrichten', 'Google Workspace beheren', 'Gebruikersbeheer', 'Beveiligingsconfiguratie', 'Ondersteuning bij migratie']
      },
      identityAccess: {
        title: 'Identiteits- en toegangsbeheer',
        subtitle: 'Active Directory, Okta & CyberArk',
        description: 'Veilig identiteits- en toegangsbeheer met gevestigde platforms.',
        features: ['Active Directory', 'Okta-integratie', 'CyberArk PAM', 'SSO-implementatie', 'Toegangscontrole']
      },
      automationDevops: {
        title: 'IT-automatisering en DevOps',
        subtitle: 'Scripting, CI/CD en procesautomatisering',
        description: 'Automatiseer IT-processen en werk volgens DevOps-principes, zodat alles efficiënter verloopt.',
        features: ['Procesautomatisering', 'CI/CD-pipelines', 'Scripts op maat', 'Workflowoptimalisatie', 'Monitoringtools']
      },
      serviceDesk: {
        title: 'Servicedesk inrichten',
        subtitle: 'Inrichting en configuratie van uw servicedesk',
        description: 'Wij richten uw servicedesk in en configureren hem, zodat uw IT-ondersteuning efficiënt verloopt.',
        features: ['Jira Service Desk', 'Jira Service Management', 'ServiceNow inrichten', 'YouTrack inrichten', 'Zammad configureren', 'Workflowontwerp', 'Ondersteuning bij integraties']
      },
      knowledgeManagement: {
        title: 'Kennisbeheer',
        subtitle: 'Confluence en kennisbanksystemen',
        description: 'Kennisbeheer voor betere documentatie en het delen van informatie.',
        features: ['Confluence inrichten', 'Ontwerp van de kennisbank', 'Documentatiestandaarden', 'Betere zoekfunctie', 'Contentbeheer']
      },
      webDevelopment: {
        title: 'Webontwikkeling',
        subtitle: 'Webapplicaties en websites op maat',
        description: 'Webontwikkeling, onderhoud en optimalisatie, op maat gemaakt voor bedrijven.',
        features: ['Webapps op maat', 'Websiteontwikkeling', 'Onderhoud en updates', 'Prestatieoptimalisatie', 'Beveiligingsmaatregelen']
      },
      itSupport: {
        title: 'IT-ondersteuning',
        subtitle: 'Helpdesk en technische ondersteuning',
        description: 'IT-helpdesk en technische ondersteuning die problemen snel oplost en uw systemen goed laat presteren.',
        features: ['24/7 technische ondersteuning', 'Helpdeskdiensten', 'Incidentafhandeling', 'Systeemmonitoring', 'Problemen analyseren en oplossen']
      },
      dataEngineering: {
        title: 'Data-engineering',
        subtitle: 'Datapijplijnen en analyse-infrastructuur',
        description: 'Robuuste datapijplijnen, ETL-processen en analyse-infrastructuur die ruwe gegevens omzetten in bruikbare inzichten, zodat u op basis van data kunt beslissen.',
        features: ['Datapijplijnen ontwikkelen', 'ETL/ELT-processen', 'Datawarehouse en data lake', 'Realtime verwerking', 'Datakwaliteit en governance']
      }
    },
    serviceOptions: {
      managedItSupport: 'IT-beheer & support',
      cloudInfrastructure: 'Cloud & infrastructuur',
      cybersecurityIdentity: 'Cybersecurity & identiteit',
      dataDatabases: 'Data & databases',
      aiAutomation: 'AI & automatisering',
      webSoftwareDevelopment: 'Web- & softwareontwikkeling',
      mobileAppDevelopment: 'App-ontwikkeling',
      crmDevelopment: 'CRM-systemen',
      erpSystems: 'ERP-systemen',
      other: 'Anders',
      otherLabel: 'Wat hebt u nog meer nodig?',
      otherPlaceholder: 'Vertel kort wat u nodig hebt…',
      otherRequired: 'Beschrijf kort wat u nodig hebt',
      otherRequiredDesc: 'U koos "Anders". Geef een korte beschrijving, dan kunnen we u verder helpen.'
    },
    about: {
      title: 'OVER BYTEET – IT-DIENSTEN IN NEDERLAND',
      subtitle: 'Wij zijn een vooruitstrevende IT-dienstverlener: we moderniseren de infrastructuur van bedrijven met nieuwe technologie.',
      description: 'Met meer dan tien jaar ervaring specialiseert ons team van gecertificeerde professionals zich in Device Management, cloudadministratie en automatisering.',
      yearsExperience: 'Jaar ervaring',
      yearsExperienceSubtitle: 'Ervaren engineers die de nieuwste technologie bijhouden',
      projectsCompleted: 'Projecten afgerond',
      excellence: {
        title: 'Kwaliteit',
        description: 'We documenteren, testen en dragen alles netjes over.'
      },
      partnership: {
        title: 'Partnerschap',
        description: 'Langdurige samenwerking, gebouwd op vertrouwen.'
      },
      efficiency: {
        title: 'Efficiëntie',
        description: 'Processen stroomlijnen met automatisering en best practices.'
      },
      security: {
        title: 'Beveiliging',
        description: 'Uw systemen en gegevens beschermen met beveiliging op enterpriseniveau.'
      }
    },
    contact: {
      title: 'NEEM CONTACT OP – IT-DIENSTEN IN NEDERLAND',
      subtitle: 'Wilt u uw IT-infrastructuur vernieuwen? We bespreken graag hoe we uw bedrijf verder kunnen helpen.',
      form: {
        name: 'Volledige naam',
        email: 'E-mailadres',
        company: 'Bedrijfsnaam',
        phone: 'Telefoonnummer',
        services: 'Gewenste diensten',
        budget: 'Budget',
        timeline: 'Planning',
        teamSize: 'Teamgrootte',
        message: 'Over uw project',
        submit: 'Verstuur bericht',
        submitting: 'Verzenden...',
        success: 'Uw bericht is verzonden!',
        error: 'Vul alle verplichte velden in.'
      },
      budgetRanges: {
        under5k: 'Minder dan € 5.000',
        '5k-10k': '€ 5.000 – € 10.000',
        '10k-20k': '€ 10.000 – € 20.000',
        '20k-30k': '€ 20.000 – € 30.000',
        '30k+': 'Vanaf € 30.000'
      },
      timelines: {
        asap: 'Zo snel mogelijk (binnen 1 maand)',
        '1-3months': '1-3 maanden',
        '3-6months': '3-6 maanden',
        '6months+': 'Meer dan 6 maanden'
      },
      teamSizes: {
        '1-5': '1-5 personen',
        '6-20': '6-20 personen',
        '21-50': '21-50 personen',
        '50+': 'Meer dan 50 personen'
      },
      contactInfo: {
        email: 'E-mail',
        phone: 'Telefoon',
        location: 'Locatie'
      }
    },
    footer: {
      description: 'Professionele IT-diensten voor moderne bedrijven in Nederland. We zijn gespecialiseerd in apparaatbeheer, cloudbeheer en automatisering.',
      services: 'DIENSTEN',
      pages: 'PAGINA\'S',
      company: 'BEDRIJF',
      copyright: 'Alle rechten voorbehouden.',
      privacyPolicy: 'Privacybeleid',
      termsOfService: 'Algemene voorwaarden'
    },
    forms: {
      alerts: {
        selectService: 'Selecteer ten minste één dienst',
        selectServiceDesc: 'Selecteer ten minste één dienst om verder te gaan.',
        selectBudget: 'Kies een budget',
        selectBudgetDesc: 'Kies een budget om verder te gaan.',
        success: 'Uw aanvraag is verzonden!',
        successDesc: 'We bekijken uw wensen en nemen binnen 24 uur contact met u op met een voorstel en een offerte op maat.'
      },
      serviceInquiry: {
        title: 'Offerte aanvragen',
        subtitle: 'Een paar korte vragen. Een gesprek is optioneel.',
        previous: 'Vorige',
        next: 'Volgende',
        send: 'Versturen',
        sending: 'Bezig met versturen…',
        steps: {
          need: { rail: 'Wat u nodig heeft', title: 'Wat heeft u nodig?', desc: 'Kies alles wat van toepassing is.' },
          project: { rail: 'Uw project', title: 'Uw project', desc: 'Een globaal idee is genoeg. De rest vragen we later.' },
          contact: { rail: 'Contact', title: 'Hoe bereiken we u?', desc: 'We antwoorden per e-mail. Een telefoonnummer is optioneel.' },
          call: { rail: 'Gesprek', title: 'Wilt u het even doorspreken?', desc: '{minutes} minuten via Google Meet, gratis en vrijblijvend.' }
        },
        projectLabel: 'In een paar zinnen',
        projectPlaceholder: 'Wat u wilt bouwen, oplossen of verbeteren, en waarom.',
        aiHint: 'Lastig te verwoorden? Laat uw AI-assistent het opstellen.',
        aiSteps: 'Plak dit in uw AI-assistent, beantwoord de drie vragen en plak het resultaat in het veld hierboven.',
        showPrompt: 'Toon prompt',
        hidePrompt: 'Verberg prompt',
        copyPrompt: 'Prompt kopiëren',
        copied: 'Gekopieerd',
        copySelected: 'Geselecteerd. Druk op Ctrl+C (of Cmd+C) om te kopiëren.',
        budget: 'Budget',
        timeline: 'Planning',
        callYes: 'Ja, plan een gesprek',
        callNo: 'Nee, alleen versturen',
        callUnavailable: 'Online plannen is nu niet beschikbaar; we mailen u om een moment af te spreken.',
        pickTime: 'Kies een tijd voor het gesprek, of kies “Nee, alleen versturen”.',
        alreadySent: 'Uw bericht hebben we al ontvangen.',
        bookingFailed: 'Uw bericht hebben we ontvangen, maar het gesprek kon niet worden ingepland. Probeer het opnieuw, of kies “Nee, alleen versturen”; dan mailen we u om een moment af te spreken.',
        nameRequired: 'Vul uw naam in.',
        emailInvalid: 'Vul een geldig e-mailadres in.',
        servicesLabel: 'Diensten',
        sendFailed: 'Uw aanvraag kon niet worden verzonden. Probeer het opnieuw of mail ons op {email}.',
        received: 'Ontvangen.',
        receivedNext: 'We lezen uw aanvraag en sturen ons antwoord naar {email}.',
        receivedNextCall: 'We lezen uw aanvraag voor het gesprek door.',
        aiPrompt: 'Ik wil een IT-bedrijf benaderen over een project. Stel me deze drie vragen, één voor één, en wacht steeds op mijn antwoord:\n1) Wat wil je bouwen, oplossen of verbeteren?\n2) Wat gebruik je nu, en wat werkt er niet?\n3) Hoe ziet een goed resultaat er voor jou uit?\nSchrijf daarna een duidelijke projectomschrijving van maximaal 120 woorden, in de ik-vorm en in gewone taal, zonder iets toe te voegen wat ik niet heb gezegd.',
        formLabels: {
          fullName: 'Volledige naam',
          emailAddress: 'E-mailadres',
          company: 'Bedrijf',
          phoneNumber: 'Telefoonnummer',
          servicesOfInterest: 'Diensten waarin u interesse hebt',
          servicesOfInterestDesc: '(selecteer alles wat van toepassing is)',
          budgetRange: 'Budget',
          projectTimeline: 'Planning',
          teamSize: 'Teamgrootte',
          projectDetails: 'Projectdetails en wensen'
        },
        placeholders: {
          enterFullName: 'Vul uw volledige naam in',
          enterEmail: 'Vul uw e-mailadres in',
          enterCompany: 'Vul uw bedrijfsnaam in',
          enterPhone: 'Vul uw telefoonnummer in',
          selectTimeline: 'Kies een planning',
          selectTeamSize: 'Kies de teamgrootte',
          projectDetailsPlaceholder: 'Vertel ons over uw project: uw wensen, de uitdagingen en andere details waarmee we een betere offerte kunnen maken...'
        }
      }
    },
    contactPage: {
      serviceInquiryForm: 'Offerte op maat',
      serviceInquirySubtitle: 'Vraag een offerte op maat aan voor uw IT-project',
      contactInformation: 'Contactgegevens',
      followUs: 'Volg ons',
      quickContact: 'Direct contact',
      quickContactDesc: 'Hebt u meteen hulp nodig? Neem rechtstreeks contact met ons op.',
      sendEmail: 'Stuur een e-mail',
      selectTimeline: 'Kies een planning',
      selectTeamSize: 'Kies de teamgrootte',
      projectDetailsPlaceholder: 'Vertel ons over uw project: uw wensen, de uitdagingen en andere details waarmee we een betere offerte kunnen maken...',
      privacyConsent: 'Met het verzenden van dit formulier gaat u akkoord met ons privacybeleid en geeft u ons toestemming om contact met u op te nemen over uw aanvraag.',
      servicesSelectAll: '(selecteer alles wat van toepassing is)'
    },
    booking: {
      label: 'Plan een gesprek',
      lead: 'Plan',
      tail: 'een gesprek',
      intro: '{minutes} minuten via Google Meet over uw IT of de software die u nodig heeft. Kies hieronder een moment; de uitnodiging komt rechtstreeks uit onze agenda.',
      expectLabel: 'Wat u kunt verwachten',
      lengthTerm: 'Duur',
      lengthValue: '{minutes} minuten',
      whereTerm: 'Waar',
      whereValue: 'Google Meet. De link staat in de agenda-uitnodiging.',
      costTerm: 'Kosten',
      costValue: 'Gratis en vrijblijvend.',
      aboutTerm: 'Waar we het over hebben',
      aboutValue: 'Uw huidige situatie, wat u wilt veranderen en of wij daar het juiste team voor zijn.',
      languageTerm: 'Taal',
      languageValue: 'Nederlands of Engels.',
      preferContact: 'Liever mailen of bellen?',
      schedulerLabel: 'Agenda',
      pickDay: 'Kies een dag',
      pickTime: 'Kies een tijd',
      timezoneNote: 'Tijden in Nederlandse tijd',
      timezoneShort: 'Nederlandse tijd',
      loading: 'Beschikbare tijden laden…',
      dayFull: 'Geen tijden',
      noSlotsDay: 'Op deze dag zijn geen tijden vrij. Kies een andere dag.',
      noSlotsAll: 'De komende weken zijn er geen tijden vrij.',
      yourDetails: 'Uw gegevens',
      selected: 'Gekozen tijd',
      changeTime: 'Andere tijd',
      name: 'Naam',
      email: 'E-mailadres',
      company: 'Bedrijf',
      topic: 'Waar wilt u het over hebben?',
      optional: 'optioneel',
      honeypot: 'Laat dit veld leeg',
      confirm: 'Afspraak bevestigen',
      submitting: 'Bezig met inplannen…',
      privacyBefore: 'Uw gegevens komen in de agenda-uitnodiging voor dit gesprek. Zie ons ',
      privacyLink: 'privacybeleid',
      privacyAfter: '.',
      errors: {
        load: 'De agenda kon niet worden geladen.',
        retry: 'Opnieuw proberen',
        taken: 'Dit tijdstip is zojuist geboekt. Kies een ander moment.',
        invalid: 'Controleer uw naam en e-mailadres, en laat links weg uit de velden bedrijf en onderwerp.',
        unavailable: 'Online plannen is op dit moment niet beschikbaar.',
        rateLimited: 'Te veel pogingen vanaf deze verbinding.',
        generic: 'De afspraak is niet gelukt.',
        fallbackBefore: 'Mail ons op ',
        fallbackAfter: ', dan zoeken we samen een moment.'
      },
      success: {
        label: 'Bevestigd',
        title: 'Geboekt.',
        when: 'Wanneer',
        meet: 'Google Meet',
        meetPending: 'De Meet-link staat in de uitnodiging.',
        invite: 'Er is een agenda-uitnodiging verstuurd naar {email}, met de Meet-link erin.',
        back: 'Terug naar home'
      }
    },
    floatingHelp: {
      needHelp: 'Hulp nodig?',
      weAreHere: 'We staan voor u klaar!',
      getServiceQuote: 'Vraag een offerte aan',
      backToTop: 'Terug naar boven',
      close: 'Sluiten',
      tooltip: 'Hulp nodig? Klik hier!'
    },
    portfolio: {
      title: 'Klantcases & succesverhalen',
      subtitle: 'Echte resultaten voor het mkb. Bekijk wat ons werk meetbaar heeft opgeleverd in managed IT-beheer, cloud, cybersecurity, data en maatwerksoftware.',
      viewAll: 'Bekijk alle projecten',
      technologiesUsed: 'Gebruikte technologieën:',
      keyResults: 'Belangrijkste resultaten:',
      viewProject: 'Bekijk details',
      openWebsite: 'Naar de website',
      viewDetails: 'Bekijk details',
      recentWork: 'RECENT WERK',
      recentWorkSubtitle: 'Een overzicht van onze nieuwste projecten en geslaagde implementaties, in uiteenlopende branches en technologieën.',
      categories: {
        infrastructure: 'Infrastructuur',
        deviceManagement: 'Apparaatbeheer',
        security: 'Beveiliging',
        automation: 'Automatisering',
        cloudInfrastructure: 'Cloudinfrastructuur',
        devopsAutomation: 'DevOps en automatisering',
        securityIAM: 'Security & IAM',
        itOperations: 'IT-beheer',
        documentation: 'Documentatie',
        webDevelopment: 'Webontwikkeling',
        serviceDesk: 'Servicedesk'
      },
      projects: {
        mundusCrasWebsite: {
          title: 'Mundus Cras – Advies voor senior management',
          description: 'Tweetalige website en contentplatform voor Mundus Cras, een adviespraktijk voor senior management in Nederland en de Verenigde Arabische Emiraten. Dertien pagina\'s in het Engels en Nederlands, een headless CMS met beheeromgeving voor artikelen, een gestructureerde aanvraagstroom en een consentsysteem voor analytics.',
          results: ['Dertien pagina\'s in het Engels en Nederlands', 'Headless CMS met beheeromgeving', 'Gestructureerde aanvraagstroom', 'Consentbeheer voor analytics']
        },
        deHorecaBrigadeWebsite: {
          title: 'De Horeca Brigade – juridische dienstverlening voor de horeca',
          description: 'Huisstijl en tweetalige website voor De Horeca Brigade, een Nederlands bureau dat horecaondernemers helpt met juridische zaken en regelgeving, van vergunningen tot compliance. Het team publiceert zelf dienstpagina\'s en kennisbankartikelen via een ingebouwde beheeromgeving.',
          results: ['Huisstijl en styleguide', 'Tweetalige site (NL/EN) met URL\'s per taal', 'Interactieve wegwijzer naar de juiste dienst', 'Eigen beheeromgeving voor artikelen, prijzen en aanvragen']
        },
        ironLadyWebsite: {
          title: 'The Iron Lady – website voor een steakhouse in Rotterdam',
          description: 'Tweetalige website voor The Iron Lady, een steakhouse en cocktailbar in het centrum van Rotterdam. De volledige spijs- en drankkaart is opgezet als gestructureerde content die de eigenaren zelf bewerken. Online een tafel reserveren zit er direct in.',
          results: ['Tweetalige site (NL/EN)', 'Beheeromgeving voor kaart, foto\'s en content', 'Volledige spijs- en drankkaart', 'Online reserveren']
        },
        fatFoxWebsite: {
          title: 'The Fat Fox – website voor een pub en steakhouse in Rotterdam',
          description: 'Tweetalige website voor The Fat Fox, een Engelse pub en steakhouse met houtskoolgrill in de Witte de With-buurt in Rotterdam. De eigenaren beheren de kaart, met meer dan 150 drankjes, in hun eigen beheeromgeving, en gasten reserveren online een tafel.',
          results: ['Tweetalige site (NL/EN)', 'Beheeromgeving voor kaart en content', 'Spijs- en drankkaart met 150+ drankjes', 'Online reserveren']
        },
        morenaWebsite: {
          title: 'Morena – Latijns restaurant en cocktailbar in Rotterdam',
          description: 'Volledig opnieuw gebouwde website voor Morena, een pan-Latijns-Amerikaans restaurant en cocktailbar in de MaHo-wijk in Rotterdam. De eigenaren bewerken zelf de kaart en kiezen welke gerechten op de homepage worden uitgelicht.',
          results: ['Volledig opnieuw gebouwde morenarotterdam.nl', 'Tweetalige site (NL/EN)', 'Beheeromgeving voor kaart en uitgelichte gerechten', 'Online reserveren']
        },
        nouraWebsite: {
          title: 'Noura – Levantijns restaurant in Rotterdam',
          description: 'Tweetalige website voor Noura, een Levantijns restaurant in Rotterdam, ontworpen rond de huisstijl van het restaurant. De eigenaren beheren de openingstijden, de kaart en de inhoud van de pagina\'s via een beheerconsole op een eigen admin-subdomein.',
          results: ['Tweetalige site (NL/EN)', 'Ontwerp gebaseerd op de huisstijl van Noura', 'Beheerconsole voor openingstijden, kaart en pagina\'s', 'Kaart met Arabische namen van gerechten en dieetlabels']
        },
        sportaMdWebsite: {
          title: 'Sporta MD – website voor een sportreserveringsplatform',
          description: 'Website voor Sporta MD, een mobiele app om in Chișinău vriendschappelijke wedstrijden te boeken in voetbal, basketbal, volleybal, tennis en padel. De drietalige site (RO/RU/EN) bevat pagina\'s per sport, een stadiongids met kaarten, de juridische documenten en de openbare API-documentatie, plus de deep links en e-mailbevestiging die gebruikers naar de app leiden.',
          results: ['Drietalige site (RO/RU/EN)', 'Stadiongids met Google Maps', 'API-documentatie op docs.sporta.md', 'Deep links en doorverwijzing naar de appstores']
        },
        jamfDeviceManagement: {
          title: 'Apparaatbeheer op enterpriseniveau',
          description: '150+ apparaten ingeschreven en geconfigureerd met Jamf Pro (MDM), inclusief uitgebreid apparaatbeheer en beveiligingsbeleid op enterpriseniveau.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie had moeite om een groeiend aantal macOS-apparaten op meerdere locaties te beheren:',
            challenges: [
              'Handmatige configuratie zorgde voor verschillen tussen apparaten',
              'Er was geen centrale manier om beveiligingsbeleid af te dwingen',
              'Apparaten inschrijven en inrichten kostte veel tijd',
              'De apparaatinventaris was lastig bij te houden en te beheren',
              'Software kon niet automatisch worden uitgerold'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Jamf Pro (MDM) ingevoerd om apparaatbeheer te centraliseren en de uitrol te automatiseren.',
            process: [
              { step: 'Inventarisatie', icon: 'clipboard', description: 'Apparaten en eisen in kaart gebracht' },
              { step: 'Jamf inrichten', icon: 'server', description: 'Jamf Pro-server en beleid geconfigureerd' },
              { step: 'Inschrijving', icon: 'users', description: '150+ apparaten automatisch ingeschreven' },
              { step: 'Beleid toepassen', icon: 'shield', description: 'Beveiligings- en beheerbeleid toegepast' }
            ]
          },
          results: ['150+ apparaten ingeschreven', 'Centraal beheer', 'Beveiligingsbeleid toegepast', 'Oplossing op enterpriseniveau']
        },
        activeDirectoryManagement: {
          title: 'Active Directory-infrastructuur',
          description: 'Uitgebreid Active Directory-beheer ingericht, met configuratie van groepsbeleid, accountbeheer van indiensttreding tot vertrek, geautomatiseerde onboarding en PowerShell-scripts op maat.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie verloor veel tijd met inefficiënt gebruikers- en apparaatbeheer:',
            challenges: [
              'Accounts handmatig aanmaken kostte uren per medewerker',
              'Het beveiligingsbeleid verschilde per afdeling',
              'Accounts werden niet automatisch beheerd van indiensttreding tot vertrek',
              'Groepsbeleid configureren kostte veel tijd',
              'Er was geen centraal identiteitsbeheer'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Een uitgebreide Active Directory-infrastructuur ontworpen en ingericht, met automatisering.',
            process: [
              { step: 'Architectuurontwerp', icon: 'layout', description: 'AD-structuur en OU-hiërarchie ontworpen' },
              { step: 'Groepsbeleid inrichten', icon: 'settings', description: 'Beveiligings- en beheerbeleid geconfigureerd' },
              { step: 'Automatiseringsscripts', icon: 'terminal', description: 'Automatiseringsworkflows in PowerShell ontwikkeld' },
              { step: 'Accountlevenscyclus', icon: 'refresh-cw', description: 'Onboarding en offboarding geautomatiseerd' }
            ]
          },
          results: ['Groepsbeleid ingericht', 'Geautomatiseerde onboarding van gebruikers', 'Automatisering met PowerShell', 'Geoptimaliseerde infrastructuur']
        },
        googleWorkspaceSetup: {
          title: 'Google Workspace inrichten en beheren',
          description: 'Uitgebreide implementatie van Google Workspace voor 150+ medewerkers, met organisatie-eenheden, beveiligingsbeleid, configuratie van Google Groups en accountbeheer met automatische accountaanmaak.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie moest overstappen op Google Workspace, maar liep tegen een aantal obstakels aan:',
            challenges: [
              'Complexe migratie vanaf verouderde e-mailsystemen',
              'De organisatiestructuur moest worden afgestemd',
              'Eisen op het gebied van beveiliging en compliance',
              'Zorgen over training en acceptatie door gebruikers',
              'Integratie met bestaande systemen'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Een volledige Google Workspace-implementatie opgeleverd, met automatische accountaanmaak en beveiliging.',
            process: [
              { step: 'Planning', icon: 'map', description: 'OU-structuur en migratieplan ontworpen' },
              { step: 'Configuratie', icon: 'cog', description: 'Beveiligingsbeleid en groepen ingesteld' },
              { step: 'Migratie', icon: 'arrow-right', description: '150+ gebruikers zonder onderbreking gemigreerd' },
              { step: 'Automatisering', icon: 'zap', description: 'Workflows voor automatische accountaanmaak ingericht' }
            ]
          },
          results: ['150+ medewerkers ingericht', 'OU-structuur ontworpen', 'Beveiligingsbeleid toegepast', 'Google Groups ingericht', 'Automatische accountaanmaak']
        },
        jiraServiceManagement: {
          title: 'Implementatie van Jira Service Management',
          description: 'Een uitgebreide helpdesk ingericht met Atlassian JSM, met geavanceerde automatisering, ticketroutering op maat, SLA-beheer en geïntegreerde rapportagedashboards, zodat de IT-ondersteuning soepeler verloopt.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie had één centrale servicedesk nodig, maar liep in de praktijk tegen problemen aan:',
            challenges: [
              'Versnipperde supportkanalen zorgden voor zoekgeraakte tickets en vertraging',
              'Er was geen standaardproces voor het afhandelen van IT-aanvragen',
              'SLA-naleving en prestaties waren lastig te volgen',
              'Zonder selfservice nam de werkdruk van de support toe',
              'Handmatige ticketroutering werkte inefficiënt'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Jira Service Management ingericht met automatisering, een selfserviceportaal en uitgebreide rapportage.',
            process: [
              { step: 'Analyse van eisen', icon: 'clipboard', description: 'Supportworkflows en eisen geanalyseerd' },
              { step: 'JSM configureren', icon: 'settings', description: 'JSM-omgeving en workflows voor meerdere regio\'s ingericht' },
              { step: 'Automatisering inrichten', icon: 'zap', description: 'Automatische routering en workflows geconfigureerd' },
              { step: 'Portaal en training', icon: 'users', description: 'Selfserviceportaal gelanceerd en supportmedewerkers getraind' }
            ]
          },
          results: ['10 IT-supportmedewerkers', 'Configuratie voor meerdere regio\'s', 'Selfserviceportaal', 'Geautomatiseerde workflows', 'SLA-beheer', 'Rapportagedashboards']
        },
        zammadServiceDesk: {
          title: 'Zammad-servicedesk met LDAP-integratie',
          description: 'Een robuuste servicedesk gebouwd met Zammad, met LDAP-integratie, automatische accountaanmaak, rolgebaseerde toegang en workflowautomatisering op maat, zodat de support efficiënter werkt.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie had een opensource-servicedesk nodig die met de directory was gekoppeld:',
            challenges: [
              'Er was behoefte aan een betaalbare servicedesk',
              'Koppeling met LDAP/Active Directory was een vereiste',
              'Handmatig gebruikersbeheer kostte de IT-afdeling veel tijd',
              'Er was geen rolgebaseerde toegangscontrole',
              'Workflows konden niet worden geautomatiseerd'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Zammad ingericht met LDAP-integratie en workflows voor automatische accountaanmaak.',
            process: [
              { step: 'Zammad implementeren', icon: 'server', description: 'Zammad-platform geïnstalleerd en geconfigureerd' },
              { step: 'LDAP-integratie', icon: 'link', description: 'Via LDAP gekoppeld aan Active Directory' },
              { step: 'RBAC inrichten', icon: 'shield', description: 'Rolgebaseerde toegangscontrole geconfigureerd' },
              { step: 'Automatisering', icon: 'zap', description: 'Automatische accountaanmaak ingericht' }
            ]
          },
          results: ['LDAP-integratie', 'Automatische accountaanmaak', 'Rolgebaseerde toegangscontrole', 'Workflowautomatisering op maat', 'Efficiëntere support']
        },
        gravlDocumentation: {
          title: 'Documentatiewebsite met Gravl',
          description: 'Een moderne, responsieve documentatiewebsite gebouwd met Gravl CMS, met een uitgebreide zoekfunctie, versiebeheer, meertaligheid en duidelijke navigatie voor omvangrijke technische documentatie.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie had een modern documentatieplatform nodig, maar de bestaande documentatie schoot op meerdere punten tekort:',
            challenges: [
              'Documentatie stond verspreid over meerdere plekken',
              'Het contentmanagementsysteem was verouderd',
              'Door de slechte zoekfunctie was informatie moeilijk te vinden',
              'Er was geen versiebeheer voor wijzigingen in de documentatie',
              'Ondersteuning voor meerdere talen was beperkt'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Een moderne documentatiewebsite gebouwd met Gravl CMS, met geavanceerde functies.',
            process: [
              { step: 'Contentaudit', icon: 'search', description: 'Bestaande documentatiestructuur geanalyseerd' },
              { step: 'Gravl inrichten', icon: 'code', description: 'Gravl CMS-platform geconfigureerd' },
              { step: 'Migratie', icon: 'arrow-right', description: 'Content gemigreerd met versiebeheer' },
              { step: 'Uitbreiding', icon: 'rocket', description: 'Zoekfunctie en meertaligheid toegevoegd' }
            ]
          },
          results: ['Modern documentatieplatform', 'Geavanceerde zoekfunctie', 'Versiebeheer', 'Meertalig', 'Duidelijke navigatie']
        },
        activeDirectoryEnrollment: {
          title: 'Grootschalige apparaatinschrijving via Active Directory',
          description: '80+ bedrijfsapparaten aan het Active Directory-domein toegevoegd en geconfigureerd, met uitgebreid groepsbeleid, beveiligingsinstellingen en centraal beheer voor betere IT-governance.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie moest apparaten in Active Directory opnemen, maar het inschrijven verliep moeizaam:',
            challenges: [
              'Apparaten handmatig inschrijven duurde te lang',
              'Beveiligingsinstellingen verschilden per apparaat',
              'Er was geen centrale manier om apparaatbeleid te beheren',
              'Compliancestandaarden waren lastig af te dwingen',
              'Apparaten konden niet automatisch worden ingericht'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Apparaten automatisch ingeschreven via Active Directory, met uitgebreid beleidsbeheer.',
            process: [
              { step: 'AD voorbereiden', icon: 'server', description: 'Active Directory voorbereid op het inschrijven van apparaten' },
              { step: 'Beleidsontwerp', icon: 'settings', description: 'Groepsbeleid en beveiligingsinstellingen ontworpen' },
              { step: 'Inschrijving', icon: 'users', description: '80+ apparaten aan het domein toegevoegd' },
              { step: 'Governance', icon: 'shield', description: 'Centraal beheerbeleid toegepast' }
            ]
          },
          results: ['80+ apparaten ingeschreven', 'Uitgebreid groepsbeleid', 'Beveiligingsinstellingen toegepast', 'Centraal beheer', 'Betere IT-governance']
        },
        windowsInstallationAutomation: {
          title: 'Geautomatiseerde Windows-installatie',
          description: 'Een systeem ontwikkeld dat Windows automatisch installeert vanaf opstartbare USB-sticks, met eigen uitrolscripts, ingebouwde drivers, vooraf geïnstalleerde software en onbeheerde installatie, zodat apparaten snel klaar zijn voor gebruik.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie wilde Windows-installaties stroomlijnen, maar de uitrol liep tegen problemen aan:',
            challenges: [
              'Windows handmatig installeren kostte uren per apparaat',
              'De geïnstalleerde software verschilde per apparaat',
              'Drivers installeren en configureren kostte veel tijd',
              'Er was geen standaard uitrolproces',
              'Software vooraf installeren was lastig te beheren'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Een geautomatiseerd Windows-installatiesysteem gebouwd met eigen uitrolscripts.',
            process: [
              { step: 'Scriptontwikkeling', icon: 'terminal', description: 'Uitrolscripts op maat ontwikkeld' },
              { step: 'USB-stick maken', icon: 'server', description: 'Opstartbare USB-stick met drivers en software gemaakt' },
              { step: 'Testen', icon: 'settings', description: 'Onbeheerde installatie getest' },
              { step: 'Uitrol', icon: 'rocket', description: 'Systeem voor het snel inrichten van apparaten in gebruik genomen' }
            ]
          },
          results: ['Geautomatiseerde installatie', 'Uitrolscripts op maat', 'Drivers inbegrepen', 'Software vooraf geïnstalleerd', 'Apparaten snel inzetbaar']
        },
        googleWorkspaceManagement: {
          title: 'Inrichting en beheer van Google Workspace',
          description: 'Uitgebreide implementatie van Google Workspace: accounts aanmaken, beveiligingsbeleid configureren, gegevens migreren, applicaties koppelen en doorlopend beheer, voor optimale productiviteit en samenwerking.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie had uitgebreid beheer van Google Workspace nodig, maar liep tegen praktische problemen aan:',
            challenges: [
              'Gebruikersaccounts aanmaken en beheren was complex',
              'Beveiligingsbeleid en compliance moesten worden ingericht',
              'Gegevens moesten worden gemigreerd vanaf verouderde systemen',
              'Applicaties moesten worden gekoppeld',
              'Er was behoefte aan doorlopend beheer en optimalisatie'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Een volledige Google Workspace-implementatie opgeleverd, met automatische accountaanmaak en doorlopend beheer.',
            process: [
              { step: 'Planning', icon: 'map', description: 'Implementatie- en migratiestrategie ontworpen' },
              { step: 'Configuratie', icon: 'cog', description: 'Beveiligingsbeleid en koppelingen geconfigureerd' },
              { step: 'Migratie', icon: 'arrow-right', description: 'Gegevens en gebruikers zonder onderbreking gemigreerd' },
              { step: 'Beheer', icon: 'refresh-cw', description: 'Processen voor doorlopend beheer ingericht' }
            ]
          },
          results: ['Accountaanmaak', 'Beveiligingsbeleid geconfigureerd', 'Gegevensmigratie afgerond', 'Applicaties gekoppeld', 'Doorlopend beheer']
        },
        wordpressPlatform: {
          title: 'WordPress-platform',
          description: 'Een WordPress-multisitenetwerk met hoge prestaties.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie had een schaalbaar WordPress-platform nodig, maar liep tegen de grenzen van de infrastructuur aan:',
            challenges: [
              'Er was behoefte aan een multisitenetwerk',
              'Eisen aan prestaties en schaalbaarheid',
              'Meerdere sites moesten centraal worden beheerd',
              'Resources moesten efficiënter en goedkoper worden ingezet',
              'Zorgen over beveiliging en onderhoud'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Een WordPress-multisitenetwerk met hoge prestaties ingericht op geoptimaliseerde infrastructuur.',
            process: [
              { step: 'Architectuurontwerp', icon: 'layout', description: 'Architectuur van het multisitenetwerk ontworpen' },
              { step: 'Infrastructuur inrichten', icon: 'server', description: 'Snelle hosting geconfigureerd' },
              { step: 'Optimalisatie', icon: 'zap', description: 'Prestaties en resources geoptimaliseerd' },
              { step: 'Uitrol', icon: 'rocket', description: 'Multisiteplatform in gebruik genomen' }
            ]
          },
          results: ['Multisitenetwerk', 'Hoge prestaties', 'Schaalbare infrastructuur', 'Centraal beheer', 'Efficiënt gebruik van resources']
        },
        caseCloudWorkspace: {
          title: 'Cloudwerkplek',
          description: 'Samenwerking gemoderniseerd met een migratie naar Microsoft 365: veilig bestanden delen, Teams voor communicatie en nauwkeurig ingestelde toegangsrechten. MFA en DLP-beleid ingevoerd om gegevens te beveiligen, plus standaard onboardingsjablonen voor nieuwe gebruikers.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie wilde de samenwerking moderniseren, maar de bestaande werkomgeving hield dat tegen:',
            challenges: [
              'Verouderde systemen voor e-mail en bestandsdeling beperkten de samenwerking',
              'Er waren zorgen over de beveiliging van gedeelde gegevens en toegangsrechten',
              'Er was geen centraal communicatieplatform',
              'Mappenstructuren en rechten waren niet consistent',
              'Er was geen standaard onboardingproces voor nieuwe gebruikers'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Overgestapt op Microsoft 365, met uitgebreide beveiliging en samenwerkingsfuncties.',
            process: [
              { step: 'Migratieplanning', icon: 'map', description: 'Migratiestrategie zonder downtime ontworpen' },
              { step: 'M365 inrichten', icon: 'server', description: 'M365 geconfigureerd met Teams en SharePoint' },
              { step: 'Beveiliging', icon: 'shield', description: 'MFA en DLP-beleid ingevoerd' },
              { step: 'Standaardisatie', icon: 'settings', description: 'Standaardsjablonen en -processen opgesteld' }
            ]
          },
          results: ['M365-migratie zonder downtime', '2FA/MFA verplicht voor alle gebruikers', 'Standaard mappenstructuur en rechten', '80% minder e-mailbijlagen']
        },
        caseDatabaseManagement: {
          title: 'Modernisering van databasebeheer',
          description: 'Versnipperde bedrijfsgegevens samengebracht in een beheerde Oracle-omgeving met geplande back-ups, monitoring en rolgebaseerde toegang. Lichte dashboards gebouwd voor rapportage in bijna realtime.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie worstelde met databasebeheer en versnipperde gegevens:',
            challenges: [
              'Gegevens stonden verspreid over meerdere systemen en locaties',
              'Trage query\'s hinderden het dagelijkse werk',
              'Back-up en herstel waren niet geautomatiseerd',
              'Er was geen rolgebaseerde toegangscontrole',
              'Realtime rapporten en dashboards waren lastig te maken'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Gegevens samengebracht in een beheerde Oracle-omgeving, met automatisering en monitoring.',
            process: [
              { step: 'Gegevensanalyse', icon: 'clipboard', description: 'Versnipperde gegevensbronnen geanalyseerd' },
              { step: 'Oracle inrichten', icon: 'server', description: 'Beheerde Oracle-omgeving ingericht' },
              { step: 'Migratie en optimalisatie', icon: 'arrow-right', description: 'Gegevens gemigreerd en geoptimaliseerd' },
              { step: 'Monitoring en dashboards', icon: 'settings', description: 'Monitoring en rapportagedashboards ingericht' }
            ]
          },
          results: ['Oracle in de cloud met geautomatiseerde back-ups', 'RBAC voor management en operations', 'Querytijd teruggebracht van minuten naar seconden', 'Operationele dashboards voor KPI\'s']
        },
        caseDeviceManagement: {
          title: 'Centraal apparaatbeheer',
          description: 'Microsoft Intune uitgerold met een basisbeveiligingsbeleid, apparaatversleuteling en appcatalogi. Automatische inschrijving ingericht om apparaten sneller klaar te zetten, plus wissen op afstand voor verloren apparaten.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie had centraal apparaatbeheer nodig, maar stuitte op een aantal problemen:',
            challenges: [
              'Er was geen centrale manier om bedrijfsapparaten te beheren',
              'Het beveiligingsbeleid verschilde per apparaat',
              'Apparaten klaarzetten kostte veel tijd',
              'Apparaatversleuteling en beveiligingsmaatregelen ontbraken',
              'Goedgekeurde software en apps waren lastig te beheren'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Microsoft Intune ingevoerd voor centraal apparaatbeheer en beveiliging.',
            process: [
              { step: 'Intune-planning', icon: 'map', description: 'Implementatiestrategie voor Intune ontworpen' },
              { step: 'Beleidsconfiguratie', icon: 'settings', description: 'Beveiligingsbeleid en versleuteling geconfigureerd' },
              { step: 'Automatische inschrijving', icon: 'zap', description: 'Automatische inschrijving van apparaten ingericht' },
              { step: 'Appcatalogus', icon: 'server', description: 'Catalogus met goedgekeurde software opgezet' }
            ]
          },
          results: ['Intune-inschrijving in het hele bedrijf', 'Volledige schijfversleuteling verplicht', 'Appcatalogus met goedgekeurde software', 'Onboardingtijd 60% korter']
        },
        caseWindowsAutomatedDeployment: {
          title: 'Geautomatiseerde uitrol van Windows-apparaten',
          description: 'Een opstartbare USB-stick gemaakt die automatisch Windows installeert, apparaten aan het Active Directory-domein toevoegt en de benodigde tools en drivers installeert, voor een accountantskantoor met 30+ apparaten.',
          problem: {
            title: 'De uitdaging',
            description: 'Een accountantskantoor zocht de eenvoudigste en goedkoopste manier om 30+ Windows-apparaten te beheren die zonder Windows werden geleverd:',
            challenges: [
              'De apparaten werden geleverd zonder Windows',
              'Handmatig installeren zou voor 30+ apparaten veel tijd kosten',
              'De apparaten moesten automatisch aan het Active Directory-domein worden toegevoegd',
              'Op elk apparaat moesten de benodigde tools en drivers komen',
              'Een klein accountantskantoor had een betaalbare oplossing nodig'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Een opstartbare USB-stick ontwikkeld die de hele installatie en configuratie van Windows automatiseert.',
            process: [
              { step: 'USB-stick maken', icon: 'server', description: 'Opstartbare USB-stick met Windows-installatiemedia gemaakt' },
              { step: 'Automatiseringsscripts', icon: 'code', description: 'Scripts voor automatische Windows-installatie ontwikkeld' },
              { step: 'Domeinkoppeling', icon: 'link', description: 'Automatische koppeling aan het Active Directory-domein geconfigureerd' },
              { step: 'Drivers en tools', icon: 'settings', description: 'Drivers en benodigde tools automatisch geïnstalleerd' }
            ]
          },
          results: ['Geautomatiseerde Windows-installatie voor 30+ apparaten', 'Automatische koppeling aan het Active Directory-domein', 'Drivers en tools vooraf geconfigureerd', 'Flinke besparing in tijd en kosten']
        },
        caseIdentityAccess: {
          title: 'Consolidatie van identiteits- en toegangsbeheer',
          description: 'SSO en MFA ingevoerd via Okta, met directorysynchronisatie naar Azure AD. Toegangsaanvragen gestandaardiseerd met groepen en levenscyclusbeleid voor de belangrijkste SaaS-applicaties.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie moest haar identiteits- en toegangsbeheer samenbrengen:',
            challenges: [
              'Meerdere inlogsystemen zorgden voor frustratie bij gebruikers',
              'Er was geen single sign-on voor de bedrijfsapplicaties',
              'Toegang werd steeds op een andere manier geregeld',
              'Accounts werden handmatig beheerd, van indiensttreding tot vertrek',
              'Het was lastig om aan de auditeisen te blijven voldoen'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Okta ingevoerd met SSO, MFA en geautomatiseerd accountbeheer.',
            process: [
              { step: 'Okta-planning', icon: 'map', description: 'Strategie ontworpen om identiteiten samen te brengen' },
              { step: 'Directory-integratie', icon: 'link', description: 'Okta gekoppeld aan Azure AD' },
              { step: 'SSO en MFA inrichten', icon: 'shield', description: 'SSO- en MFA-beleid geconfigureerd' },
              { step: 'Automatisch accountbeheer', icon: 'zap', description: 'Workflows voor de hele accountlevenscyclus geautomatiseerd' }
            ]
          },
          results: ['SSO voor 12+ bedrijfsapps', 'MFA per rol en risico', 'Geautomatiseerde processen voor in-, door- en uitstroom', 'Toegangsreviews klaar voor audits']
        },
        caseInfrastructure: {
          title: 'Cloudmigratie van infrastructuur',
          description: 'Bestandsdiensten en geselecteerde workloads verhuisd naar AWS, met EC2 en S3. De infrastructuur vastgelegd in Terraform, zodat die reproduceerbaar is, en CloudWatch-alarmen ingesteld voor proactieve monitoring.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie wilde haar infrastructuur naar de cloud verhuizen, maar liep tegen problemen aan:',
            challenges: [
              'Hoge kosten voor de on-premises infrastructuur',
              'Zonder infrastructure as code was de omgeving niet reproduceerbaar',
              'Er waren geen geautomatiseerde monitoring en meldingen',
              'Resources waren lastig op te schalen wanneer dat nodig was',
              'Disaster recovery en back-up waren complex'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Infrastructuur gemigreerd naar AWS, met Terraform (IaC) en uitgebreide monitoring.',
            process: [
              { step: 'Migratieplanning', icon: 'map', description: 'Strategie voor de cloudmigratie ontworpen' },
              { step: 'Terraform inrichten', icon: 'code', description: 'Infrastructure as code opgezet met Terraform' },
              { step: 'AWS-migratie', icon: 'arrow-right', description: 'Workloads gemigreerd naar EC2 en S3' },
              { step: 'Monitoring inrichten', icon: 'settings', description: 'CloudWatch-alarmen en monitoring geconfigureerd' }
            ]
          },
          results: ['50% lagere infrastructuurkosten', 'Terraform-basisconfiguraties (IaC)', 'S3-levenscyclusbeleid om kosten te beheersen', 'Betere betrouwbaarheid en herstel (RTO/RPO)']
        },
        caseDevOpsAutomation: {
          title: 'CI/CD en automatisering',
          description: 'Een GitLab CI-pipeline gebouwd met builds in Docker, geautomatiseerde tests en promotie tussen omgevingen. Chatmeldingen en releasetags toegevoegd voor traceerbaarheid.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie wilde ontwikkeling en uitrol automatiseren:',
            challenges: [
              'Handmatige uitrol zorgde voor vertraging en fouten',
              'Er waren geen geautomatiseerde tests in de ontwikkelworkflow',
              'Builds en uitrol kostten veel tijd',
              'Een rollback tijdens een uitrol was niet mogelijk',
              'Er was geen zicht op de status van de uitrol en er kwamen geen meldingen'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Een GitLab CI/CD-pipeline ingericht met Docker, geautomatiseerde tests en meldingen.',
            process: [
              { step: 'Pipelineontwerp', icon: 'layout', description: 'Architectuur van de CI/CD-pipeline ontworpen' },
              { step: 'GitLab CI inrichten', icon: 'code', description: 'GitLab CI geconfigureerd met Docker-builds' },
              { step: 'Testautomatisering', icon: 'zap', description: 'Geautomatiseerde tests per PR toegevoegd' },
              { step: 'Uitrol en monitoring', icon: 'rocket', description: 'Geautomatiseerde uitrol en meldingen ingericht' }
            ]
          },
          results: ['Uitroltijd teruggebracht tot 10 minuten', 'Geautomatiseerde tests per PR', 'Releases met rollbackmogelijkheid', 'Minder downtime tijdens een uitrol']
        },
        caseKnowledgeManagement: {
          title: 'Kennisbeheerplatform',
          description: 'Een kennisbank in Confluence gelanceerd, met paginasjablonen, goedkeuringsworkflows en gestructureerde tags. SSO gekoppeld en teams getraind om de content actueel te houden.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie had één centrale plek voor kennis nodig, maar informatie was lastig te beheren:',
            challenges: [
              'Kennis stond verspreid over meerdere plekken en formaten',
              'Er waren geen standaardsjablonen voor documentatie',
              'Er waren geen goedkeuringsworkflows om de kwaliteit te bewaken',
              'Door gebrekkige ordening was informatie moeilijk te vinden',
              'Er was geen gestructureerd systeem voor tags of categorieën'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Een kennisbank in Confluence ingericht, met sjablonen, workflows en een duidelijke structuur.',
            process: [
              { step: 'Confluence inrichten', icon: 'server', description: 'Confluence-platform geconfigureerd met SSO' },
              { step: 'Sjablonen maken', icon: 'layout', description: 'Standaardsjablonen voor pagina\'s gemaakt' },
              { step: 'Workflowontwerp', icon: 'settings', description: 'Goedkeuringsworkflows en tags ingericht' },
              { step: 'Training en lancering', icon: 'users', description: 'Teams getraind en kennisbank gelanceerd' }
            ]
          },
          results: ['Beleid en SOP\'s op één plek', 'Content op basis van sjablonen', 'Doorzoekbare tags en labels', 'Onboardingtijd flink verkort']
        },
        caseServiceDesk: {
          title: 'Implementatie van een servicedesk',
          description: 'Eén centrale helpdesk ingevoerd met ticketcategorieën, SLA\'s, selfservicekennis en automatische routeringsregels. CSAT-enquêtes toegevoegd om de tevredenheid van gebruikers te meten.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie had één centrale servicedesk nodig, maar de ondersteuning was versnipperd:',
            challenges: [
              'Meerdere supportkanalen zorgden voor verwarring en vertraging',
              'SLA\'s werden niet op een standaardmanier bijgehouden en beheerd',
              'Zonder selfservice nam het aantal tickets toe',
              'Handmatige ticketroutering werkte inefficiënt',
              'Er was geen manier om de tevredenheid van gebruikers te meten en te verbeteren'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Een centrale servicedesk ingericht met automatisering, selfservice en tevredenheidsmetingen.',
            process: [
              { step: 'Servicedesk inrichten', icon: 'server', description: 'Centraal helpdeskplatform geconfigureerd' },
              { step: 'SLA-configuratie', icon: 'settings', description: 'SLA-bewaking en categorieën ingesteld' },
              { step: 'Automatisering en selfservice', icon: 'zap', description: 'Automatische routering en kennisbank ingericht' },
              { step: 'CSAT-integratie', icon: 'users', description: 'Tevredenheidsenquêtes en metingen toegevoegd' }
            ]
          },
          results: ['Betere SLA-naleving', 'Veelvoorkomende tickets opgevangen door selfservice', 'Kleinere achterstand dankzij automatische routering', 'CSAT gemeten en elk kwartaal verbeterd']
        }
      }
    },
    homepageFeaturedWork: {
      title: 'UITGELICHTE OPLOSSINGEN',
      subtitle: 'Een greep uit onze IT-oplossingen en implementaties met de grootste impact: projecten die bedrijven flink verder hebben geholpen en uitzonderlijke resultaten opleverden.',
      technologiesUsed: 'Gebruikte technologieën:',
      keyResults: 'Belangrijkste resultaten:',
      learnMore: 'Meer informatie',
      viewAllProjects: 'Bekijk alle projecten',
      categories: {
        cloudSolutions: 'Cloudoplossingen',
        securityIAM: 'Security & IAM',
        infrastructure: 'Infrastructuur'
      },
      projects: {
        microsoft365Migration: {
          title: 'Microsoft 365-migratie op enterpriseniveau',
          description: 'Een uitgebreide Microsoft 365-migratie geleid voor een organisatie met 200+ medewerkers, inclusief e-mailmigratie, inrichting van SharePoint, uitrol van Teams en beveiligingsconfiguratie. Het resultaat: betere samenwerking en hogere productiviteit.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie moest overstappen op Microsoft 365, maar de migratie was complex:',
            challenges: [
              'Verouderde e-mailsystemen beperkten de samenwerking',
              'De migratie voor 200+ gebruikers moest zonder downtime verlopen',
              'Gegevens moesten vanuit meerdere bronnen worden gemigreerd',
              'Eisen op het gebied van beveiliging en compliance',
              'Zorgen over training en acceptatie door gebruikers'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Een uitgebreide M365-migratie uitgevoerd, zonder downtime en met betere beveiliging.',
            process: [
              { step: 'Migratieplanning', icon: 'map', description: 'Migratiestrategie zonder downtime ontworpen' },
              { step: 'E-mailmigratie', icon: 'arrow-right', description: '200+ gebruikers zonder onderbreking gemigreerd' },
              { step: 'Platform inrichten', icon: 'server', description: 'SharePoint, Teams en beveiliging geconfigureerd' },
              { step: 'Training en ondersteuning', icon: 'users', description: 'Training en doorlopende ondersteuning gegeven' }
            ]
          },
          results: ['200+ gebruikers gemigreerd', 'Migratie zonder downtime', 'Strenger beveiligingsbeleid', 'Betere samenwerkingstools', 'Lagere kosten']
        },
        oktaImplementation: {
          title: 'Identiteitsbeheer met Okta',
          description: 'Okta ingevoerd als primaire identiteitsprovider voor een organisatie met meerdere tenants. Gebruikers loggen nu met single sign-on in op 15+ applicaties, en multifactorauthenticatie heeft de beveiliging versterkt.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie had één centraal identiteitsbeheer nodig, maar het inloggen was versnipperd:',
            challenges: [
              'Meerdere inlogsystemen zorgden voor frustratie bij gebruikers',
              'Er was geen single sign-on voor 15+ bedrijfsapplicaties',
              'Er waren zorgen over de veiligheid van inloggen met alleen een wachtwoord',
              'Een omgeving met meerdere tenants stelde complexe eisen aan identiteiten',
              'De toegang van gebruikers tot applicaties was lastig te beheren'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Okta ingevoerd als primaire identiteitsprovider, met SSO en MFA voor alle applicaties.',
            process: [
              { step: 'Okta-planning', icon: 'map', description: 'Strategie voor identiteitsbeheer ontworpen' },
              { step: 'Applicatie-integratie', icon: 'link', description: '15+ applicaties gekoppeld via SSO' },
              { step: 'MFA-configuratie', icon: 'shield', description: 'Multifactorauthenticatie geconfigureerd' },
              { step: 'Multi-tenant inrichten', icon: 'users', description: 'Architectuur voor meerdere tenants ingericht' }
            ]
          },
          results: ['15+ applicaties gekoppeld', 'SSO ingevoerd', 'MFA verplicht', 'Voldoet aan beveiligingseisen', 'Betere gebruikerservaring']
        },
        serverInfrastructure: {
          title: 'Serverinfrastructuur op enterpriseniveau',
          description: 'Een complete serverinfrastructuur ontworpen en ingericht voor een groeiende organisatie: Windows Server, VMware-virtualisatie, Active Directory, geautomatiseerde back-ups en uitgebreide monitoring.',
          problem: {
            title: 'De uitdaging',
            description: 'De organisatie had een serverinfrastructuur op enterpriseniveau nodig, maar de bestaande omgeving schoot tekort:',
            challenges: [
              'Er was geen centrale serverinfrastructuur voor de groeiende organisatie',
              'Zonder virtualisatie bleef de efficiëntie beperkt',
              'Er was geen Active Directory voor identiteitsbeheer',
              'Handmatige back-ups brachten risico op gegevensverlies met zich mee',
              'De gezondheid van de infrastructuur werd niet gemonitord'
            ]
          },
          solution: {
            title: 'Onze oplossing',
            description: 'Een complete infrastructuur op enterpriseniveau ontworpen en ingericht, met virtualisatie en automatisering.',
            process: [
              { step: 'Infrastructuurontwerp', icon: 'layout', description: 'Serverarchitectuur en topologie ontworpen' },
              { step: 'VMware-implementatie', icon: 'server', description: 'VMware-virtualisatieplatform ingericht' },
              { step: 'AD en services inrichten', icon: 'settings', description: 'Active Directory en services geconfigureerd' },
              { step: 'Automatisering en monitoring', icon: 'zap', description: 'Back-ups en 24/7 monitoring ingericht' }
            ]
          },
          results: ['Complete serverinfrastructuur', 'VMware-virtualisatie', 'Active Directory ingericht', 'Geautomatiseerde back-ups', '24/7 monitoring']
        }
      }
    },
    solutions: {
      title: 'ONZE OPLOSSINGEN',
      subtitle: 'IT voor het mkb, van managed IT-beheer en cloud tot security, data, AI en maatwerksoftware.',
      exploreAllSolutions: 'Bekijk alle oplossingen',
      exploreSolution: 'Bekijk oplossing',
      technologies: 'Technologieën',
      keyBenefits: 'Belangrijkste voordelen',
      managedItSupport: {
        title: 'Wie regelt en beheert onze IT?',
        subtitle: 'IT-beheer, helpdesk & werkplekbeheer',
        description: 'Helpdesk, werkplekbeheer, servicedesk en monitoring als één samenhangende beheerdienst, met een actuele kennisbank achter elke oplossing.'
      },
      cloudInfrastructure: {
        title: 'Hoe stappen we veilig over naar de cloud?',
        subtitle: 'Cloudmigratie, Microsoft 365 & servers',
        description: 'Cloudmigratie naar Microsoft 365 en Azure, beheer van servers en virtualisatie, en cloudbeheer met monitoring en kostenbeheersing.'
      },
      cybersecurityIdentity: {
        title: 'Hoe bescherm ik mijn bedrijf tegen cyberaanvallen?',
        subtitle: 'Cybersecurity, NIS2, pentest & toegangsbeheer',
        description: 'Identiteits- en toegangsbeheer, endpointbeveiliging, pentesten en NIS2/ISO 27001-compliance die uw accounts en apparaten beschermen.'
      },
      dataDatabases: {
        title: 'Hoe haal ik waarde uit mijn bedrijfsdata?',
        subtitle: 'Databasebeheer, datamigratie & Power BI',
        description: 'Databasebeheer, datamigratie en performancetuning, plus datapijplijnen, een dataplatform en Power BI-dashboards waarmee u beslissingen op data baseert.'
      },
      aiAutomation: {
        title: 'Welke processen kan ik met AI automatiseren?',
        subtitle: 'AI-automatisering, AI-agents & document-AI',
        description: 'Procesautomatisering, AI-agents en chatbots op uw eigen data, en geautomatiseerde documentverwerking, gebouwd volgens de AVG en de AI-verordening.'
      },
      webSoftwareDevelopment: {
        title: 'Doet onze website nog wat hij moet doen?',
        subtitle: 'Website, webshop of webapp laten maken',
        description: 'Websites, webshops en webapplicaties met UX-design, performance en security, en ook maatwerksoftware. U krijgt de broncode, geen vendor lock-in.'
      },
      mobileAppDevelopment: {
        title: 'Hebben wij een eigen app nodig?',
        subtitle: 'Apps voor iOS & Android laten maken',
        description: 'Apps voor iOS en Android, gebouwd met React Native, Flutter of native code, met backend, publicatie in de stores en onderhoud.'
      },
      crmDevelopment: {
        title: 'Hoe houden we klanten en deals goed bij?',
        subtitle: 'CRM op maat, inrichting & koppelingen',
        description: 'Een CRM op maat of een ingericht HubSpot, Salesforce of Dynamics 365, gekoppeld aan e-mail, facturatie en uw website, met uw spreadsheets overgezet.'
      },
      erpSystems: {
        title: 'Hoe koppelen we ons ERP aan de rest?',
        subtitle: 'ERP-koppelingen, maatwerkmodules & migratie',
        description: 'Koppelingen tussen Exact Online, AFAS, Business Central of Odoo en uw webshop, CRM en boekhouding, plus maatwerkmodules en datamigratie.'
      },
      infrastructureManagement: {
        title: 'Infrastructure Management',
        subtitle: 'Server-, apparaat- en VM-beheer',
        description: 'Volledig endpoint-, server- en VM-beheer met 24/7 monitoring en ondersteuning.',
        benefits: ['24/7 monitoring', 'Geautomatiseerde updates', 'Prestatieoptimalisatie', 'Back-up en herstel']
      },
      cloudSolutions: {
        title: 'Cloudoplossingen',
        subtitle: 'Microsoft 365 & Google Workspace',
        description: 'Deskundig beheer van Microsoft 365- en Google Workspace-omgevingen.',
        benefits: ['Gebruikersbeheer', 'Beveiligingsconfiguratie', 'Migratie', 'Training en ondersteuning']
      },
      securityIdentity: {
        title: 'Security & identity',
        subtitle: 'Active Directory, Okta & CyberArk',
        description: 'Identiteits- en toegangsbeheer op enterpriseniveau met AD, Okta en CyberArk.',
        benefits: ['Single sign-on', 'Multifactorauthenticatie', 'Bevoorrechte toegang (PAM)', 'Compliancerapportage']
      },
      webDevelopment: {
        title: 'Webontwikkeling',
        subtitle: 'Webapplicaties en websites op maat',
        description: 'Webapplicaties op maat, moderne websites en digitale oplossingen die uw bedrijf verder helpen.',
        benefits: ['Ontwikkeling op maat', 'Prestatieoptimalisatie', 'Beveiligingsmaatregelen', 'Onderhoud en updates']
      }
    },
    servicePageCommon: {
      backToServices: 'Terug naar diensten',
      backToAllServices: 'Terug naar alle diensten',
      relatedArticles: 'Artikelen over deze dienst',
      serviceNotFound: 'Dienst niet gevonden',
      serviceNotFoundDescription: 'De pagina van deze dienst kon niet worden gevonden.',
      coreCapabilities: 'Wat we doen',
      deliverables: 'Wat u krijgt',
      businessImpact: 'Wat het u oplevert',
      coreCapabilitiesDescription: 'Oplossingen die uw specifieke uitdagingen aanpakken en meetbare resultaten opleveren.',
      projectInformation: 'Projectinformatie',
      projectInformationDescription: 'De getoonde cijfers en statistieken zijn voorbeeldgegevens op basis van branche-onderzoek. Uw werkelijke resultaten hangen af van de specifieke behoeften van uw project en uw omgeving. We stemmen onze oplossing af op uw situatie.'
    },
    servicePages: {
      managedItSupport: {
        title: 'IT-beheer & support',
        subtitle: 'IT-beheer uitbesteden: helpdesk, werkplekbeheer, servicedesk & monitoring',
        description: 'Besteed uw IT-beheer uit aan één team: een helpdesk met heldere SLA\'s, werkplekbeheer met Intune en Jamf, een goed ingerichte servicedesk en proactieve monitoring.',
        heroContent: {
          mainTitle: 'IT-beheer & support',
          subtitle: 'Eén team voor uw helpdesk, apparaten, servicedesk en monitoring',
          keyPoints: [
            'Helpdesk in eerste en tweede lijn, met vastgelegde SLA\'s en escalatieroutes',
            'Beheer van apparaten en endpoints met Microsoft Intune en Jamf Pro',
            'Inrichting van uw servicedesk in Jira Service Desk, Zammad of ServiceNow',
            'Proactieve monitoring en een kennisbank die actueel blijft'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Versnipperde ondersteuning en apparaten',
            description: 'Tickets, laptops en documentatie zitten in losse systemen. Daardoor lopen reactietijden op, verschillen patchniveaus per apparaat en worden dezelfde vragen elke week opnieuw beantwoord.',
            challenges: [
              'Lange reactietijden die ten koste gaan van de productiviteit',
              'Onbeheerde apparaten die niet allemaal even goed gepatcht en compliant zijn',
              'Geen vaste werkwijze voor tickets en geen duidelijke escalatieroute',
              'Kennis die bij een paar mensen in het hoofd zit en nergens is vastgelegd'
            ]
          },
          solution: {
            title: 'Al uw IT-ondersteuning bij één team',
            description: 'We brengen helpdesk, endpointbeheer en servicedesk samen in één werkwijze. Monitoring en documentatie zorgen ervoor dat elke volgende storing sneller is opgelost.',
            benefits: [
              'Snelle afhandeling van incidenten met heldere escalatie',
              'Centraal beheerde en compliant apparaten op Windows, macOS en mobiel',
              'Eenduidige ticketrouting, SLA\'s en rapportage',
              'Vastgelegde oplossingen, zodat meer vragen bij het eerste contact worden opgelost'
            ]
          }
        },
        features: [
          {
            title: 'Helpdesk & technische ondersteuning',
            description: 'Eerste- en tweedelijnsondersteuning bij vragen van gebruikers, met registratie van elk ticket, hulp op afstand en specialistische hulp bij lastige problemen.',
            capabilities: [
              'Registratie en beheer van tickets',
              'Eerste- en tweedelijnsondersteuning',
              'Hulp en diagnose op afstand',
              'Escalatie en doorverwijzing naar specialisten'
            ]
          },
          {
            title: 'Apparaat- & endpointbeheer',
            description: 'Beheer van Windows-, macOS-, iOS- en Android-apparaten gedurende de hele levenscyclus met Microsoft Intune en Jamf Pro: van uitrol tot patches en compliance.',
            capabilities: [
              'Zero-touch-uitrol en automatische inrichting',
              'Beleid instellen en afdwingen',
              'Software-uitrol en patchbeheer',
              'Inventarisatie van hardware en compliancerapportage'
            ]
          },
          {
            title: 'Servicedesk inrichten',
            description: 'We richten Jira Service Desk, Zammad of ServiceNow in met workflows, SLA\'s en automatiseringen die passen bij uw team.',
            capabilities: [
              'Platformconfiguratie en workflowontwerp',
              'Automatische ticketrouting en SLA-bewaking',
              'Koppeling met uw gebruikersdirectory en bestaande systemen',
              'Dashboards en prestatierapportages'
            ]
          },
          {
            title: 'Monitoring & kennisbank',
            description: 'Doorlopende monitoring die problemen signaleert voordat gebruikers ze melden, en een actuele kennisbank waardoor problemen sneller en eenduidiger worden opgelost.',
            capabilities: [
              '24/7 systeemmonitoring en meldingen',
              'Problemen vroeg opsporen en voorkomen',
              'Opbouw en onderhoud van de kennisbank',
              'Vastgelegde procedures en runbooks'
            ]
          }
        ],
        technologies: {
          title: 'Tools & platforms voor IT-ondersteuning',
          description: 'Wij kennen de platforms voor endpointbeheer, ticketing en documentatie waar modern IT-beheer op draait.',
          platforms: [
            { name: 'Microsoft Intune', category: 'Apparaatbeheer' },
            { name: 'Jamf Pro', category: 'macOS-beheer' },
            { name: 'Jira Service Desk', category: 'ITSM-platform' },
            { name: 'Zammad', category: 'Opensource-helpdesk' },
            { name: 'ServiceNow', category: 'Enterprise-ITSM' },
            { name: 'Confluence', category: 'Kennisbank' }
          ]
        },
        implementation: {
          title: 'Zo richten we uw ondersteuning in',
          description: 'Een gestructureerde aanpak waarin we ondersteuning, apparaten en documentatie in één keer inrichten.',
          phases: [
            {
              phase: 'Analyse & planning',
              duration: '1-2 weken',
              description: 'We brengen het huidige aantal supportvragen, uw apparaten en uw tools in kaart en bepalen hoe de ondersteuning wordt georganiseerd.',
              deliverables: ['Analyse van ondersteuning en apparaten', 'Werkwijze en SLA\'s', 'Keuze van tools', 'Implementatieplan']
            },
            {
              phase: 'Inrichting & configuratie',
              duration: '2-3 weken',
              description: 'We configureren de servicedesk, rollen de apparaten uit en zetten de eerste versie van de kennisbank op.',
              deliverables: ['Geconfigureerde servicedesk', 'Uitgerolde apparaten en beleid', 'Opzet van de kennisbank', 'Ingerichte monitoring en meldingen']
            },
            {
              phase: 'Training & livegang',
              duration: '1-2 weken',
              description: 'We trainen medewerkers, leggen procedures vast en starten de ondersteuning.',
              deliverables: ['Training van het supportteam', 'Gebruikersdocumentatie', 'Begeleiding bij de livegang', 'Ingerichte rapportage']
            },
            {
              phase: 'Doorlopende ondersteuning',
              duration: 'Doorlopend',
              description: 'We bieden dagelijks ondersteuning en verbeteren intussen processen en documentatie.',
              deliverables: ['24/7 ondersteuning', 'Patch- en compliancebeheer', 'Procesverbetering', 'Onderhoud van de kennisbank']
            }
          ]
        },
        benefits: {
          title: 'Wat het oplevert',
          description: 'Meetbare verbetering in oplossnelheid, compliance van apparaten en tevredenheid van gebruikers.',
          outcomes: [
            {
              label: 'Snellere oplostijden',
              description: 'Standaardworkflows en deskundige support verkorten de tijd om problemen op te lossen.'
            },
            {
              label: 'First-contact resolution',
              description: 'Een onderhouden kennisbank helpt supportmedewerkers om problemen bij het eerste contact op te lossen.'
            },
            {
              label: 'Monitoring & support',
              description: 'Continue monitoring signaleert problemen voordat ze gebruikers bereiken.'
            },
            {
              label: 'Apparaatcompliance',
              description: 'Centraal beheerd beleid houdt endpoints gepatcht en compliant.'
            }
          ]
        }
      },
      cloudInfrastructure: {
        title: 'Cloud & infrastructuur',
        subtitle: 'Cloudmigratie, Microsoft 365, servers & virtualisatie',
        description: 'Stap veilig over naar de cloud en houd uw omgeving goed op orde: beheer van Microsoft 365 en Google Workspace, van servers en virtualisatie, en een zorgvuldig geplande migratie naar Azure en AWS, met monitoring en grip op de kosten.',
        heroContent: {
          mainTitle: 'Cloud & infrastructuur',
          subtitle: 'Microsoft 365, Google Workspace, servers, virtualisatie en cloudmigratie onder één dak',
          keyPoints: [
            'Beheer en beveiliging van Microsoft 365 en Google Workspace',
            'Beheer van servers en virtuele machines op VMware en Hyper-V',
            'Migratie naar en integratie met Azure en AWS',
            'Monitoring, capaciteitsplanning en kostenbeheersing'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Wildgroei in cloud en infrastructuur',
            description: 'Tenants voor Microsoft 365 of Google Workspace, eigen servers en cloudaccounts worden los van elkaar beheerd. Dat leidt tot blinde vlekken, ongelijke beveiliging en onvoorspelbare kosten.',
            challenges: [
              'Aparte tools en teams voor werkplek en infrastructuur',
              'Beveiliging en compliance die per platform verschillen',
              'Handmatig beheer van servers en VM\'s, met risico op downtime',
              'Licentie- en cloudkosten die lastig te voorspellen of te beheersen zijn'
            ]
          },
          solution: {
            title: 'Geïntegreerd cloud- en infrastructuurbeheer',
            description: 'We beheren uw werkplekomgeving en infrastructuur als één geheel. Monitoring, beveiligingsbaselines en capaciteitsplanning gelden voor de hele hybride omgeving.',
            benefits: [
              'Centraal beheer van Microsoft 365 en Google Workspace',
              'Betrouwbaar server- en virtualisatiebeheer',
              'Zorgvuldig geplande migraties met minimale downtime',
              'Licenties en cloudkosten die passen bij wat u echt gebruikt'
            ]
          }
        },
        features: [
          {
            title: 'Microsoft 365 & Google Workspace',
            description: 'Tenantbeheer, accountbeheer van indiensttreding tot vertrek en de beveiligingsinstellingen van Microsoft 365 en Google Workspace.',
            capabilities: [
              'Tenantconfiguratie en -optimalisatie',
              'Accountbeheer van indiensttreding tot vertrek',
              'Beleid voor DLP en voorwaardelijke toegang (conditional access)',
              'Licentiebeheer en kostenoptimalisatie'
            ]
          },
          {
            title: 'Server- & virtualisatiebeheer',
            description: 'Inrichten, patchen en optimaliseren van Windows- en Linux-servers en van virtuele machines op VMware of Hyper-V.',
            capabilities: [
              'Servers inrichten en configureren',
              'Patchbeheer en beveiligingsupdates',
              'VM\'s inrichten en resources optimaal benutten',
              'Back-up en disaster recovery'
            ]
          },
          {
            title: 'Cloudmigratie & integratie',
            description: 'Zorgvuldig geplande migratie van e-mail, bestanden en workloads naar de cloud, met directorysynchronisatie en koppelingen met uw bestaande systemen.',
            capabilities: [
              'E-mail- en datamigratie',
              'Directorysynchronisatie',
              'Migratie van workloads naar Azure en AWS',
              'Koppelingen tussen applicaties'
            ]
          },
          {
            title: 'Monitoring & optimalisatie',
            description: 'Doorlopende monitoring en capaciteitsplanning voor cloud en eigen servers, met bijsturing op prestaties en kosten.',
            capabilities: [
              'Realtime monitoring van de infrastructuur',
              'Capaciteitsplanning en prognoses',
              'Prestaties verbeteren',
              'Kosten- en licentieoptimalisatie'
            ]
          }
        ],
        technologies: {
          title: 'Platforms waarmee we werken',
          description: 'Ruime ervaring met Microsoft 365 en Google Workspace, virtualisatieplatforms en de publieke cloud.',
          platforms: [
            { name: 'Microsoft 365', category: 'Kantoorsoftware' },
            { name: 'Google Workspace', category: 'Samenwerkingsplatform' },
            { name: 'Microsoft Azure', category: 'Publieke cloud' },
            { name: 'AWS', category: 'Publieke cloud' },
            { name: 'VMware vSphere', category: 'Virtualisatieplatform' },
            { name: 'Hyper-V', category: 'Hypervisor' }
          ]
        },
        implementation: {
          title: 'Onze aanpak',
          description: 'Een gestructureerde aanpak voor de uitrol van cloud en infrastructuur, zodat beheer en optimalisatie daarna goed geregeld zijn.',
          phases: [
            {
              phase: 'Analyse & strategie',
              duration: '1-2 weken',
              description: 'We brengen uw huidige tenants, servers en cloudgebruik in kaart en bepalen hoe de nieuwe omgeving eruit moet zien.',
              deliverables: ['Analyse van de huidige situatie', 'Cloud- en infrastructuurstrategie', 'Migratieplan', 'Beveiligingsbaseline']
            },
            {
              phase: 'Ontwerp & configuratie',
              duration: '2-3 weken',
              description: 'We ontwerpen de architectuur en configureren de werkplekomgeving, servers en virtualisatie.',
              deliverables: ['Architectuurontwerp', 'Beveiligingsinstellingen', 'Integratiespecificaties', 'Testplannen']
            },
            {
              phase: 'Migratie & uitrol',
              duration: '3-4 weken',
              description: 'Migratie en uitrol in fasen, met controles en begeleiding bij de definitieve overstap.',
              deliverables: ['Pilotmigratie', 'Volledige uitrol', 'Gebruikerstraining', 'Begeleiding bij de livegang']
            },
            {
              phase: 'Optimalisatie & ondersteuning',
              duration: 'Doorlopend',
              description: 'Doorlopende monitoring, bijsturing en kostenoptimalisatie voor de hele omgeving.',
              deliverables: ['Prestatieoptimalisatie', 'Capaciteitsplanning', '24/7 ondersteuning', 'Periodieke kostenevaluaties']
            }
          ]
        },
        benefits: {
          title: 'Wat het oplevert',
          description: 'Meetbare verbeteringen in kosten, betrouwbaarheid en prestaties, in de cloud en op uw eigen servers.',
          outcomes: [
            {
              label: 'Lagere IT-kosten',
              description: 'Goed afgestemde licenties en juist gedimensioneerde resources verlagen de kosten van uw werkplekomgeving en infrastructuur.'
            },
            {
              label: 'Uptime van de infrastructuur',
              description: 'Proactieve monitoring en onderhoud houden uw systemen beschikbaar en uw bedrijf draaiende.'
            },
            {
              label: 'Snellere probleemoplossing',
              description: 'Met centrale monitoring en meldingen worden problemen sneller ontdekt en opgelost.'
            },
            {
              label: 'Besparing op cloudkosten',
              description: 'Capaciteitsplanning en het juist dimensioneren van servers en diensten verlagen de kosten van cloud en infrastructuur.'
            }
          ]
        }
      },
      cybersecurityIdentity: {
        title: 'Cybersecurity & identiteit',
        subtitle: 'Identiteits- en toegangsbeheer, endpointbeveiliging & NIS2',
        description: 'Bepaal wie er binnenkomt en beveilig wat er op uw apparaten draait: SSO en MFA, beheer van beheerdersrechten, endpointbeveiliging met EDR en pentesten, ingericht volgens zero trust en NIS2/ISO 27001.',
        heroContent: {
          mainTitle: 'Cybersecurity & identiteit',
          subtitle: 'Identiteit, toegang en endpointbeveiliging, ingericht volgens zero trust',
          keyPoints: [
            'Single sign-on en MFA voor systemen in de cloud en op locatie',
            'Privileged access management met controle op elke beheersessie',
            'Detectie en respons op alle endpoints in uw organisatie',
            'Zero-trustarchitectuur en compliancerapportage'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Kwetsbare accounts en apparaten',
            description: 'Gestolen inloggegevens en onbeheerde endpoints zijn de meest gebruikte ingangen voor aanvallers. Tegelijk zorgen wildgroei in toegangsrechten en audit-eisen voor een overbelast securityteam.',
            challenges: [
              'Aanvallen op accounts en diefstal van inloggegevens',
              'Permanente beheerdersrechten zonder controle op sessies',
              'Endpoints zonder eenduidige detectie en respons',
              'Compliance- en audit-eisen uit meerdere normenkaders'
            ]
          },
          solution: {
            title: 'Beveiliging die begint bij identiteit',
            description: 'We brengen identiteitsbeheer, beheerdersrechten en endpointbeveiliging samen in een zero-trustmodel, met doorlopende verificatie en rapportages die klaar zijn voor de audit.',
            benefits: [
              'Eén identiteitsbeheer met sterke authenticatie',
              'Beheerdersrechten alleen wanneer nodig (just-in-time), met opname van sessies',
              'Automatische detectie en respons op endpoints',
              'Doorlopende bewaking van en rapportage over compliance'
            ]
          }
        },
        features: [
          {
            title: 'Identiteits- & toegangsbeheer',
            description: 'SSO, MFA en rolgebaseerde toegang in Microsoft Entra ID, Active Directory en Okta, met automatische workflows voor nieuwe medewerkers, functiewissels en vertrek.',
            capabilities: [
              'Invoering van single sign-on (SSO)',
              'Meervoudige authenticatie (MFA)',
              'Rolgebaseerd toegangsbeheer (RBAC)',
              'Accounts automatisch aanmaken en intrekken'
            ]
          },
          {
            title: 'Privileged access management',
            description: 'Beheer en bewaak beheerdersrechten met CyberArk: wachtwoorden in een kluis, tijdelijke rechten op het moment dat ze nodig zijn en opname van sessies.',
            capabilities: [
              'Beheerdersaccounts opsporen en in een kluis beveiligen',
              'Tijdelijke toegang op het moment dat die nodig is (just-in-time)',
              'Sessies bewaken en opnemen',
              'Automatische rotatie van inloggegevens'
            ]
          },
          {
            title: 'Endpointbeveiliging',
            description: 'Detectie en respons op elk endpoint met CrowdStrike Falcon en Microsoft Defender, met gedragsanalyse en automatisch herstel.',
            capabilities: [
              'Endpointdetectie en -respons (EDR)',
              'Gedragsanalyse en detectie van afwijkingen',
              'Automatische reactie op incidenten',
              'Koppeling met threat intelligence'
            ]
          },
          {
            title: 'Zero trust & compliance',
            description: 'Iedereen krijgt alleen de rechten die nodig zijn (least privilege), met doorlopende verificatie, audittrails en rapportages die aansluiten op wet- en regelgeving.',
            capabilities: [
              'Voorwaardelijke en risicogebaseerde toegang',
              'Least privilege en microsegmentatie',
              'Auditlogs en audittrails',
              'Compliancerapportages en dashboards'
            ]
          }
        ],
        technologies: {
          title: 'Platforms waarmee we werken',
          description: 'Wij kennen de gangbare platforms voor identiteitsbeheer, beheerdersrechten en endpointbeveiliging.',
          platforms: [
            { name: 'Microsoft Entra ID', category: 'Identiteitsbeheer in de cloud' },
            { name: 'Active Directory', category: 'Directoryservice' },
            { name: 'Okta', category: 'Identity provider' },
            { name: 'CyberArk', category: 'Privileged access management' },
            { name: 'CrowdStrike Falcon', category: 'EDR-platform' },
            { name: 'Microsoft Defender', category: 'Endpointbeveiliging' }
          ]
        },
        implementation: {
          title: 'Onze aanpak',
          description: 'Een vaste werkwijze voor de uitrol van identiteitsbeheer, beheerdersrechten en endpointbeveiliging.',
          phases: [
            {
              phase: 'Inventarisatie & beoordeling',
              duration: '1-2 weken',
              description: 'We brengen uw huidige identiteitsbeheer, beheerdersaccounts en de staat van uw endpoints in kaart.',
              deliverables: ['Audit van accounts en toegangsrechten', 'Risicobeoordeling', 'Gap-analyse', 'Implementatiestrategie']
            },
            {
              phase: 'Ontwerp & architectuur',
              duration: '2-3 weken',
              description: 'We ontwerpen de zero-trustarchitectuur, het toegangsbeleid en de beveiligingsmaatregelen voor endpoints.',
              deliverables: ['Architectuurontwerp', 'Toegangs- en beveiligingsbeleid', 'Integratiespecificaties', 'Testprotocollen']
            },
            {
              phase: 'Uitrol & integratie',
              duration: '3-4 weken',
              description: 'Gefaseerde uitrol van identiteitsbeheer, PAM en endpointbeveiliging, met een controle na elke stap.',
              deliverables: ['Pilotuitrol', 'Integratietests', 'Validatie van de beveiliging', 'Gebruikerstraining']
            },
            {
              phase: 'Optimalisatie & ondersteuning',
              duration: 'Doorlopend',
              description: 'Doorlopende monitoring, bijsturing en ondersteuning om uw beveiliging op peil te houden.',
              deliverables: ['Beveiligingsmonitoring', 'Bijstellen van beleid', '24/7 ondersteuning', 'Compliancerapportage']
            }
          ]
        },
        benefits: {
          title: 'Wat het oplevert',
          description: 'Een aanzienlijk betere beveiliging, terwijl toegang efficiënt en controleerbaar blijft.',
          outcomes: [
            {
              label: 'Minder risico op accountmisbruik',
              description: 'Sterke authenticatie en goed toegangsbeheer verkleinen de kans op aanvallen via gestolen of misbruikte accounts.'
            },
            {
              label: 'Minder beveiligingsincidenten',
              description: 'Endpointdetectie en minimale toegangsrechten zorgen voor minder incidenten.'
            },
            {
              label: 'Snellere incidentrespons',
              description: 'Geautomatiseerde respons en inzicht in sessies versnellen het indammen van incidenten.'
            },
            {
              label: 'Compliancedekking',
              description: 'Audittrails en rapportage houden toegang afgestemd op regelgevende frameworks.'
            }
          ]
        }
      },
      dataDatabases: {
        title: 'Data & databases',
        subtitle: 'Databasebeheer, datamigratie, pijplijnen & Power BI',
        description: 'Houd uw databases gezond en uw data in beweging: beheer, migratie en tuning van PostgreSQL, MySQL en SQL Server, plus datapijplijnen, een dataplatform en rapportages in Power BI. Back-up en herstel zijn inbegrepen.',
        heroContent: {
          mainTitle: 'Data & databases',
          subtitle: 'Databasebeheer en data-engineering in één hand',
          keyPoints: [
            'Databases inrichten, migreren en sneller maken',
            'ETL- en ELT-pijplijnen met Apache Airflow',
            'Datawarehouses en datalakes voor centrale analyse',
            'Datakwaliteit, governance en rapportage'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Trage databases en versnipperde data',
            description: 'Databases lopen vast zodra het druk wordt en uw data staat verspreid over verschillende systemen. Daardoor zijn betrouwbare analyses en rapportages lastig te maken.',
            challenges: [
              'Slecht presterende databases die uw applicaties vertragen',
              'Risicovolle migraties die downtime veroorzaken',
              'Versnipperde databronnen en silo\'s',
              'Geen governance en weinig vertrouwen in de cijfers in rapportages'
            ]
          },
          solution: {
            title: 'Betrouwbare data, van bron tot rapport',
            description: 'We beheren en optimaliseren uw databases en bouwen de pijplijnen en het datawarehouse waarmee uw data beschikbaar, juist en klaar voor analyse is.',
            benefits: [
              'Snelle, betrouwbare databases met back-up en monitoring',
              'Gecontroleerde migraties met minimale downtime',
              'Al uw data samengebracht via beheerde pijplijnen',
              'Goed beheerde, betrouwbare data voor analyse'
            ]
          }
        },
        features: [
          {
            title: 'Databases inrichten, migreren & beheren',
            description: 'Installatie, tuning en doorlopend beheer van PostgreSQL, MySQL, SQL Server en MongoDB, inclusief migraties met minimale downtime.',
            capabilities: [
              'Installatie, configuratie en hardening',
              'Tuning van prestaties en queries',
              'Migratiestrategieën met minimale downtime',
              'Automatische back-up, herstel en monitoring'
            ]
          },
          {
            title: 'Datapijplijnen & ETL',
            description: 'We ontwerpen en beheren ETL- en ELT-pijplijnen in Apache Airflow die data betrouwbaar inlezen, omzetten en verplaatsen.',
            capabilities: [
              'Pijplijnarchitectuur en -orkestratie',
              'Inrichting van ETL- en ELT-processen',
              'Data inlezen en koppelen',
              'Monitoring van pijplijnen en meldingen bij fouten'
            ]
          },
          {
            title: 'Datawarehouses & datalakes',
            description: 'We bouwen en modelleren datawarehouses en datalakes voor centrale opslag en snelle analyses.',
            capabilities: [
              'Architectuur van warehouse en datalake',
              'Datamodellering en schemaontwerp',
              'Opslagoptimalisatie en partitionering',
              'Incrementeel en batchgewijs laden'
            ]
          },
          {
            title: 'Analyse & governance',
            description: 'We maken van uw opgeslagen data rapportages en dashboards, met controles op datakwaliteit, inzicht in de herkomst van data (lineage) en governance.',
            capabilities: [
              'Ontwikkeling van rapportages en dashboards',
              'Regels en controles voor datakwaliteit',
              'Herkomst van data vastleggen en catalogiseren',
              'Governance en toegangsbeheer'
            ]
          }
        ],
        technologies: {
          title: 'Databases en datatools',
          description: 'Wij werken met relationele en NoSQL-databases, datawarehouses en tools voor datapijplijnen.',
          platforms: [
            { name: 'PostgreSQL', category: 'Relationele database' },
            { name: 'MySQL', category: 'Relationele database' },
            { name: 'Microsoft SQL Server', category: 'Enterprise-database' },
            { name: 'MongoDB', category: 'NoSQL-database' },
            { name: 'Snowflake', category: 'Datawarehouse' },
            { name: 'Apache Airflow', category: 'Workfloworkestratie' }
          ]
        },
        implementation: {
          title: 'Onze werkwijze',
          description: 'Een gestructureerde aanpak voor databasebeheer en data-engineering, met betrouwbare data die klaar is voor analyse als resultaat.',
          phases: [
            {
              phase: 'Analyse & ontwerp',
              duration: '2-3 weken',
              description: 'We lichten uw databases en databronnen door en ontwerpen daarna het doelschema en de architectuur van de pijplijnen.',
              deliverables: ['Database- en data-audit', 'Nulmeting van de prestaties', 'Architectuurontwerp', 'Implementatieplan']
            },
            {
              phase: 'Inrichting & configuratie',
              duration: '2-3 weken',
              description: 'We richten de databases in, stellen ze af en zetten de eerste pijplijnen en het datawarehouse op.',
              deliverables: ['Geïnstalleerde en afgestelde databases', 'Back-upstrategie', 'Eerste pijplijnen', 'Beveiligingsinstellingen']
            },
            {
              phase: 'Migratie & pijplijnbouw',
              duration: '3-6 weken',
              description: 'We migreren de data en bouwen ETL-processen en warehousemodellen verder uit, met controle op de uitkomsten.',
              deliverables: ['Datamigratie', 'ETL-processen', 'Regels voor datakwaliteit', 'Ingerichte monitoring']
            },
            {
              phase: 'Optimalisatie & ondersteuning',
              duration: 'Doorlopend',
              description: 'Doorlopende tuning, monitoring en ondersteuning voor databases en pijplijnen.',
              deliverables: ['Prestatieoptimalisatie', 'Monitoring en meldingen', '24/7 ondersteuning', 'Doorlopende verbetering']
            }
          ]
        },
        benefits: {
          title: 'Wat het oplevert',
          description: 'Meetbare verbeteringen in de snelheid van databases, de beschikbaarheid van data en de betrouwbaarheid.',
          outcomes: [
            {
              label: 'Betere prestaties',
              description: 'Het afstellen van queries en indexen verkort de responstijd van kritieke toepassingen.'
            },
            {
              label: 'Snellere dataverwerking',
              description: 'Goed aangestuurde pijplijnen brengen data sneller van de bron naar het warehouse.'
            },
            {
              label: 'Snellere rapportage',
              description: 'Een goed gemodelleerd warehouse maakt van trage queries snelle, herbruikbare rapportages.'
            },
            {
              label: 'Back-up en herstel geregeld',
              description: 'Automatische back-ups en geteste herstelprocedures beschermen uw belangrijkste data.'
            }
          ]
        }
      },
      aiAutomation: {
        title: 'AI & automatisering',
        subtitle: 'AI-agents, procesautomatisering & document-AI',
        description: 'Zet AI in voor echte processen: automatiseer workflows tussen uw tools met n8n en Make, laat AI-agents en chatbots bouwen die uw eigen documenten kennen en laat documenten automatisch verwerken. Alles wordt opgeleverd in lijn met de AVG en de AI-verordening.',
        heroContent: {
          mainTitle: 'AI & automatisering',
          subtitle: 'AI-agents, procesautomatisering en document-AI, gekoppeld aan de tools die u al gebruikt',
          keyPoints: [
            'Processen automatiseren tussen uw tools met n8n, Make en Zapier',
            'AI-agents en chatbots die antwoorden op basis van uw bedrijfsdocumenten',
            'Documenten automatisch verwerken, uitlezen en classificeren',
            'Elke oplossing uitgerold met CI/CD en degelijke koppelingen'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Handwerk en tools die niet op elkaar aansluiten',
            description: 'Medewerkers kopiëren gegevens van het ene naar het andere systeem, beantwoorden steeds dezelfde vragen en verwerken documenten met de hand. Ondertussen komen veelbelovende AI-pilots nooit in productie.',
            challenges: [
              'Steeds hetzelfde handwerk in tools die niet met elkaar gekoppeld zijn',
              'Vragen van klanten en collega\'s die telkens opnieuw beantwoord moeten worden',
              'Documenten die met de hand worden verwerkt en overgetypt',
              'AI-experimenten die stranden voordat ze in productie gaan'
            ]
          },
          solution: {
            title: 'AI die echt in gebruik gaat',
            description: 'We bouwen automatiseringen, AI-agents en documentworkflows op beproefde platforms en zetten ze live met degelijke koppelingen en CI/CD.',
            benefits: [
              'Automatische workflows die uw bestaande tools met elkaar verbinden',
              'AI-agents die werken met uw eigen documenten en data',
              'Documentverwerking en gegevensinvoer zonder handwerk',
              'Koppelingen die worden uitgerold, bewaakt en onderhouden'
            ]
          }
        },
        features: [
          {
            title: 'AI-procesautomatisering',
            description: 'Automatiseer bedrijfsprocessen tussen uw tools met n8n, Make, Zapier en API-koppelingen op maat, van het doorzetten van leads tot het verwerken van facturen.',
            capabilities: [
              'Processen in kaart brengen en automatisering ontwerpen',
              'Workflows in n8n, Make en Zapier',
              'API- en webhookkoppelingen op maat',
              'Foutafhandeling en monitoring'
            ]
          },
          {
            title: 'AI-agents & chatbots',
            description: 'Assistenten voor klantenservice en intern gebruik, gebouwd op Claude en OpenAI, die met retrieval-augmented generation (RAG) antwoorden op basis van uw documenten.',
            capabilities: [
              'Agents voor klantenservice en interne vragen',
              'Retrieval-augmented generation op basis van bedrijfsdocumenten',
              'Koppeling met LLM\'s en API\'s (Claude, OpenAI)',
              'Guardrails, evaluatie en monitoring'
            ]
          },
          {
            title: 'Document- & data-AI',
            description: 'Automatiseer de verwerking van documenten (uitlezen, classificeren en invoeren), zodat gegevens in uw systemen terechtkomen zonder dat iemand ze hoeft over te typen.',
            capabilities: [
              'Uitlezen en ontleden van documenten',
              'Classificeren en doorsturen',
              'Automatische invoer in uw systemen',
              'Controle door een medewerker waar nodig (human-in-the-loop)'
            ]
          },
          {
            title: 'AI-analyse & inzichten',
            description: 'Rapportages, prognoses en ondersteuning bij beslissingen met behulp van AI, zodat uw data op tijd heldere antwoorden geeft.',
            capabilities: [
              'Rapportages en samenvattingen met AI',
              'Prognoses en trends signaleren',
              'Ondersteuning bij beslissingen en aanbevelingen',
              'Dashboards en meldingen'
            ]
          }
        ],
        technologies: {
          title: 'AI- en automatiseringstools',
          description: 'De modellen, automatiseringsplatforms en tools waarmee we bouwen en uitrollen.',
          platforms: [
            { name: 'Claude (Anthropic) API', category: 'LLM-aanbieder' },
            { name: 'OpenAI API', category: 'LLM-aanbieder' },
            { name: 'n8n', category: 'Procesautomatisering' },
            { name: 'Make / Zapier', category: 'Automatiseringsplatforms' },
            { name: 'LangChain', category: 'Framework voor agents' },
            { name: 'GitHub Actions', category: 'CI/CD-platform' }
          ]
        },
        implementation: {
          title: 'Onze aanpak',
          description: 'Van een afgebakende use case naar een werkende automatisering die in productie draait en wordt bewaakt.',
          phases: [
            {
              phase: 'Verkenning & afbakening',
              duration: '1-2 weken',
              description: 'We zoeken de processen waar automatisering het meest oplevert, beoordelen de databronnen en bepalen wanneer het project geslaagd is.',
              deliverables: ['Beoordeling van processen en data', 'Use cases op volgorde van prioriteit', 'Succescriteria', 'Oplossingsontwerp']
            },
            {
              phase: 'Prototype & validatie',
              duration: '2-3 weken',
              description: 'We bouwen een werkend prototype en testen met echte data hoe nauwkeurig het is en of het bij uw werkwijze past.',
              deliverables: ['Werkend prototype', 'Resultaten van nauwkeurigheidstests en evaluatie', 'Integratieplan', 'Vastgelegde guardrails']
            },
            {
              phase: 'Integratie & uitrol',
              duration: '2-4 weken',
              description: 'We koppelen de oplossing aan uw systemen en rollen die uit met CI/CD, tests en monitoring.',
              deliverables: ['Koppelingen met uw systemen', 'CI/CD-pijplijn', 'Geautomatiseerde tests', 'Monitoring en meldingen']
            },
            {
              phase: 'Optimalisatie & ondersteuning',
              duration: 'Doorlopend',
              description: 'We bewaken de resultaten, verfijnen prompts en workflows en breiden de automatisering uit naar meer processen.',
              deliverables: ['Bewaking van de resultaten', 'Verfijning van prompts en workflows', 'Uitrol van nieuwe automatiseringen', 'Doorlopende ondersteuning']
            }
          ]
        },
        benefits: {
          title: 'Wat het oplevert',
          description: 'Concrete tijdsbesparing en snellere antwoorden door automatisering en AI.',
          outcomes: [
            {
              label: 'Minder handmatig werk',
              description: 'Geautomatiseerde workflows nemen repetitief kopiëren, routeren en overtypen weg.'
            },
            {
              label: 'Altijd beschikbare agents',
              description: 'Assistenten handelen routinevragen rond de klok af.'
            },
            {
              label: 'Snellere documentverwerking',
              description: 'Automatisch uitlezen en classificeren vervangt het handmatig overtypen.'
            },
            {
              label: 'Snellere reactietijd',
              description: 'Agents en automatiseringen handelen veelvoorkomende verzoeken direct af.'
            }
          ]
        }
      },
      webSoftwareDevelopment: {
        title: 'Web- & softwareontwikkeling',
        subtitle: 'Maatwerksoftware, webapps, SaaS & portalen laten maken',
        description: 'Laat snelle, veilige webapplicaties en maatwerksoftware ontwikkelen met React, Next.js en TypeScript, van SaaS en portalen tot interne tools. U krijgt de broncode en zit niet vast aan één leverancier.',
        heroContent: {
          mainTitle: 'Web- & softwareontwikkeling',
          subtitle: 'Maatwerksoftware laten maken: webapplicaties en websites die we bouwen én onderhouden',
          keyPoints: [
            'Webapplicaties op maat',
            'Ontwerp van interface en gebruikerservaring',
            'Prestaties, toegankelijkheid en beveiliging',
            'Doorlopend onderhoud en ondersteuning'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Webprojecten die tekortschieten',
            description: 'Verouderde technologie, trage pagina\'s en onhandige interfaces zorgen voor afhakende bezoekers en minder conversies, terwijl beveiliging en onderhoud steeds worden uitgesteld.',
            challenges: [
              'Verouderde technologie die de mogelijkheden beperkt',
              'Een matige gebruikerservaring waardoor bezoekers afhaken',
              'Trage pagina\'s en slechte Core Web Vitals',
              'Beveiliging en onderhoud die blijven liggen'
            ]
          },
          solution: {
            title: 'Websoftware die goed in elkaar zit',
            description: 'We bouwen responsieve, toegankelijke webapplicaties met moderne technologie, geoptimaliseerd voor snelheid en veiligheid, en blijven ze na de livegang ondersteunen.',
            benefits: [
              'Moderne, responsieve applicaties en websites',
              'Interfaces ontworpen rond wat gebruikers echt moeten doen',
              'Snel ladende pagina\'s en goede Core Web Vitals',
              'Goed onderhouden, veilig en up-to-date'
            ]
          }
        },
        features: [
          {
            title: 'Webapplicaties op maat',
            description: 'Applicaties gebouwd met React, Next.js en Node.js, met goed ontworpen API\'s en databases.',
            capabilities: [
              'React- en Next.js-applicaties',
              'Backendontwikkeling in Node.js',
              'Ontwikkeling en koppeling van API\'s',
              'Databaseontwerp en -optimalisatie'
            ]
          },
          {
            title: 'UX- & interfaceontwerp',
            description: 'Responsieve, toegankelijke interfaces, ontworpen rond wat gebruikers echt doen en getest op alle apparaten.',
            capabilities: [
              'Ontwerp van de gebruikersinterface',
              'Responsief ontwerp voor alle apparaten',
              'Optimalisatie van de gebruikerservaring',
              'Toegankelijkheid volgens WCAG'
            ]
          },
          {
            title: 'Prestaties & beveiliging',
            description: 'Optimalisatie van de Core Web Vitals en extra beveiliging (hardening) voor snelle, betrouwbare applicaties.',
            capabilities: [
              'Optimalisatie van de Core Web Vitals',
              'Hardening en best practices voor beveiliging',
              'Technische basis voor SEO',
              'Ondersteuning bij compliance en audits'
            ]
          },
          {
            title: 'Onderhoud & ondersteuning',
            description: 'Doorlopende updates, monitoring en ondersteuning om applicaties actueel en veilig te houden.',
            capabilities: [
              'Regelmatige updates en onderhoud',
              'Monitoring van prestaties en uptime',
              'Beveiligingspatches',
              'Snelle technische ondersteuning'
            ]
          }
        ],
        technologies: {
          title: 'Technologie waarmee we werken',
          description: 'Ervaring met een moderne stack voor webontwikkeling.',
          platforms: [
            { name: 'React', category: 'Frontend-framework' },
            { name: 'Next.js', category: 'Fullstack-framework' },
            { name: 'Node.js', category: 'Backend-runtime' },
            { name: 'TypeScript', category: 'Programmeertaal' },
            { name: 'Tailwind CSS', category: 'CSS-framework' },
            { name: 'PostgreSQL', category: 'Database' }
          ]
        },
        implementation: {
          title: 'Ontwikkelproces',
          description: 'Een gestructureerde aanpak die zorgt voor kwaliteit en oplevering op tijd.',
          phases: [
            {
              phase: 'Planning & ontwerp',
              duration: '1-2 weken',
              description: 'We brengen de eisen in kaart, doen gebruikersonderzoek en ontwerpen de oplossing.',
              deliverables: ['Programma van eisen', 'UX-ontwerp', 'Technische architectuur', 'Projectplanning']
            },
            {
              phase: 'Ontwikkeling & testen',
              duration: '4-8 weken',
              description: 'We ontwikkelen de applicatie en testen en bewaken de kwaliteit doorlopend.',
              deliverables: ['Frontendontwikkeling', 'Backendontwikkeling', 'Integratietests', 'Kwaliteitsborging']
            },
            {
              phase: 'Uitrol & livegang',
              duration: '1-2 weken',
              description: 'Uitrol naar productie, optimalisatie van de prestaties en begeleiding bij de livegang.',
              deliverables: ['Uitrol naar productie', 'Prestatieoptimalisatie', 'Gebruikerstraining', 'Begeleiding bij de livegang']
            },
            {
              phase: 'Onderhoud & ondersteuning',
              duration: 'Doorlopend',
              description: 'Doorlopend onderhoud, updates en ondersteuning, zodat de applicatie betrouwbaar blijft werken.',
              deliverables: ['Regelmatig onderhoud', 'Nieuwe functies', 'Prestatiemonitoring', 'Technische ondersteuning']
            }
          ]
        },
        benefits: {
          title: 'Wat het oplevert',
          description: 'Meetbare resultaten van websoftware die goed gebouwd is en goed onderhouden wordt.',
          outcomes: [
            {
              label: 'Gebruikersbetrokkenheid',
              description: 'Responsief ontwerp en helderere interfaces verhogen betrokkenheid en conversies.'
            },
            {
              label: 'Snellere paginalaadtijden',
              description: 'Prestatietuning verlaagt laadtijden en verbetert Core Web Vitals.'
            },
            {
              label: 'Prestatiebudgetten',
              description: 'Builds worden vóór oplevering getoetst aan Lighthouse en Core Web Vitals.'
            },
            {
              label: 'Responsieve dekking',
              description: 'Applicaties werken op mobiel, tablet en desktop.'
            }
          ]
        }
      },
      mobileAppDevelopment: {
        title: 'App-ontwikkeling',
        subtitle: 'Apps voor iOS en Android laten maken, met backend en publicatie',
        description: 'Laat een app voor iOS en Android bouwen voor uw klanten of uw eigen medewerkers: native of cross-platform met React Native of Flutter, samen met de backend en API, publicatie in de App Store en Google Play, en onderhoud na de lancering.',
        heroContent: {
          mainTitle: 'App-ontwikkeling',
          subtitle: 'Apps voor iOS en Android, van eerste prototype tot publicatie in de stores en daarna',
          keyPoints: [
            'Apps die op iOS en Android natuurlijk aanvoelen',
            'Cross-platform met React Native of Flutter, of native in Swift en Kotlin waar nodig',
            'Backend, API en beheeromgeving bij de app gebouwd',
            'Publicatie in de App Store en Google Play en doorlopende updates'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Een app-idee zonder duidelijke weg naar de store',
            description: 'Een klantapp of een app voor de buitendienst blijft vaak hangen tussen idee en lancering: twee platformen, een backend waar niemand aan had gedacht, de beoordeling door de stores, en niemand die de app bijhoudt na de volgende update van iOS of Android.',
            challenges: [
              'Onduidelijk of u beter native of cross-platform kunt bouwen',
              'Geen backend of API waar de app mee kan praten',
              'Indienen, ondertekenen en privacygegevens voor de stores pas aan het eind geregeld',
              'Apps die na een systeemupdate niet meer werken omdat niemand ze onderhoudt'
            ]
          },
          solution: {
            title: 'Eén team van prototype tot store en updates',
            description: 'We bepalen de app aan de hand van wat uw gebruikers er echt mee doen, kiezen de aanpak die past, bouwen app en backend samen, begeleiden de beoordeling door de stores en houden de app daarna actueel.',
            benefits: [
              'Een platformkeuze die vooraf is uitgelegd en afgestemd',
              'App en backend ontworpen als één systeem',
              'Publicatie in de stores vanaf de eerste sprint voorbereid, niet in de laatste week',
              'Een onderhoudsplan voor systeemupdates, libraries en bugfixes'
            ]
          }
        },
        features: [
          {
            title: 'Apps voor iOS en Android',
            description: 'Apps die er op elk platform uitzien en werken zoals gebruikers verwachten, cross-platform gebouwd met React Native of Flutter, of native in Swift en Kotlin als de app diepe toegang tot het toestel nodig heeft.',
            capabilities: [
              'Cross-platformontwikkeling met React Native of Flutter',
              'Native ontwikkeling voor iOS (Swift) en Android (Kotlin)',
              'Offline gebruik, camera, locatie en pushmeldingen',
              'Toegankelijke schermen voor telefoon en tablet'
            ]
          },
          {
            title: 'Backend & API',
            description: 'De serverkant waar de app op draait: API\'s, gebruikersaccounts, databases en een beheeromgeving voor uw team, of een koppeling met systemen die u al gebruikt. Persoonsgegevens verwerken we met de AVG in het achterhoofd.',
            capabilities: [
              'Ontwikkeling van een REST- of GraphQL-API',
              'Inloggen en gebruikersbeheer',
              'Beheeromgeving voor content en gebruikers',
              'Koppelingen met bestaande bedrijfssystemen'
            ]
          },
          {
            title: 'Publicatie in App Store en Google Play',
            description: 'We bereiden de release voor en dienen hem in: ontwikkelaarsaccounts, ondertekening, de vermelding in de store en de privacy- en toestemmingsinformatie die beide stores vragen.',
            capabilities: [
              'Ontwikkelaarsaccounts en ondertekening',
              'Storevermelding, screenshots en teksten',
              'Privacy- en toestemmingsverklaringen',
              'Testversies via TestFlight en de testtracks van Google Play'
            ]
          },
          {
            title: 'Onderhoud & updates',
            description: 'Een app vraagt regelmatig onderhoud om te blijven werken op nieuwe versies van iOS en Android. Wij regelen updates, monitoring en nieuwe functies na de lancering.',
            capabilities: [
              'Updates voor nieuwe versies van het besturingssysteem',
              'Updates van libraries en beveiliging',
              'Crashrapportage en monitoring',
              'Geplande releases met nieuwe functies'
            ]
          }
        ],
        technologies: {
          title: 'Mobiele technologie',
          description: 'Frameworks en talen waarmee we mobiele apps bouwen en draaiende houden.',
          platforms: [
            { name: 'React Native', category: 'Cross-platformframework' },
            { name: 'Flutter', category: 'Cross-platformframework' },
            { name: 'Swift', category: 'Native iOS' },
            { name: 'Kotlin', category: 'Native Android' },
            { name: 'Node.js', category: 'Backend & API' },
            { name: 'Firebase', category: 'Pushmeldingen & inloggen' }
          ]
        },
        implementation: {
          title: 'Zo bouwen we uw app',
          description: 'Van afgebakend idee tot gepubliceerde app, in korte stappen met testversies die u op uw eigen telefoon installeert.',
          phases: [
            {
              phase: 'Verkenning & prototype',
              duration: '2-3 weken',
              description: 'We bepalen gebruikers, kerntaken en platformaanpak, en testen de belangrijkste schermen in een klikbaar prototype.',
              deliverables: ['Functionele afbakening en gebruikersstromen', 'Advies native of cross-platform', 'Klikbaar prototype', 'Technische architectuur']
            },
            {
              phase: 'Ontwikkeling & testen',
              duration: '6-12 weken',
              description: 'We bouwen app en backend in korte iteraties, met na elke iteratie een testversie op echte toestellen.',
              deliverables: ['App-builds voor iOS en Android', 'Backend en API', 'Testversies via TestFlight en Google Play', 'Geautomatiseerde tests en tests op toestellen']
            },
            {
              phase: 'Publicatie in de stores',
              duration: '1-2 weken',
              description: 'We maken de storevermelding, privacy-informatie en releaseversies klaar en begeleiden de beoordeling door App Store en Google Play.',
              deliverables: ['Storevermelding en screenshots', 'Privacy- en toestemmingsverklaringen', 'Ondertekende releaseversies', 'Crashrapportage ingericht']
            },
            {
              phase: 'Onderhoud & updates',
              duration: 'Doorlopend',
              description: 'We houden de app werkend op nieuwe systeemversies en brengen verbeteringen uit in geplande releases.',
              deliverables: ['Updates van besturingssysteem en libraries', 'Bugfixes en monitoring', 'Nieuwe functies', 'Bijwerken van de storevermelding']
            }
          ]
        },
        benefits: {
          title: 'Zakelijke impact',
          description: 'Wat een goed gebouwde, onderhouden app uw bedrijf oplevert.',
          outcomes: [
            {
              label: 'Eén codebase, twee platformen',
              description: 'Bij een cross-platform aanpak delen iOS en Android het grootste deel van de code, zodat nieuwe functies op beide tegelijk verschijnen.'
            },
            {
              label: 'Broncode in uw bezit',
              description: 'U krijgt de broncode van de app en de backend, zodat u niet vastzit aan één leverancier.'
            },
            {
              label: 'Minder verrassingen bij publicatie',
              description: 'De eisen van de stores nemen we mee tijdens de bouw, zodat knelpunten vroeg boven water komen.'
            },
            {
              label: 'Blijft actueel',
              description: 'Regelmatig onderhoud houdt de app werkend terwijl iOS en Android veranderen.'
            }
          ]
        }
      },
      crmDevelopment: {
        title: 'CRM-systemen',
        subtitle: 'CRM op maat, CRM-inrichting en koppelingen',
        description: 'Een CRM dat past bij hoe uw team verkoopt en klanten bedient: een CRM op maat, of HubSpot, Salesforce of Microsoft Dynamics 365 ingericht en uitgebreid, gekoppeld aan uw e-mail, facturatie en website, met uw gegevens uit spreadsheets overgezet.',
        heroContent: {
          mainTitle: 'CRM-systemen',
          subtitle: 'Klantgegevens, verkoopkansen en opvolging in één systeem dat bij uw werkwijze past',
          keyPoints: [
            'CRM op maat, gebouwd rond uw verkoop- en serviceproces',
            'Inrichten en uitbreiden van een bestaand CRM',
            'Koppelingen met e-mail, facturatie en uw website',
            'Overstap vanuit spreadsheets en oude systemen'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Klantgegevens verspreid over spreadsheets en mailboxen',
            description: 'Leads komen binnen via e-mail, webformulier en telefoon, offertes staan in een spreadsheet en facturen in weer een ander systeem. Opvolging schiet erbij in en niemand heeft het volledige beeld van een klant.',
            challenges: [
              'Leads en deals bijgehouden in spreadsheets of persoonlijke mailboxen',
              'Een CRM-licentie die het team niet gebruikt omdat het niet bij de werkwijze past',
              'Dubbel invoeren tussen CRM, facturatie en website',
              'Geen betrouwbaar overzicht van de pijplijn en openstaande acties'
            ]
          },
          solution: {
            title: 'Een CRM dat uw werkwijze volgt',
            description: 'We brengen in kaart hoe klanten door uw bedrijf lopen en bouwen daar een CRM voor, of richten het CRM dat u al heeft in en breiden het uit. Daarna koppelen we het aan de tools die uw team al gebruikt.',
            benefits: [
              'Pijplijnen, velden en fases die bij uw verkoopproces passen',
              'Webformulieren en e-mail komen direct in het CRM',
              'Klant- en factuurgegevens blijven gesynchroniseerd',
              'Bestaande gegevens opgeschoond en geïmporteerd, niet overgetypt'
            ]
          }
        },
        features: [
          {
            title: 'CRM op maat',
            description: 'Een CRM gebouwd voor uw proces als standaardpakketten slecht aansluiten, met de schermen, velden en rechten die uw team nodig heeft en niets meer.',
            capabilities: [
              'Eigen datamodel voor klanten, deals en projecten',
              'Rechten per rol en bewaartermijnen met de AVG in het achterhoofd',
              'Dashboards en pijplijnrapportages',
              'Werkt in de browser en op mobiel'
            ]
          },
          {
            title: 'CRM inrichten & uitbreiden',
            description: 'Inrichting en uitbreiding van HubSpot, Salesforce, Microsoft Dynamics 365 of Odoo: pijplijnen, eigen velden, automatiseringen, en uitbreidingen waar de standaardinrichting tekortschiet.',
            capabilities: [
              'Ontwerp van pijplijn en fases',
              'Eigen velden, objecten en weergaven',
              'Automatische workflows en herinneringen',
              'Maatwerkuitbreidingen via de API van het platform'
            ]
          },
          {
            title: 'Koppelingen',
            description: 'Verbindingen tussen het CRM en uw andere tools, zodat gegevens één keer worden ingevoerd en overal kloppen.',
            capabilities: [
              'Koppeling met e-mail en agenda',
              'Koppeling met facturatie en boekhouding',
              'Leads uit uw website en webformulieren',
              'Synchronisatie in twee richtingen met andere bedrijfssystemen'
            ]
          },
          {
            title: 'Overstap vanuit spreadsheets',
            description: 'Uw bestaande klantgegevens naar het CRM: opgeschoond, ontdubbeld, omgezet naar de nieuwe structuur en gecontroleerd vóór de livegang.',
            capabilities: [
              'Inventarisatie van spreadsheets en tools',
              'Opschonen en ontdubbelen',
              'Veldmapping en proefimports',
              'Controle samen met uw team vóór de livegang'
            ]
          }
        ],
        technologies: {
          title: 'CRM-platformen & tools',
          description: 'Platformen die we inrichten en uitbreiden, en de tools die we gebruiken voor maatwerk en koppelingen.',
          platforms: [
            { name: 'HubSpot', category: 'CRM-platform' },
            { name: 'Salesforce', category: 'CRM-platform' },
            { name: 'Microsoft Dynamics 365', category: 'CRM & bedrijfsapplicaties' },
            { name: 'Odoo', category: 'Open-source CRM & ERP' },
            { name: 'PostgreSQL', category: 'Database voor CRM op maat' },
            { name: 'n8n', category: 'Integratieworkflows' }
          ]
        },
        implementation: {
          title: 'Zo implementeren we uw CRM',
          description: 'Een stapsgewijze route van verspreide klantgegevens naar een CRM dat uw team echt gebruikt.',
          phases: [
            {
              phase: 'Proces in kaart',
              duration: '1-2 weken',
              description: 'We brengen in kaart hoe leads, deals en klanten nu door uw bedrijf lopen en bepalen of bouwen of inrichten de beste route is.',
              deliverables: ['Overzicht van verkoop- en serviceproces', 'Inventarisatie van huidige gegevens en tools', 'Advies bouwen of inrichten', 'Afbakening en planning']
            },
            {
              phase: 'Bouwen & inrichten',
              duration: '3-8 weken',
              description: 'We richten het CRM in of bouwen het, en koppelen het aan e-mail, facturatie en uw website.',
              deliverables: ['Pijplijnen, velden en rollen', 'Maatwerkschermen of uitbreidingen', 'Koppelingen', 'Automatiseringen en herinneringen']
            },
            {
              phase: 'Migratie & training',
              duration: '1-3 weken',
              description: 'We importeren opgeschoonde gegevens, controleren ze met uw team en trainen elke rol op het dagelijks gebruik.',
              deliverables: ['Opgeschoonde, ontdubbelde import', 'Proefmigratie en akkoord', 'Training per rol', 'Ondersteuning bij de livegang']
            },
            {
              phase: 'Support & verbetering',
              duration: 'Doorlopend',
              description: 'We passen pijplijnen, rapportages en koppelingen aan als uw werkwijze verandert.',
              deliverables: ['Gebruikersondersteuning', 'Aanpassingen aan velden en workflows', 'Monitoring van koppelingen', 'Nieuwe rapportages en automatiseringen']
            }
          ]
        },
        benefits: {
          title: 'Zakelijke impact',
          description: 'Wat een CRM dat bij uw werkwijze past uw team oplevert.',
          outcomes: [
            {
              label: 'Eén beeld per klant',
              description: 'Contactpersonen, deals, e-mails en facturen van een klant staan op één plek.'
            },
            {
              label: 'Minder gemiste opvolging',
              description: 'Herinneringen en pijplijnfases maken openstaande acties zichtbaar.'
            },
            {
              label: 'Minder dubbel werk',
              description: 'Koppelingen zetten gegevens over tussen systemen, in plaats van dat iemand ze overtypt.'
            },
            {
              label: 'Gemaakt voor dagelijks gebruik',
              description: 'Schermen en velden volgen uw proces, waardoor het CRM makkelijker bij te houden is.'
            }
          ]
        }
      },
      erpSystems: {
        title: 'ERP-systemen',
        subtitle: 'ERP-koppelingen, maatwerkmodules & datamigratie',
        description: 'Koppel en breid het ERP-systeem uit waar uw bedrijf op draait, zoals Exact Online, AFAS, Microsoft Dynamics 365 Business Central of Odoo: maatwerkmodules, koppelingen met uw webshop, CRM en boekhouding, en een datamigratie die stap voor stap wordt getest en gecontroleerd.',
        heroContent: {
          mainTitle: 'ERP-systemen',
          subtitle: 'Uw ERP gekoppeld aan de rest van uw bedrijf, uitgebreid waar de standaard tekortschiet',
          keyPoints: [
            'Koppelingen tussen uw ERP en uw webshop, CRM en boekhouding',
            'Maatwerkmodules en uitbreidingen voor processen die de standaard niet dekt',
            'Datamigratie uit oude systemen, met controle op de uitkomsten',
            'Ondersteuning als ERP-versies en API\'s veranderen'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Een ERP dat op zichzelf staat',
            description: 'Orders worden met de hand overgenomen uit de webshop, voorraden verschillen per systeem, en de processen die uw bedrijf onderscheiden lopen via spreadsheets naast het ERP.',
            challenges: [
              'Orders, klanten en facturen handmatig overnemen tussen systemen',
              'Verschillen in voorraad en prijzen tussen ERP en webshop',
              'Processen die het standaard-ERP niet ondersteunt, opgelost in spreadsheets',
              'Een geplande ERP-overstap met jaren aan gegevens om over te zetten'
            ]
          },
          solution: {
            title: 'Een ERP dat aansluit op de rest van uw bedrijf',
            description: 'We brengen in kaart hoe gegevens tussen uw systemen lopen, bouwen de koppelingen en modules die de gaten dichten, en zetten gegevens over met proefmigraties en controles voordat er iets live gaat.',
            benefits: [
              'Orders, klanten en voorraad automatisch gesynchroniseerd',
              'Maatwerkmodules die uw eigen processen volgen',
              'Koppelingen met logging en foutmeldingen, zodat problemen opvallen',
              'Datamigratie getest vóór de overstap'
            ]
          }
        },
        features: [
          {
            title: 'ERP koppelen & uitbreiden',
            description: 'We werken met het ERP dat u al gebruikt, zoals Exact Online, AFAS, Business Central of Odoo, via de API\'s en uitbreidingsmogelijkheden van het pakket.',
            capabilities: [
              'Analyse van uw huidige ERP-inrichting',
              'Gebruik van standaard-API\'s en connectoren',
              'Inrichting van bestaande modules',
              'Documentatie van elke aanpassing'
            ]
          },
          {
            title: 'Maatwerkmodules',
            description: 'Modules of aanvullende applicaties voor processen die uw ERP niet dekt, zoals planning, productiestappen, servicebezoeken of klantportalen, op dezelfde gegevens.',
            capabilities: [
              'Maatwerkmodules voor Odoo of Business Central',
              'Aanvullende webapps op ERP-gegevens',
              'Klant- en leveranciersportalen',
              'Rapportages en dashboards uit ERP-gegevens'
            ]
          },
          {
            title: 'Koppelingen',
            description: 'Verbindingen tussen het ERP en uw webshop, CRM, boekhouding en logistieke tools, met logging en meldingen zodat een mislukte synchronisatie niet onopgemerkt blijft.',
            capabilities: [
              'Webshopkoppeling voor orders, voorraad en prijzen',
              'Synchronisatie van klanten en orders tussen CRM en ERP',
              'Koppeling met boekhouding en facturatie',
              'Monitoring, logging en foutmeldingen'
            ]
          },
          {
            title: 'Datamigratie',
            description: 'Klanten, artikelen, openstaande posten en historie uit een oud systeem naar het nieuwe ERP, met proefmigraties en aansluiting van de cijfers vóór de livegang.',
            capabilities: [
              'Inventarisatie en beoordeling van datakwaliteit',
              'Mapping- en conversiescripts',
              'Proefmigraties in een testomgeving',
              'Aansluiting van totalen met het oude systeem'
            ]
          }
        ],
        technologies: {
          title: 'ERP-pakketten & integratietools',
          description: 'ERP-pakketten die veel voorkomen in het Nederlandse MKB en die we koppelen en uitbreiden, plus de tools waarmee we ze integreren.',
          platforms: [
            { name: 'Exact Online', category: 'Boekhouding & ERP' },
            { name: 'AFAS', category: 'ERP- & HR-pakket' },
            { name: 'Microsoft Dynamics 365 Business Central', category: 'ERP' },
            { name: 'Odoo', category: 'Modulair ERP' },
            { name: 'n8n', category: 'Integratieworkflows' },
            { name: 'PostgreSQL', category: 'Staging- & rapportagedatabase' }
          ]
        },
        implementation: {
          title: 'Zo pakken we uw ERP-koppeling aan',
          description: 'Een zorgvuldige volgorde voor aanpassingen aan het systeem waar uw financiën en bedrijfsvoering op draaien.',
          phases: [
            {
              phase: 'Analyse',
              duration: '2-3 weken',
              description: 'We brengen uw systemen, gegevensstromen en de processen die het ERP nu niet dekt in kaart.',
              deliverables: ['Overzicht van systemen en gegevensstromen', 'Eisen voor koppelingen en modules', 'Beoordeling van datakwaliteit', 'Implementatieplan']
            },
            {
              phase: 'Bouwen & koppelen',
              duration: '4-10 weken',
              description: 'We ontwikkelen koppelingen en maatwerkmodules en testen ze in een testomgeving, niet in uw live administratie.',
              deliverables: ['API-koppelingen', 'Maatwerkmodules of uitbreidingen', 'Logging en foutafhandeling', 'Testruns met echte scenario\'s']
            },
            {
              phase: 'Migratie & livegang',
              duration: '2-4 weken',
              description: 'We draaien proefmigraties, sluiten de uitkomsten aan met het oude systeem en plannen de overstap samen met uw team.',
              deliverables: ['Migratiescripts en proefruns', 'Aansluitingsrapportages', 'Overstapplan', 'Ondersteuning bij de livegang']
            },
            {
              phase: 'Support & onderhoud',
              duration: 'Doorlopend',
              description: 'We bewaken de koppelingen en passen ze aan als het ERP of gekoppelde systemen veranderen.',
              deliverables: ['Monitoring van koppelingen', 'Aanpassingen bij wijzigingen in ERP en API\'s', 'Fixes en uitbreidingen', 'Actuele documentatie']
            }
          ]
        },
        benefits: {
          title: 'Zakelijke impact',
          description: 'Wat een gekoppeld ERP dat bij uw processen past uw bedrijf oplevert.',
          outcomes: [
            {
              label: 'Minder handmatige invoer',
              description: 'Orders, klanten en facturen gaan automatisch tussen systemen.'
            },
            {
              label: 'Kloppende voorraad en prijzen',
              description: 'Webshop en ERP werken met dezelfde cijfers.'
            },
            {
              label: 'Processen die passen',
              description: 'Maatwerkmodules dekken de stappen die uw bedrijf onderscheiden.'
            },
            {
              label: 'Gecontroleerde migratie',
              description: 'Proefruns en aansluitingen vangen dataproblemen af vóór de livegang.'
            }
          ]
        }
      },
      deviceManagement: {
        title: 'Device management',
        subtitle: 'Windows, macOS, Linux, ChromeOS, iOS, Android',
        description: 'Beveilig elk Windows-, macOS-, Linux- en mobiel endpoint met Intune, Jamf en automatische compliance, zodat inventaris, beleid en patches op elkaar afgestemd blijven.',
        heroContent: {
          mainTitle: 'Device management',
          subtitle: 'End-to-end device management voor Windows en macOS: Microsoft Intune en SCCM voor Windows, en Jamf Pro voor macOS',
          keyPoints: [
            'Geavanceerde bedreigingsbescherming op alle endpoints',
            'Unified device management en compliance',
            'Implementatie van een zero-trust-beveiligingsarchitectuur',
            'Geautomatiseerde incidentrespons en remediatie'
          ]
        },
        problemSolution: {
          problem: {
            title: 'De uitdaging van endpointbeveiliging',
            description: 'Moderne bedrijven worden geconfronteerd met ongekende beveiligingsuitdagingen door verspreid werkende medewerkers, BYOD-beleid en geavanceerde cyberbedreigingen die endpoints als primaire aanvalsvector gebruiken.',
            challenges: [
              'Versnipperde beveiligingstools die blinde vlekken veroorzaken',
              'Complexe compliancevereisten in verschillende rechtsgebieden',
              'Een snel veranderend bedreigingslandschap dat de verdediging voorbijstreeft',
              'Beperkte middelen die de effectiviteit van het beveiligingsteam drukken'
            ]
          },
          solution: {
            title: 'Onze uitgebreide aanpak',
            description: 'We bieden geïntegreerde endpointbeveiliging met volledig inzicht, controle en bescherming voor al uw apparaten.',
            benefits: [
              'Eén beveiligingsplatform dat de complexiteit vermindert',
              'Geautomatiseerde bedreigingsdetectie en -respons',
              'Gecentraliseerd beleidsbeheer en handhaving',
              'Continue compliancemonitoring en -rapportage'
            ]
          }
        },
        features: [
          {
            title: 'Geavanceerde bedreigingsbescherming',
            description: 'Meerlaagse beveiliging inclusief EDR, gedragsanalyse en AI-gestuurde bedreigingsdetectie om geavanceerde aanvallen te identificeren en te neutraliseren voordat ze uw bedrijf raken.',
            capabilities: [
              'Realtime bedreigingsdetectie en -analyse',
              'Gedragsanalyses en anomaliedetectie',
              'Geautomatiseerde workflows voor incidentrespons',
              'Integratie van bedreigingsinformatie'
            ]
          },
          {
            title: 'Unified device management',
            description: 'Centrale controle over en beheer van alle Windows-, macOS-, Linux-, iOS- en Android-apparaten vanuit één console.',
            capabilities: [
              'Apparaatinschrijving en provisioning op alle platforms',
              'Beleidsconfiguratie en handhaving',
              'Software-implementatie en patchbeheer',
              'Assetinventarisatie en levenscyclusbeheer'
            ]
          },
          {
            title: 'Zero-trust-architectuur',
            description: 'Implementeer zero-trust-beveiligingsprincipes met continue verificatie, toegang op basis van least privilege en microsegmentatie in uw hele endpointinfrastructuur.',
            capabilities: [
              'Identiteitsgebaseerde toegangscontroles',
              'Netwerksegmentatie en isolatie',
              'Continue authenticatie en autorisatie',
              'Risicogebaseerde toegangsbeslissingen'
            ]
          },
          {
            title: 'Compliance & rapportage',
            description: 'Borg naleving van regelgeving met geautomatiseerde rapportage, audittrails en beleidshandhaving voor meerdere kaders en standaarden.',
            capabilities: [
              'Geautomatiseerde compliancemonitoring',
              'Rapportages en dashboards op maat',
              'Onderhoud van audittrails',
              'Afstemming op regelgevingskaders'
            ]
          }
        ],
        technologies: {
          title: 'Technologiestack',
          description: 'De platforms en tools die we inzetten voor endpointbeveiliging.',
          platforms: [
            { name: 'Microsoft Intune', category: 'Device management' },
            { name: 'Microsoft Defender', category: 'Endpointbescherming' },
            { name: 'Jamf Pro', category: 'macOS-beheer' },
            { name: 'CrowdStrike Falcon', category: 'EDR-platform' },
            { name: 'SentinelOne', category: 'Autonome respons' },
            { name: 'VMware Workspace ONE', category: 'Unified endpoint management' }
          ]
        },
        implementation: {
          title: 'Implementatiemethodologie',
          description: 'Onze bewezen aanpak zorgt voor een succesvolle implementatie en adoptie van endpointbeveiliging.',
          phases: [
            {
              phase: 'Evaluatie & planning',
              duration: '1-2 weken',
              description: 'Uitgebreide beveiligingsevaluatie, gap-analyse en strategische planning voor de implementatie van endpointbeveiliging.',
              deliverables: ['Evaluatie van de beveiligingshouding', 'Risicoanalyserapport', 'Implementatieroadmap', 'Technologieaanbevelingen']
            },
            {
              phase: 'Ontwerp & configuratie',
              duration: '2-3 weken',
              description: 'Ontwerp van de oplossingsarchitectuur, beleidsconfiguratie en implementatie van het beveiligingskader.',
              deliverables: ['Ontwerp van de beveiligingsarchitectuur', 'Beleidsconfiguraties', 'Integratiespecificaties', 'Testprotocollen']
            },
            {
              phase: 'Implementatie & testen',
              duration: '2-4 weken',
              description: 'Gefaseerde implementatie per omgeving met uitgebreide test- en validatieprocedures.',
              deliverables: ['Pilotimplementatie', 'Prestatietesten', 'Beveiligingsvalidatie', 'Gebruikersacceptatietesten']
            },
            {
              phase: 'Training & optimalisatie',
              duration: '1-2 weken',
              description: 'Training van medewerkers, oplevering van documentatie en doorlopende optimalisatieadviezen.',
              deliverables: ['Trainingsmateriaal', 'Documentatie', 'Optimalisatieplan', 'Ondersteuningsprocedures']
            }
          ]
        },
        benefits: {
          title: 'Bedrijfsimpact',
          description: 'Verbeter uw beveiligingshouding, verhoog de operationele efficiëntie en verminder risico\'s.',
          outcomes: [
            {
              label: 'Nauwkeurige bedreigingsdetectie',
              description: 'Geavanceerde, AI-gestuurde detectie vermindert het aantal false positives en behoudt een brede dekking van bedreigingen.'
            },
            {
              label: 'Minder beveiligingsincidenten',
              description: 'Proactieve bedreigingspreventie en geautomatiseerde respons verminderen beveiligingsincidenten aanzienlijk.'
            },
            {
              label: 'Snellere incidentrespons',
              description: 'Geautomatiseerde workflows en gecentraliseerd beheer versnellen incidentdetectie en -oplossing.'
            },
            {
              label: 'Compliancedekking',
              description: 'Uitgebreide monitoring en rapportage zorgen voor continue compliance met alle regelgevingskaders.'
            }
          ]
        }
      },
      infrastructureManagement: {
        title: 'Infrastructure management',
        subtitle: 'Server-, device- en VM-beheer',
        description: 'Centraliseer server-, netwerk- en VM-beheer met monitoring, capaciteitsplanning en automatisch herstel, zodat hybride omgevingen snel, compliant en weerbaar zijn.',
        heroContent: {
          mainTitle: 'Infrastructure management',
          subtitle: 'Uitgebreid infrastructuurbeheer, inclusief serveradministratie, device management en optimalisatie van virtuele machines',
          keyPoints: [
            'Uitgebreide serveradministratie en monitoring',
            'Optimalisatie en beheer van virtuele machines',
            'Geautomatiseerde back-up en disaster recovery',
            'Prestatiemonitoring en capaciteitsplanning'
          ]
        },
        problemSolution: {
          problem: {
            title: 'De complexiteit van infrastructuur',
            description: 'Moderne bedrijven worstelen met complexe, gedistribueerde infrastructuur die constante monitoring, onderhoud en optimalisatie vereist om bedrijfscontinuïteit en prestaties te waarborgen.',
            challenges: [
              'Versnipperde monitoringtools die blinde vlekken veroorzaken',
              'Handmatige processen die operationele inefficiënties veroorzaken',
              'Uitdagingen bij capaciteitsplanning en resourceoptimalisatie',
              'Complexe back-up en disaster recovery'
            ]
          },
          solution: {
            title: 'Geïntegreerd infrastructuurbeheer',
            description: 'We bieden uitgebreid infrastructuurbeheer dat de controle centraliseert, processen automatiseert en optimale prestaties waarborgt in uw volledige IT-omgeving.',
            benefits: [
              'Gecentraliseerd monitoring- en beheerplatform',
              'Geautomatiseerde back-up- en herstelprocessen',
              'Proactieve prestatieoptimalisatie',
              'Uitgebreide capaciteitsplanning en schaling'
            ]
          }
        },
        features: [
          {
            title: 'Serveradministratie',
            description: 'Compleet beheer van de serverlevenscyclus, inclusief provisioning, configuratie, monitoring en onderhoud in Windows- en Linux-omgevingen.',
            capabilities: [
              'Serverprovisioning en -configuratie',
              'Prestatiemonitoring en -optimalisatie',
              'Patchbeheer en beveiligingsupdates',
              'Capaciteitsplanning en resourceoptimalisatie'
            ]
          },
          {
            title: 'Databasebeheer',
            description: 'Deskundige databaseadministratie en -optimalisatie die hoge beschikbaarheid, prestaties en beveiliging van uw kritieke datasystemen waarborgen.',
            capabilities: [
              'Installatie en configuratie van databases',
              'Prestatietuning en -optimalisatie',
              'Back-up- en herstelstrategieën',
              'Beveiligingshardening en compliance'
            ]
          },
          {
            title: 'Optimalisatie van virtuele machines',
            description: 'Beheer van VMware- en Hyper-V-virtualisatie, geoptimaliseerd voor resourcegebruik, prestaties en kostenefficiëntie.',
            capabilities: [
              'Provisioning en beheer van virtuele machines',
              'Resourceallocatie en -optimalisatie',
              'VM-migratie en -consolidatie',
              'Prestatiemonitoring en -tuning'
            ]
          },
          {
            title: 'Monitoring & analytics',
            description: 'Uitgebreide infrastructuurmonitoring met geavanceerde analytics, alerting en rapportage voor proactieve probleemdetectie en -oplossing.',
            capabilities: [
              'Realtime infrastructuurmonitoring',
              'Predictieve analytics en alerting',
              'Dashboards en rapportages op maat',
              'Capaciteitsplanning en prognose'
            ]
          }
        ],
        technologies: {
          title: 'Technologie-expertise',
          description: 'Diepgaande expertise in platforms en tools voor infrastructuurbeheer.',
          platforms: [
            { name: 'VMware vSphere', category: 'Virtualisatieplatform' },
            { name: 'Microsoft Hyper-V', category: 'Hypervisor' },
            { name: 'Microsoft System Center', category: 'Beheersuite' },
            { name: 'Nagios', category: 'Monitoringoplossing' },
            { name: 'Veeam', category: 'Back-up & herstel' },
            { name: 'SolarWinds', category: 'Infrastructuurmonitoring' }
          ]
        },
        implementation: {
          title: 'Implementatiemethodologie',
          description: 'Gestructureerde aanpak voor de implementatie van infrastructuurbeheer die optimale prestaties en betrouwbaarheid waarborgt.',
          phases: [
            {
              phase: 'Evaluatie & inventarisatie',
              duration: '1-2 weken',
              description: 'Uitgebreide evaluatie van de infrastructuur en analyse van de huidige situatie.',
              deliverables: ['Auditrapport van de infrastructuur', 'Prestatiebaseline', 'Capaciteitsanalyse', 'Risico-evaluatie']
            },
            {
              phase: 'Ontwerp & planning',
              duration: '2-3 weken',
              description: 'Ontwerp van de oplossingsarchitectuur en planning van de implementatie.',
              deliverables: ['Architectuurontwerp', 'Implementatieroadmap', 'Migratiestrategie', 'Testprotocollen']
            },
            {
              phase: 'Implementatie & migratie',
              duration: '3-4 weken',
              description: 'Gefaseerde implementatie met uitgebreide tests en validatie.',
              deliverables: ['Implementatie van de infrastructuur', 'Datamigratie', 'Prestatietesten', 'Gebruikerstraining']
            },
            {
              phase: 'Optimalisatie & ondersteuning',
              duration: 'Doorlopend',
              description: 'Continue optimalisatie en doorlopende ondersteuning voor optimale prestaties.',
              deliverables: ['Prestatieoptimalisatie', 'Regelmatige monitoring', '24/7-ondersteuning', 'Continue verbetering']
            }
          ]
        },
        benefits: {
          title: 'Operationele impact',
          description: 'Meetbare verbeteringen in prestaties, betrouwbaarheid en operationele efficiëntie.',
          outcomes: [
            {
              label: 'SLA-realisatie',
              description: 'Proactieve monitoring en onderhoud zorgen voor maximale systeembeschikbaarheid en bedrijfscontinuïteit.'
            },
            {
              label: 'Minder downtime',
              description: 'Geautomatiseerde monitoring en snelle respons verminderen ongeplande downtime-incidenten aanzienlijk.'
            },
            {
              label: 'Snellere probleemoplossing',
              description: 'Gecentraliseerde monitoring en geautomatiseerde alerting versnellen probleemdetectie en -oplossing.'
            },
            {
              label: 'Kostenoptimalisatie',
              description: 'Resourceoptimalisatie en capaciteitsplanning verlagen de infrastructuurkosten en verbeteren tegelijk de prestaties.'
            }
          ]
        }
      },
      databaseManagement: {
        title: 'Database management',
        subtitle: 'Inrichting, migratie & beheer',
        description: 'Stabiliseer bedrijfskritische databases met migratie, tuning, geautomatiseerde back-ups en 24/7-monitoring die prestaties, uptime en compliance bewaakt.',
        heroContent: {
          mainTitle: 'Database management',
          subtitle: 'Deskundig databasebeheer, migratie en optimalisatie voor optimale prestaties en betrouwbaarheid',
          keyPoints: [
            'Inrichting en configuratie van databases',
            'Veilige datamigratie',
            'Prestatieoptimalisatie en tuning',
            '24/7-monitoring en -ondersteuning'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Uitdagingen in databasebeheer',
            description: 'Organisaties worstelen met databaseprestaties, complexe migraties, beveiligingskwetsbaarheden en een gebrek aan expertise in databasebeheer.',
            challenges: [
              'Slechte databaseprestaties die applicaties hinderen',
              'Complexe migratieprojecten die downtime veroorzaken',
              'Beveiligingskwetsbaarheden en complianceproblemen',
              'Gebrek aan deskundige databasebeheerders'
            ]
          },
          solution: {
            title: 'Uitgebreide databasediensten',
            description: 'We bieden deskundig databasebeheer dat prestaties optimaliseert, veilige migraties waarborgt en uw databases betrouwbaar laat draaien.',
            benefits: [
              'Geoptimaliseerde databaseprestaties en betrouwbaarheid',
              'Veilige datamigraties',
              'Verbeterde beveiliging en compliance',
              'Deskundig beheer en 24/7-ondersteuning'
            ]
          }
        },
        features: [
          {
            title: 'Database-inrichting & configuratie',
            description: 'Professionele installatie, configuratie en tuning van databases voor optimale prestaties en beveiliging.',
            capabilities: [
              'Installatie en inrichting van databaseservers',
              'Prestatietuning en -optimalisatie',
              'Beveiligingshardening en -configuratie',
              'Implementatie van hoge beschikbaarheid'
            ]
          },
          {
            title: 'Databasemigratie',
            description: 'Veilige en betrouwbare databasemigratie met minimale downtime en uitgebreide testen.',
            capabilities: [
              'Databasemigratieplanning en -uitvoering',
              'Validatie en testen van data-integriteit',
              'Migratiestrategieën zonder downtime',
              'Optimalisatie en ondersteuning na de migratie'
            ]
          },
          {
            title: 'Prestatieoptimalisatie',
            description: 'Tuning en optimalisatie van databaseprestaties voor snelle query-uitvoering en efficiënt resourcegebruik.',
            capabilities: [
              'Queryoptimalisatie en -tuning',
              'Indexbeheer en -optimalisatie',
              'Databasemonitoring en -analyse',
              'Capaciteitsplanning en schaling'
            ]
          },
          {
            title: 'Doorlopend beheer',
            description: 'Uitgebreide databaseadministratie inclusief monitoring, back-ups, beveiliging en onderhoud.',
            capabilities: [
              '24/7-databasemonitoring en -ondersteuning',
              'Geautomatiseerde back-up en herstel',
              'Beveiligingsupdates en patchbeheer',
              'Prestatiemonitoring en -rapportage'
            ]
          }
        ],
        technologies: {
          title: 'Database-expertise',
          description: 'Expertise in databaseplatforms en beheertools.',
          platforms: [
            { name: 'PostgreSQL', category: 'Open-sourcedatabase' },
            { name: 'MySQL', category: 'Relationele database' },
            { name: 'Microsoft SQL Server', category: 'Enterprise-database' },
            { name: 'Oracle Database', category: 'Enterprise-database' },
            { name: 'MongoDB', category: 'NoSQL-database' },
            { name: 'Redis', category: 'In-memorydatabase' }
          ]
        },
        implementation: {
          title: 'Implementatieproces',
          description: 'Gestructureerde aanpak voor databasebeheer die optimale prestaties en betrouwbaarheid waarborgt.',
          phases: [
            {
              phase: 'Evaluatie & planning',
              duration: '1-2 weken',
              description: 'Uitgebreide database-evaluatie en ontwikkeling van een beheerstrategie.',
              deliverables: ['Database-auditrapport', 'Prestatiebaseline', 'Beheerstrategie', 'Beveiligingsevaluatie']
            },
            {
              phase: 'Inrichting & configuratie',
              duration: '2-3 weken',
              description: 'Inrichting, configuratie en optimalisatie van de database, klaar voor productie.',
              deliverables: ['Database-installatie', 'Prestatietuning', 'Beveiligingsconfiguratie', 'Back-upstrategie']
            },
            {
              phase: 'Migratie & implementatie',
              duration: '2-4 weken',
              description: 'Veilige databasemigratie en implementatie met uitgebreide testen.',
              deliverables: ['Datamigratie', 'Prestatietesten', 'Beveiligingsvalidatie', 'Gebruikersacceptatie']
            },
            {
              phase: 'Doorlopende ondersteuning',
              duration: 'Doorlopend',
              description: 'Continue monitoring, optimalisatie en 24/7-ondersteuning voor databaseoperaties.',
              deliverables: ['24/7-monitoring', 'Prestatieoptimalisatie', 'Beveiligingsupdates', 'Doorlopende ondersteuning']
            }
          ]
        },
        benefits: {
          title: 'Prestatie-impact',
          description: 'Meetbare verbeteringen in databaseprestaties, betrouwbaarheid en beveiliging.',
          outcomes: [
            {
              label: 'Prestatieverbetering',
              description: 'Optimalisatie-inspanningen verbeteren queryprestaties en responstijden aanzienlijk.'
            },
            {
              label: 'SLA-garantie',
              description: 'Betrouwbare databaseoperaties met uitgebreide monitoring en ondersteuning zorgen voor maximale beschikbaarheid.'
            },
            {
              label: 'Snellere query-uitvoering',
              description: 'Prestatietuning en -optimalisatie verkorten de uitvoeringstijd van queries drastisch.'
            },
            {
              label: 'Databeveiliging en compliance',
              description: 'Verbeterde beveiligings- en compliancemaatregelen zorgen voor gegevensbescherming en naleving van regelgeving.'
            }
          ]
        }
      },
      serviceDesk: {
        title: 'Implementatie van een servicedesk',
        subtitle: 'Inrichting en configuratie van uw servicedesk',
        description: 'Lanceer Jira-, ServiceNow- of YouTrack-desks met workflows, SLA\'s en automatisering die oplostijden verlagen en agents volledige ticketcontext geven.',
        heroContent: {
          mainTitle: 'Implementatie van een servicedesk',
          subtitle: 'Professionele inrichting en configuratie van uw servicedesk voor efficiënte IT-ondersteuning',
          keyPoints: [
            'Implementatie van een professioneel servicedeskplatform',
            'Geautomatiseerde ticketrouting en escalatie',
            'Uitgebreide rapportage en analytics',
            'Integratie met bestaande IT-systemen'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Uitdagingen in IT-ondersteuning',
            description: 'Organisaties worstelen met inefficiënte ondersteuningsprocessen, slecht ticketbeheer en een gebrek aan inzicht in de prestaties van hun IT-dienstverlening.',
            challenges: [
              'Handmatige ticketrouting die vertragingen veroorzaakt',
              'Gebrek aan gestandaardiseerde ondersteuningsprocessen',
              'Slecht zicht op kengetallen van de ondersteuning',
              'Integratie-uitdagingen met bestaande systemen'
            ]
          },
          solution: {
            title: 'Uitgebreide servicedeskoplossingen',
            description: 'We implementeren professionele servicedeskplatforms die processen automatiseren, de efficiëntie verbeteren en volledig inzicht geven in uw IT-ondersteuning.',
            benefits: [
              'Geautomatiseerde ticketrouting en escalatie',
              'Gestandaardiseerde ondersteuningsprocessen en workflows',
              'Uitgebreide rapportage en analytics',
              'Integratie met bestaande systemen'
            ]
          }
        },
        features: [
          {
            title: 'Platformimplementatie',
            description: 'Volledige inrichting en configuratie van uw servicedeskplatform met Jira Service Desk, YouTrack of Zammad, afgestemd op uw eisen.',
            capabilities: [
              'Platformselectie en -configuratie',
              'Ontwerp en implementatie van workflows op maat',
              'Aanpassing van de gebruikersinterface',
              'Integratie met bestaande systemen'
            ]
          },
          {
            title: 'Procesautomatisering',
            description: 'Geautomatiseerde ticketrouting, escalatie en afhandeling die de efficiëntie verbeteren en responstijden verkorten.',
            capabilities: [
              'Regels voor geautomatiseerde ticketrouting',
              'Escalatie- en SLA-beheer',
              'Goedkeuringsworkflows en automatisering',
              'Automatisering van notificaties en communicatie'
            ]
          },
          {
            title: 'Rapportage & analytics',
            description: 'Uitgebreide rapportage en analytics die inzicht geven in ondersteuningsprestaties, gebruikerstevredenheid en operationele efficiëntie.',
            capabilities: [
              'Dashboards op maat',
              'Prestatiecijfers en KPI\'s',
              'Trendanalyse en prognose',
              'Rapportage en inzichten voor het management'
            ]
          },
          {
            title: 'Integratie & beveiliging',
            description: 'Veilige integratie met bestaande IT-systemen en implementatie van best practices voor de beveiliging van uw servicedesk.',
            capabilities: [
              'Active Directory-integratie',
              'Implementatie van single sign-on',
              'Handhaving van beveiligingsbeleid',
              'Audittrail en compliancerapportage'
            ]
          }
        ],
        technologies: {
          title: 'Platformexpertise',
          description: 'Expertise in servicedeskplatforms en ondersteunende technologieën.',
          platforms: [
            { name: 'Jira Service Desk', category: 'Atlassian-platform' },
            { name: 'YouTrack', category: 'JetBrains-oplossing' },
            { name: 'Zammad', category: 'Open-sourceplatform' },
            { name: 'ServiceNow', category: 'Enterprise-platform' },
            { name: 'Freshservice', category: 'Cloudoplossing' },
            { name: 'ManageEngine', category: 'IT-beheersuite' }
          ]
        },
        implementation: {
          title: 'Implementatieproces',
          description: 'Gestructureerde aanpak voor de implementatie van uw servicedesk, die een succesvolle adoptie en optimalisatie waarborgt.',
          phases: [
            {
              phase: 'Eisen & planning',
              duration: '1-2 weken',
              description: 'Uitgebreide analyse van de eisen en planning van de implementatie.',
              deliverables: ['Eisenspecificatie', 'Platformselectie', 'Implementatieplan', 'Tijdlijn en mijlpalen']
            },
            {
              phase: 'Configuratie & inrichting',
              duration: '2-3 weken',
              description: 'Platformconfiguratie, workflowontwerp en systeeminrichting.',
              deliverables: ['Platformconfiguratie', 'Workflowimplementatie', 'Inrichting van de gebruikersinterface', 'Integratieconfiguratie']
            },
            {
              phase: 'Testen & training',
              duration: '1-2 weken',
              description: 'Uitgebreide tests en gebruikerstraining voor een succesvolle adoptie.',
              deliverables: ['Systeemtesten', 'Trainingsmateriaal voor gebruikers', 'Beheerderstraining', 'Voorbereiding op de livegang']
            },
            {
              phase: 'Lancering & optimalisatie',
              duration: 'Doorlopend',
              description: 'Ondersteuning bij de livegang en continue optimalisatie voor optimale prestaties.',
              deliverables: ['Ondersteuning bij de livegang', 'Prestatiemonitoring', 'Procesoptimalisatie', 'Doorlopend onderhoud']
            }
          ]
        },
        benefits: {
          title: 'Service-impact',
          description: 'Meetbare verbeteringen in ondersteuningsefficiëntie en gebruikerstevredenheid.',
          outcomes: [
            {
              label: 'Snellere ticketafhandeling',
              description: 'Geautomatiseerde routing en gestandaardiseerde processen verminderen oplossingstijden aanzienlijk.'
            },
            {
              label: 'Gebruikerstevredenheid',
              description: 'Verbeterde servicekwaliteit en snellere responstijden verhogen de gebruikerstevredenheid.'
            },
            {
              label: 'Minder escalaties',
              description: 'Meer oplossingen bij het eerste contact en geautomatiseerde escalatie verminderen onnodige escalaties.'
            },
            {
              label: 'Kostenreductie',
              description: 'Gestroomlijnde processen en automatisering verlagen de operationele kosten van de ondersteuning.'
            }
          ]
        }
      },
      knowledgeManagement: {
        title: 'Knowledge management',
        subtitle: 'Confluence en kennisbanksystemen',
        description: 'Bouw Confluence- en kennisbankportalen met governance, templates en een vaste reviewcyclus, zodat kennis die nu alleen in hoofden zit verandert in betrouwbare, herbruikbare documentatie.',
        heroContent: {
          mainTitle: 'Knowledge management',
          subtitle: 'Uitgebreid kennisbeheer voor betere documentatie en informatie-uitwisseling',
          keyPoints: [
            'Implementatie van een gecentraliseerde kennisrepository',
            'Geavanceerde zoek- en vindbaarheidsfuncties',
            'Collaboratieve documentatieworkflows',
            'Kennisretentie en overdrachtsprocessen'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Uitdagingen in kennisbeheer',
            description: 'Organisaties worstelen met verspreide informatie, slechte kennisdeling en moeite om relevante informatie te vinden wanneer die nodig is.',
            challenges: [
              'Informatie verspreid over meerdere systemen',
              'Slechte kennisdeling en samenwerking',
              'Moeilijkheden bij het vinden van relevante informatie',
              'Kennisverlies door personeelsverloop'
            ]
          },
          solution: {
            title: 'Uitgebreide kennisoplossingen',
            description: 'We implementeren centrale kennisbeheersystemen die informatie organiseren, samenwerking faciliteren en kennisretentie waarborgen.',
            benefits: [
              'Gecentraliseerde kennisrepository',
              'Geavanceerde zoek- en vindbaarheidsfuncties',
              'Collaboratieve documentatieworkflows',
              'Kennisretentie en overdrachtsprocessen'
            ]
          }
        },
        features: [
          {
            title: 'Platformimplementatie',
            description: 'Volledige inrichting van uw kennisbeheerplatform met Confluence, SharePoint of vergelijkbare tools.',
            capabilities: [
              'Platformselectie en -configuratie',
              'Sitestructuur en -indeling',
              'Templates opstellen en aanpassen',
              'Inrichting van gebruikerstoegang en rechten'
            ]
          },
          {
            title: 'Contentbeheer',
            description: 'Gestructureerde contentbeheerprocessen die nauwkeurige, relevante en goed vindbare informatie waarborgen.',
            capabilities: [
              'Workflows voor contentcreatie',
              'Review- en goedkeuringsprocessen',
              'Versiecontrole en wijzigingsbeheer',
              'Levenscyclusbeheer van content'
            ]
          },
          {
            title: 'Zoeken & vinden',
            description: 'Geavanceerde zoekmogelijkheden en functies om content te ontdekken, zodat gebruikers relevante informatie snel vinden.',
            capabilities: [
              'Geavanceerde zoekconfiguratie',
              'Tagging en categorisatie van content',
              'Aanbevelingsengines',
              'Analytics en gebruikstracking'
            ]
          },
          {
            title: 'Samenwerken & delen',
            description: 'Functies voor samenwerken en delen die kennisdeling en teamsamenwerking bevorderen.',
            capabilities: [
              'Samen bewerken en reageren',
              'Workflows voor kennisdeling',
              'Samenwerkingsfuncties voor teams',
              'Integratie met communicatietools'
            ]
          }
        ],
        technologies: {
          title: 'Platformexpertise',
          description: 'Expertise in platforms voor kennisbeheer en ondersteunende technologieën.',
          platforms: [
            { name: 'Confluence', category: 'Atlassian-platform' },
            { name: 'SharePoint', category: 'Microsoft-oplossing' },
            { name: 'Notion', category: 'Modern platform' },
            { name: 'GitBook', category: 'Documentatieplatform' },
            { name: 'Slab', category: 'Kennisbank voor teams' },
            { name: 'Tettra', category: 'Interne kennisbank' }
          ]
        },
        implementation: {
          title: 'Implementatiemethodologie',
          description: 'Gestructureerde aanpak voor de implementatie van kennisbeheer, die een succesvolle adoptie en het realiseren van waarde waarborgt.',
          phases: [
            {
              phase: 'Evaluatie & strategie',
              duration: '1-2 weken',
              description: 'Kennisaudit en strategieontwikkeling voor effectief kennisbeheer.',
              deliverables: ['Kennisauditrapport', 'Strategiedocument', 'Platformselectie', 'Implementatieroadmap']
            },
            {
              phase: 'Ontwerp & configuratie',
              duration: '2-3 weken',
              description: 'Platformontwerp, configuratie en opzet van de contentstructuur.',
              deliverables: ['Platformconfiguratie', 'Contentstructuur', 'Ontwikkeling van templates', 'Trainingsmateriaal voor gebruikers']
            },
            {
              phase: 'Migratie & lancering',
              duration: '2-4 weken',
              description: 'Contentmigratie, gebruikerstraining en lancering van het platform.',
              deliverables: ['Contentmigratie', 'Gebruikerstraining', 'Ondersteuning bij de livegang', 'Veranderingsbeheer']
            },
            {
              phase: 'Optimalisatie & ondersteuning',
              duration: 'Doorlopend',
              description: 'Continue optimalisatie en doorlopende ondersteuning voor succesvol kennisbeheer.',
              deliverables: ['Prestatieoptimalisatie', 'Contentonderhoud', 'Gebruikersondersteuning', 'Continue verbetering']
            }
          ]
        },
        benefits: {
          title: 'Impact van kennisbeheer',
          description: 'Meetbare verbeteringen in kennisdeling, samenwerking en besluitvorming.',
          outcomes: [
            {
              label: 'Snellere toegang tot informatie',
              description: 'Een gecentraliseerde kennisrepository en geavanceerd zoeken verkorten de tijd die nodig is om informatie te vinden aanzienlijk.'
            },
            {
              label: 'Minder dubbel werk',
              description: 'Betere kennisdeling vermindert overbodig werk en verbetert de efficiëntie.'
            },
            {
              label: 'Betere samenwerking',
              description: 'Functies voor samenwerken en kennisdeling verbeteren de samenwerking en communicatie binnen teams.'
            },
            {
              label: 'Kennisretentie',
              description: 'Gestructureerde processen voor kennisbeheer zorgen ervoor dat organisatiekennis behouden en toegankelijk blijft.'
            }
          ]
        }
      },
      cloudWorkspace: {
        title: 'Cloudwerkplekken',
        subtitle: 'Microsoft 365 & Google Workspace',
        description: 'Moderniseer M365 en Google Workspace met geautomatiseerde provisioning, onboarding, DLP-beleid en workflows die samenwerking veilig, compliant en snel houden.',
        heroContent: {
          mainTitle: 'Cloudwerkplekken',
          subtitle: 'Complete inrichting en administratie van Microsoft 365- en Google Workspace-omgevingen',
          keyPoints: [
            'Complete administratie van Microsoft 365 en Google Workspace',
            'Geavanceerde beveiligings- en complianceconfiguraties',
            'Migratie en integratie',
            'Doorlopende optimalisatie en ondersteuning'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Complexe cloudwerkplekken',
            description: 'Organisaties worstelen met complexe cloudomgevingen, beveiligingsconfiguraties en het waarborgen van optimale prestaties voor verspreid werkende teams.',
            challenges: [
              'Complexe beveiligings- en compliancevereisten',
              'Integratie-uitdagingen tussen platforms',
              'Gebruikersadoptie en veranderingsbeheer',
              'Kostenoptimalisatie en licentiebeheer'
            ]
          },
          solution: {
            title: 'Uitgebreid cloudbeheer',
            description: 'We bieden end-to-end oplossingen voor cloudwerkplekken die de complexiteit verminderen en tegelijk beveiliging en productiviteit maximaliseren.',
            benefits: [
              'Centrale administratie voor alle platforms',
              'Geautomatiseerde beveiliging en compliance',
              'Gestroomlijnd gebruikersbeheer',
              'Kosteneffectieve licentieoptimalisatie'
            ]
          }
        },
        features: [
          {
            title: 'Platformadministratie',
            description: 'Complete administratie van Microsoft 365- en Google Workspace-omgevingen met geavanceerde configuratie en optimalisatie.',
            capabilities: [
              'Tenantconfiguratie en -optimalisatie',
              'Gebruikerslevenscyclusbeheer',
              'Implementatie van beveiligingsbeleid',
              'Prestatiemonitoring en -tuning'
            ]
          },
          {
            title: 'Beveiliging & compliance',
            description: 'Beveiligingsconfiguraties op enterpriseniveau die gegevensbescherming en naleving van regelgeving waarborgen voor alle clouddiensten.',
            capabilities: [
              'DLP-beleid (data loss prevention)',
              'Voorwaardelijke toegang',
              'Compliancerapportage en -monitoring',
              'Bedreigingsbescherming en -respons'
            ]
          },
          {
            title: 'Migratie & integratie',
            description: 'Migratie- en integratiediensten die uw cloudwerkplek verbinden met bestaande systemen.',
            capabilities: [
              'Migratie van e-mail en data',
              'Directorysynchronisatie',
              'Applicatie-integratie',
              'Ondersteuning bij veranderingsbeheer'
            ]
          },
          {
            title: 'Optimalisatie & ondersteuning',
            description: 'Continue optimalisatie en 24/7-ondersteuning die ervoor zorgen dat uw cloudomgeving optimaal presteert.',
            capabilities: [
              'Prestatiemonitoring en -optimalisatie',
              'Licentiebeheer en kostenoptimalisatie',
              '24/7 technische ondersteuning',
              'Regelmatige statuscontroles en rapportage'
            ]
          }
        ],
        technologies: {
          title: 'Platformexpertise',
          description: 'Diepgaande expertise in cloudwerkplekplatforms en ondersteunende technologieën.',
          platforms: [
            { name: 'Microsoft 365', category: 'Productiviteitssuite' },
            { name: 'Google Workspace', category: 'Samenwerkingsplatform' },
            { name: 'Azure Active Directory', category: 'Identiteitsbeheer' },
            { name: 'Microsoft Defender', category: 'Beveiligingsplatform' },
            { name: 'Google Cloud Identity', category: 'Identiteitsservices' },
            { name: 'Okta', category: 'Identiteitsprovider' }
          ]
        },
        implementation: {
          title: 'Implementatieproces',
          description: 'Gestructureerde aanpak voor de implementatie van uw cloudwerkplek, die een succesvolle adoptie en optimalisatie waarborgt.',
          phases: [
            {
              phase: 'Evaluatie & strategie',
              duration: '1-2 weken',
              description: 'Uitgebreide evaluatie van de huidige omgeving en ontwikkeling van een cloudstrategie.',
              deliverables: ['Analyse van de huidige situatie', 'Cloudstrategiedocument', 'Migratieroadmap', 'Beveiligingskader']
            },
            {
              phase: 'Ontwerp & configuratie',
              duration: '2-3 weken',
              description: 'Ontwerp en configuratie van de cloudwerkplekomgeving.',
              deliverables: ['Architectuurontwerp', 'Beveiligingsconfiguraties', 'Integratiespecificaties', 'Testplannen']
            },
            {
              phase: 'Migratie & implementatie',
              duration: '3-4 weken',
              description: 'Gefaseerde migratie en implementatie met uitgebreide tests en validatie.',
              deliverables: ['Pilotmigratie', 'Volledige implementatie', 'Gebruikerstraining', 'Ondersteuning bij de livegang']
            },
            {
              phase: 'Optimalisatie & ondersteuning',
              duration: 'Doorlopend',
              description: 'Continue optimalisatie en doorlopende ondersteuning voor optimale prestaties.',
              deliverables: ['Prestatieoptimalisatie', 'Regelmatige monitoring', '24/7-ondersteuning', 'Continue verbetering']
            }
          ]
        },
        benefits: {
          title: 'Bedrijfswaarde',
          description: 'Meetbare bedrijfswaarde door geoptimaliseerde cloudwerkplekken.',
          outcomes: [
            {
              label: 'Lagere IT-kosten',
              description: 'Geoptimaliseerde licenties en gestroomlijnde administratie verlagen de totale operationele IT-kosten.'
            },
            {
              label: 'Gebruikerstevredenheid',
              description: 'Betere gebruikerservaring en productiviteit door een geoptimaliseerde configuratie van uw cloudwerkplek.'
            },
            {
              label: 'SLA-garantie',
              description: 'Betrouwbare cloudinfrastructuur met uitgebreide monitoring en proactieve ondersteuning.'
            },
            {
              label: 'Compliancedekking',
              description: 'Uitgebreide beveiliging en compliance zorgen ervoor dat aan de wettelijke vereisten wordt voldaan.'
            }
          ]
        }
      },
      identityAccess: {
        title: 'Identiteits- en toegangsbeheer',
        subtitle: 'Active Directory, Okta en CyberArk',
        description: 'Implementeer Azure AD, Okta en CyberArk met SSO, MFA, geautomatiseerd levenscyclusbeheer en PAM-beleid om wildgroei van toegangsrechten te stoppen en audits te doorstaan.',
        heroContent: {
          mainTitle: 'Identiteits- en toegangsbeheer',
          subtitle: 'Veilig identiteits- en toegangsbeheer',
          keyPoints: [
            'Geavanceerde authenticatie en autorisatie',
            'Privileged access management (PAM)',
            'Implementatie van single sign-on (SSO)',
            'Uitgebreide audit en compliance'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Uitdagingen in identiteitsbeveiliging',
            description: 'Organisaties worden geconfronteerd met toenemende beveiligingsrisico\'s door identiteitsgebaseerde aanvallen, complexe toegangsvereisten en eisen voor naleving van regelgeving.',
            challenges: [
              'Identiteitsgebaseerde aanvallen en diefstal van inloggegevens',
              'Complex toegangsbeheer voor meerdere systemen',
              'Beveiligingslekken bij geprivilegieerde toegang',
              'Compliance en auditvereisten'
            ]
          },
          solution: {
            title: 'Uitgebreide identiteitsbeveiliging',
            description: 'We bieden geïntegreerd identiteits- en toegangsbeheer voor veilige, efficiënte en compliant toegangscontrole.',
            benefits: [
              'Eén platform voor identiteitsbeheer',
              'Geavanceerde authenticatiemechanismen',
              'Geautomatiseerde toegangsprovisioning',
              'Uitgebreide audit en compliance'
            ]
          }
        },
        features: [
          {
            title: 'Authenticatie & autorisatie',
            description: 'Multifactorauthenticatie en role-based access control die veilige toegang tot kritieke systemen en gegevens waarborgen.',
            capabilities: [
              'Multifactorauthenticatie (MFA)',
              'Implementatie van single sign-on (SSO)',
              'Role-based access control (RBAC)',
              'Beleid voor voorwaardelijke toegang'
            ]
          },
          {
            title: 'Privileged access management',
            description: 'Veilig beheer van geprivilegieerde accounts en verhoogde toegangsrechten met uitgebreide monitoring en controle.',
            capabilities: [
              'Detectie van geprivilegieerde accounts',
              'Just-in-time-toegangsprovisioning',
              'Sessiemonitoring en -opname',
              'Geautomatiseerde wachtwoordrotatie'
            ]
          },
          {
            title: 'Identiteitslevenscyclusbeheer',
            description: 'Geautomatiseerde provisioning en deprovisioning van gebruikers en toegangsbeheer gedurende de hele levenscyclus van medewerkers.',
            capabilities: [
              'Geautomatiseerde gebruikersprovisioning',
              'Workflows voor toegangsaanvragen',
              'Identiteitsgovernance en compliance',
              'Gedelegeerde administratie'
            ]
          },
          {
            title: 'Audit & compliance',
            description: 'Uitgebreide audittrails, compliancerapportage en risico-evaluatie voor activiteiten op het gebied van identiteits- en toegangsbeheer.',
            capabilities: [
              'Uitgebreide auditlogging',
              'Compliancerapportage en -dashboards',
              'Risico-evaluatie en analytics',
              'Afstemming op regelgevingskaders'
            ]
          }
        ],
        technologies: {
          title: 'Technologieplatforms',
          description: 'Expertise in platforms voor identiteits- en toegangsbeheer.',
          platforms: [
            { name: 'Microsoft Active Directory', category: 'Directory Services' },
            { name: 'Azure Active Directory', category: 'Cloudidentiteit' },
            { name: 'Okta', category: 'Identiteitsprovider' },
            { name: 'CyberArk', category: 'Privileged Access Management' },
            { name: 'BeyondTrust', category: 'PAM-platform' },
            { name: 'SailPoint', category: 'Identiteitsgovernance' }
          ]
        },
        implementation: {
          title: 'Implementatieaanpak',
          description: 'Gestructureerde methodologie voor een succesvolle implementatie van identiteits- en toegangsbeheer.',
          phases: [
            {
              phase: 'Inventarisatie & evaluatie',
              duration: '1-2 weken',
              description: 'Uitgebreide evaluatie van de huidige identiteitsinfrastructuur en beveiligingshouding.',
              deliverables: ['Identiteitsauditrapport', 'Risico-evaluatie', 'Gap-analyse', 'Implementatiestrategie']
            },
            {
              phase: 'Ontwerp & architectuur',
              duration: '2-3 weken',
              description: 'Ontwerp van de oplossingsarchitectuur en implementatie van het beveiligingskader.',
              deliverables: ['Architectuurontwerp', 'Beveiligingsbeleid', 'Integratiespecificaties', 'Testprotocollen']
            },
            {
              phase: 'Implementatie & integratie',
              duration: '3-4 weken',
              description: 'Gefaseerde implementatie met uitgebreide tests en validatie van de integraties.',
              deliverables: ['Pilotimplementatie', 'Integratietesten', 'Beveiligingsvalidatie', 'Gebruikerstraining']
            },
            {
              phase: 'Optimalisatie & ondersteuning',
              duration: 'Doorlopend',
              description: 'Continue optimalisatie en doorlopende ondersteuning voor een optimale beveiligingshouding.',
              deliverables: ['Prestatieoptimalisatie', 'Beveiligingsmonitoring', '24/7-ondersteuning', 'Continue verbetering']
            }
          ]
        },
        benefits: {
          title: 'Beveiligingsimpact',
          description: 'Verbeter uw beveiligingshouding aanzienlijk en verhoog tegelijk de operationele efficiëntie.',
          outcomes: [
            {
              label: 'Minder identiteitsrisico\'s',
              description: 'Uitgebreide identiteitsbeveiliging vermindert het risico op identiteitsgebaseerde aanvallen en datalekken.'
            },
            {
              label: 'Snellere toegangsprovisioning',
              description: 'Geautomatiseerde workflows versnellen gebruikersonboarding en toegangsbeheerprocessen.'
            },
            {
              label: 'Compliancedekking',
              description: 'Uitgebreide audit en rapportage zorgen voor continue compliance met regelgevingsvereisten.'
            },
            {
              label: 'Minder administratieve overhead',
              description: 'Geautomatiseerd identiteitsbeheer vermindert de administratieve last en de operationele kosten.'
            }
          ]
        }
      },
      automationDevops: {
        title: 'IT-automatisering & DevOps',
        subtitle: 'Scripting, CI/CD en procesautomatisering',
        description: 'Ontwerp CI/CD-pijplijnen, infrastructure as code en zelfherstellende runbooks, zodat releases sneller gaan, repetitief handwerk afneemt en omgevingen volledig inzichtelijk blijven.',
        heroContent: {
          mainTitle: 'IT-automatisering & DevOps',
          subtitle: 'Automatiseer IT-processen en implementeer DevOps-praktijken voor een hogere efficiëntie',
          keyPoints: [
            'Continue integratie en uitrol (CI/CD)',
            'Implementatie van infrastructure as code (IaC)',
            'Geautomatiseerd testen en kwaliteitsborging',
            'Monitoring en observability'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Uitdagingen in IT-beheer',
            description: 'Organisaties worstelen met handmatige processen, trage uitrol en inconsistente omgevingen die de productiviteit en betrouwbaarheid aantasten.',
            challenges: [
              'Handmatige uitrolprocessen die vertragingen veroorzaken',
              'Inconsistente omgevingen en configuraties',
              'Beperkt inzicht in systeemprestaties',
              'Beperkte middelen die innovatie afremmen'
            ]
          },
          solution: {
            title: 'Operationele excellentie door automatisering',
            description: 'We implementeren uitgebreide automatisering en DevOps-praktijken die de oplevering versnellen en tegelijk de kwaliteit en betrouwbaarheid verbeteren.',
            benefits: [
              'Geautomatiseerde uitrolpijplijnen',
              'Consistent omgevingsbeheer',
              'Uitgebreide monitoring en alerting',
              'Verminderde operationele overhead'
            ]
          }
        },
        features: [
          {
            title: 'Implementatie van CI/CD-pijplijnen',
            description: 'Geautomatiseerde pijplijnen voor continue integratie en uitrol die snelle, betrouwbare softwarelevering waarborgen.',
            capabilities: [
              'Geautomatiseerde build- en testprocessen',
              'Geautomatiseerde uitrol en rollback',
              'Workflows voor promotie tussen omgevingen',
              'Kwaliteitspoorten en goedkeuringen'
            ]
          },
          {
            title: 'Infrastructure as code',
            description: 'Automatisering van infrastructuur met een codegebaseerde aanpak voor consistente, herhaalbare uitrol.',
            capabilities: [
              'Geautomatiseerde provisioning van infrastructuur',
              'Configuratiebeheer',
              'Omgevingsconsistentie',
              'Versiecontrole voor infrastructuur'
            ]
          },
          {
            title: 'Monitoring & observability',
            description: 'Uitgebreide monitoring, logging en observability voor proactieve probleemdetectie en -oplossing.',
            capabilities: [
              'Monitoring van applicatieprestaties',
              'Infrastructuurmonitoring en alerting',
              'Gecentraliseerde logging en analyse',
              'Dashboards en rapportages op maat'
            ]
          },
          {
            title: 'Procesautomatisering',
            description: 'Automatisering van routinematige IT-taken en bedrijfsprocessen om de efficiëntie te verbeteren en fouten te verminderen.',
            capabilities: [
              'Automatisering van IT-beheertaken',
              'Bedrijfsprocesautomatisering',
              'Automatisering van incidentrespons',
              'Automatisering van compliance en audits'
            ]
          }
        ],
        technologies: {
          title: 'Technologiestack',
          description: 'Expertise in automatisering en DevOps-platforms.',
          platforms: [
            { name: 'GitHub Actions', category: 'CI/CD-platform' },
            { name: 'Jenkins', category: 'Automatiseringsserver' },
            { name: 'Terraform', category: 'Infrastructure as code' },
            { name: 'Ansible', category: 'Configuratiebeheer' },
            { name: 'Docker', category: 'Containerisatie' },
            { name: 'Kubernetes', category: 'Containerorkestratie' }
          ]
        },
        implementation: {
          title: 'Implementatiemethodologie',
          description: 'Bewezen aanpak voor het implementeren van automatisering en DevOps-praktijken.',
          phases: [
            {
              phase: 'Evaluatie & planning',
              duration: '1-2 weken',
              description: 'Uitgebreide evaluatie van de huidige processen en ontwikkeling van een automatiseringsstrategie.',
              deliverables: ['Procesevaluatie', 'Automatiseringsroadmap', 'Technologieaanbevelingen', 'Implementatieplan']
            },
            {
              phase: 'Fundament & inrichting',
              duration: '2-3 weken',
              description: 'De automatiseringsinfrastructuur opzetten en de basis van DevOps-praktijken invoeren.',
              deliverables: ['Inrichting van de CI/CD-pijplijn', 'Infrastructuurautomatisering', 'Implementatie van monitoring', 'Beveiligingsintegratie']
            },
            {
              phase: 'Implementatie & testen',
              duration: '2-4 weken',
              description: 'Automatisering implementeren met uitgebreide tests en validatie.',
              deliverables: ['Pilotautomatisering', 'Prestatietesten', 'Beveiligingsvalidatie', 'Gebruikerstraining']
            },
            {
              phase: 'Optimalisatie & ondersteuning',
              duration: 'Doorlopend',
              description: 'Continue optimalisatie en doorlopende ondersteuning voor optimale prestaties.',
              deliverables: ['Prestatieoptimalisatie', 'Procesverbetering', '24/7-ondersteuning', 'Continue verbetering']
            }
          ]
        },
        benefits: {
          title: 'Operationele impact',
          description: 'Meetbare verbeteringen in snelheid, kwaliteit en betrouwbaarheid.',
          outcomes: [
            {
              label: 'Snellere uitrol',
              description: 'Geautomatiseerde pijplijnen verkorten de uitroltijd en verminderen het handwerk aanzienlijk.'
            },
            {
              label: 'Minder fouten',
              description: 'Geautomatiseerde processen elimineren handmatige fouten en verbeteren de consistentie.'
            },
            {
              label: 'Minder downtime',
              description: 'Proactieve monitoring en geautomatiseerd herstel verminderen systeemdowntime.'
            },
            {
              label: 'Kostenreductie',
              description: 'Automatisering vermindert operationele overhead en resourcevereisten.'
            }
          ]
        }
      },
      webDevelopment: {
        title: 'Webontwikkeling',
        subtitle: 'Webapplicaties en websites op maat',
        description: 'Laat razendsnelle sites en webapps bouwen met design systems, CMS-integraties en Core Web Vitals-tuning die bezoekers omzetten in gekwalificeerde leads.',
        heroContent: {
          mainTitle: 'Webontwikkeling in Nederland',
          subtitle: 'Professionele webontwikkeling, onderhoud en optimalisatie',
          keyPoints: [
            'Ontwikkeling van webapplicaties op maat',
            'Moderne frameworks en technologieën',
            'Responsief design en gebruikerservaring',
            'Prestatieoptimalisatie en beveiliging'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Uitdagingen bij digitale transformatie',
            description: 'Organisaties hebben moderne weboplossingen nodig om online te concurreren, maar worden geconfronteerd met technische complexiteit en beperkte middelen.',
            challenges: [
              'Verouderde webtechnologieën die mogelijkheden beperken',
              'Slechte gebruikerservaring die de betrokkenheid schaadt',
              'Beveiligingskwetsbaarheden en complianceproblemen',
              'Beperkingen in schaalbaarheid en prestaties'
            ]
          },
          solution: {
            title: 'Uitgebreide weboplossingen',
            description: 'We bouwen moderne webapplicaties die uitzonderlijke gebruikerservaringen bieden en tegelijk beveiliging, prestaties en schaalbaarheid waarborgen.',
            benefits: [
              'Moderne, responsieve webapplicaties',
              'Verbeterde gebruikerservaring en betrokkenheid',
              'Robuuste beveiliging en compliance',
              'Schaalbare architectuur en prestaties'
            ]
          }
        },
        features: [
          {
            title: 'Maatwerkontwikkeling',
            description: 'Op maat gemaakte webapplicaties gebouwd met moderne frameworks en best practices voor optimale prestaties en onderhoudbaarheid.',
            capabilities: [
              'React- en Next.js-applicaties',
              'Node.js-backendontwikkeling',
              'API-ontwikkeling en -integratie',
              'Databaseontwerp en -optimalisatie'
            ]
          },
          {
            title: 'UX-design',
            description: 'Intuïtieve, responsieve designs die uitzonderlijke gebruikerservaringen bieden op alle apparaten en platforms.',
            capabilities: [
              'Gebruikersinterfaceontwerp',
              'Responsief webdesign',
              'Optimalisatie van de gebruikerservaring',
              'Toegankelijkheidscompliance'
            ]
          },
          {
            title: 'Beveiliging & prestaties',
            description: 'Robuuste beveiligingsimplementaties en prestatieoptimalisaties die betrouwbare, snelle webapplicaties waarborgen.',
            capabilities: [
              'Implementatie van best practices voor beveiliging',
              'Prestatieoptimalisatie',
              'SEO-optimalisatie',
              'Compliance- en auditondersteuning'
            ]
          },
          {
            title: 'Onderhoud & ondersteuning',
            description: 'Doorlopend onderhoud, updates en ondersteuning die ervoor zorgen dat uw webapplicaties actueel en veilig blijven.',
            capabilities: [
              'Regelmatige updates en onderhoud',
              'Prestatiemonitoring',
              'Beveiligingsupdates en patches',
              '24/7 technische ondersteuning'
            ]
          }
        ],
        technologies: {
          title: 'Technologie-expertise',
          description: 'Ervaring met moderne technologieën en frameworks voor webontwikkeling.',
          platforms: [
            { name: 'React', category: 'Frontend-framework' },
            { name: 'Next.js', category: 'Full-stack-framework' },
            { name: 'Node.js', category: 'Backend-runtime' },
            { name: 'TypeScript', category: 'Programmeertaal' },
            { name: 'Tailwind CSS', category: 'Styling-framework' },
            { name: 'PostgreSQL', category: 'Database' }
          ]
        },
        implementation: {
          title: 'Ontwikkelingsproces',
          description: 'Gestructureerde aanpak voor webontwikkeling die kwaliteit en tijdige oplevering waarborgt.',
          phases: [
            {
              phase: 'Planning & ontwerp',
              duration: '1-2 weken',
              description: 'Vereistenanalyse, gebruikersonderzoek en oplossingsontwerp.',
              deliverables: ['Vereistenspecificatie', 'Gebruikerservaringsontwerp', 'Technische architectuur', 'Projecttijdlijn']
            },
            {
              phase: 'Ontwikkeling & testen',
              duration: '4-8 weken',
              description: 'Applicatieontwikkeling met continu testen en kwaliteitsborging.',
              deliverables: ['Frontendontwikkeling', 'Backendontwikkeling', 'Integratietesten', 'Kwaliteitsborging']
            },
            {
              phase: 'Implementatie & lancering',
              duration: '1-2 weken',
              description: 'Implementatie in productie, prestatieoptimalisatie en ondersteuning bij de livegang.',
              deliverables: ['Implementatie in productie', 'Prestatieoptimalisatie', 'Gebruikerstraining', 'Ondersteuning bij de livegang']
            },
            {
              phase: 'Onderhoud & ondersteuning',
              duration: 'Doorlopend',
              description: 'Doorlopend onderhoud, updates en ondersteuning voor optimale prestaties.',
              deliverables: ['Regelmatig onderhoud', 'Feature-updates', 'Prestatiemonitoring', '24/7-ondersteuning']
            }
          ]
        },
        benefits: {
          title: 'Bedrijfsimpact',
          description: 'Meetbare bedrijfswaarde door moderne weboplossingen.',
          outcomes: [
            {
              label: 'Meer gebruikersbetrokkenheid',
              description: 'Modern, responsief design verbetert gebruikersbetrokkenheid en conversiepercentages aanzienlijk.'
            },
            {
              label: 'Snellere paginalaadtijden',
              description: 'Prestatieoptimalisatie verkort paginalaadtijden en verbetert de gebruikerservaring.'
            },
            {
              label: 'Beveiligingscompliance',
              description: 'Robuuste beveiligingsimplementaties zorgen voor compliance met industriestandaarden en regelgeving.'
            },
            {
              label: 'Meer mobiel verkeer',
              description: 'Responsief design en mobiele optimalisatie zorgen voor een aanzienlijke toename van mobiel verkeer.'
            }
          ]
        }
      },
      itSupport: {
        title: 'IT-ondersteuning',
        subtitle: 'Helpdesk en technische ondersteuning',
        description: 'Uitgebreide IT-helpdesk en technische ondersteuning die snelle probleemoplossing en optimale systeemprestaties waarborgen.',
        heroContent: {
          mainTitle: 'IT-ondersteuning',
          subtitle: 'Professionele IT-helpdesk en technische ondersteuning voor een stabiele bedrijfsvoering en snelle probleemoplossing',
          keyPoints: [
            '24/7 technische ondersteuning en helpdeskdiensten',
            'Snelle incidentrespons en oplossing',
            'Proactieve systeemmonitoring en onderhoud',
            'Deskundige troubleshooting en probleemoplossing'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Uitdagingen in IT-ondersteuning',
            description: 'Organisaties worstelen met IT-problemen die downtime, productiviteitsverlies en frustratie bij gebruikers veroorzaken door trage responstijden en een gebrek aan deskundige ondersteuning.',
            challenges: [
              'Trage responstijden die de productiviteit drukken',
              'Gebrek aan deskundige technische ondersteuning',
              'Inconsistente probleemoplossingsprocessen',
              'Beperkt inzicht in de status van IT-systemen'
            ]
          },
          solution: {
            title: 'Uitgebreide IT-ondersteuning',
            description: 'We bieden professionele IT-ondersteuning die snelle probleemoplossing, proactieve monitoring en deskundige technische assistentie waarborgt.',
            benefits: [
              'Snelle incidentrespons en oplossing',
              'Deskundige technische ondersteuning en troubleshooting',
              'Proactieve systeemmonitoring en onderhoud',
              'Uitgebreide ondersteuningsdocumentatie en kennisbank'
            ]
          }
        },
        features: [
          {
            title: 'Helpdeskdiensten',
            description: 'Professionele helpdeskdiensten die eerstelijnsondersteuning bieden bij IT-problemen, gebruikersvragen en technische assistentie.',
            capabilities: [
              'Ticketbeheer en tracking',
              'Eerstelijns technische ondersteuning',
              'Gebruikersassistentie en begeleiding',
              'Escalatie en routing van problemen'
            ]
          },
          {
            title: 'Technische ondersteuning',
            description: 'Deskundige technische ondersteuning bij complexe IT-problemen, systeemtroubleshooting en probleemoplossing.',
            capabilities: [
              'Geavanceerde troubleshooting en diagnostiek',
              'Systeemconfiguratie en -optimalisatie',
              'Hardware- en softwareondersteuning',
              'Ondersteuning op afstand'
            ]
          },
          {
            title: 'Proactieve monitoring',
            description: 'Continue systeemmonitoring en proactief onderhoud om problemen te voorkomen voordat gebruikers er last van hebben.',
            capabilities: [
              '24/7-systeemmonitoring en alerting',
              'Proactieve probleemdetectie en -preventie',
              'Prestatiemonitoring en -optimalisatie',
              'Statuscontroles en onderhoud'
            ]
          },
          {
            title: 'Kennisbeheer',
            description: 'Uitgebreide kennisbank en documentatie die een consistente ondersteuningskwaliteit en snellere oplostijden waarborgen.',
            capabilities: [
              'Ontwikkeling en onderhoud van de kennisbank',
              'Ondersteuningsdocumentatie en procedures',
              'Training en kennisoverdracht',
              'Best practices en richtlijnen'
            ]
          }
        ],
        technologies: {
          title: 'Supporttools en -platforms',
          description: 'Expertise in platforms en tools voor IT-ondersteuning.',
          platforms: [
            { name: 'Zammad', category: 'Helpdeskplatform' },
            { name: 'Jira Service Desk', category: 'ITSM-platform' },
            { name: 'ServiceNow', category: 'Enterprise ITSM' },
            { name: 'Freshservice', category: 'Cloudhelpdesk' },
            { name: 'ManageEngine', category: 'IT-beheer' },
            { name: 'TeamViewer', category: 'Ondersteuning op afstand' }
          ]
        },
        implementation: {
          title: 'Zo richten we uw ondersteuning in',
          description: 'Gestructureerde aanpak voor het opzetten van uitgebreide IT-ondersteuning.',
          phases: [
            {
              phase: 'Evaluatie & planning',
              duration: '1-2 weken',
              description: 'Uitgebreide evaluatie van de huidige behoefte aan IT-ondersteuning en ontwikkeling van een ondersteuningsstrategie.',
              deliverables: ['Analyse van de ondersteuningsbehoefte', 'Ondersteuningsstrategiedocument', 'Toolselectie en planning', 'Implementatieroadmap']
            },
            {
              phase: 'Inrichting & configuratie',
              duration: '2-3 weken',
              description: 'Inrichting van het helpdeskplatform, configuratie van workflows en implementatie van ondersteuningsprocessen.',
              deliverables: ['Platformconfiguratie', 'Inrichting van workflows', 'Structuur van de kennisbank', 'Ondersteuningsprocedures']
            },
            {
              phase: 'Training & lancering',
              duration: '1-2 weken',
              description: 'Training van medewerkers, procesdocumentatie en ondersteuning bij de livegang van de IT-ondersteuning.',
              deliverables: ['Training van het supportteam', 'Gebruikersdocumentatie', 'Ondersteuning bij de livegang', 'Inrichting van prestatiemonitoring']
            },
            {
              phase: 'Doorlopende ondersteuning',
              duration: 'Doorlopend',
              description: 'Continue ondersteuning, procesoptimalisatie en serviceverbetering.',
              deliverables: ['24/7-ondersteuning', 'Prestatiemonitoring', 'Procesoptimalisatie', 'Continue verbetering']
            }
          ]
        },
        benefits: {
          title: 'Ondersteuningsimpact',
          description: 'Meetbare verbeteringen in ondersteuningskwaliteit en gebruikerstevredenheid.',
          outcomes: [
            {
              label: 'Snellere oplostijden',
              description: 'Deskundige ondersteuning en efficiënte processen verkorten de oplostijd van problemen aanzienlijk.'
            },
            {
              label: 'Gebruikerstevredenheid',
              description: 'Professionele ondersteuning en snelle responstijden verhogen de gebruikerstevredenheid.'
            },
            {
              label: 'Minder downtime',
              description: 'Proactieve monitoring en snelle respons verminderen systeemdowntime en productiviteitsverlies.'
            },
            {
              label: 'Oplossing bij eerste contact',
              description: 'Deskundige ondersteuning en een uitgebreide kennisbank zorgen ervoor dat veel problemen bij het eerste contact worden opgelost.'
            }
          ]
        }
      },
      dataEngineering: {
        title: 'Data-engineering',
        subtitle: 'Datapijplijnen en analytics-infrastructuur',
        description: 'Bouw robuuste datapijplijnen, ETL-processen en analytics-infrastructuur die ruwe gegevens omzetten in bruikbare inzichten voor datagestuurde besluitvorming.',
        heroContent: {
          mainTitle: 'Data-engineering',
          subtitle: 'Uitgebreide data-engineering voor het bouwen van schaalbare datapijplijnen, ETL-processen en analytics-infrastructuur',
          keyPoints: [
            'Ontwikkeling van schaalbare datapijplijnen',
            'Ontwerp en implementatie van ETL/ELT-processen',
            'Architectuur voor datawarehouses en data lakes',
            'Realtime dataverwerking en analytics'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Uitdagingen in de data-infrastructuur',
            description: 'Organisaties worstelen met versnipperde gegevensbronnen, inefficiënte gegevensverwerking en een gebrek aan schaalbare infrastructuur voor analytics en business intelligence.',
            challenges: [
              'Versnipperde gegevensbronnen en silo\'s',
              'Inefficiënte gegevensverwerking en -transformatie',
              'Gebrek aan schaalbare gegevensinfrastructuur',
              'Beperkte mogelijkheden voor realtime gegevensverwerking'
            ]
          },
          solution: {
            title: 'Uitgebreide data-engineering',
            description: 'We bouwen schaalbare data-engineeringoplossingen die efficiënte gegevensverwerking, transformatie en analytics-infrastructuur mogelijk maken.',
            benefits: [
              'Schaalbare architectuur voor datapijplijnen',
              'Efficiënte ETL/ELT-processen',
              'Eén gegevensinfrastructuur',
              'Realtime gegevensverwerking'
            ]
          }
        },
        features: [
          {
            title: 'Ontwikkeling van datapijplijnen',
            description: 'Ontwerp en implementeer schaalbare datapijplijnen voor efficiënte gegevensinname, -transformatie en -verwerking.',
            capabilities: [
              'Architectuurontwerp voor datapijplijnen',
              'Implementatie van ETL/ELT-processen',
              'Gegevensinname en -integratie',
              'Monitoring en optimalisatie van pijplijnen'
            ]
          },
          {
            title: 'Datawarehouse & data lake',
            description: 'Bouw en optimaliseer datawarehouses en data lakes voor gecentraliseerde gegevensopslag en analytics.',
            capabilities: [
              'Architectuurontwerp voor datawarehouses',
              'Implementatie en optimalisatie van data lakes',
              'Gegevensmodellering en schemaontwerp',
              'Opslagoptimalisatie en partitionering'
            ]
          },
          {
            title: 'Realtime verwerking',
            description: 'Implementeer realtime gegevensverwerking en streaming analytics voor directe inzichten en besluitvorming.',
            capabilities: [
              'Architectuur voor streamverwerking',
              'Realtime gegevenstransformatie',
              'Eventgestuurde gegevensverwerking',
              'Stream analytics en monitoring'
            ]
          },
          {
            title: 'Datakwaliteit & governance',
            description: 'Implementeer datakwaliteitskaders, governancebeleid en monitoring om betrouwbare gegevens te waarborgen.',
            capabilities: [
              'Datakwaliteitskaders en validatie',
              'Datagovernance en compliance',
              'Data lineage en catalogisering',
              'Datakwaliteitsmonitoring en -rapportage'
            ]
          }
        ],
        technologies: {
          title: 'Technologiestack',
          description: 'Expertise in platforms en tools voor data-engineering.',
          platforms: [
            { name: 'Apache Airflow', category: 'Workfloworkestratie' },
            { name: 'Apache Spark', category: 'Gegevensverwerking' },
            { name: 'Snowflake', category: 'Datawarehouse' },
            { name: 'AWS Glue', category: 'ETL-dienst' },
            { name: 'Apache Kafka', category: 'Streamverwerking' },
            { name: 'dbt', category: 'Gegevenstransformatie' }
          ]
        },
        implementation: {
          title: 'Implementatiemethodologie',
          description: 'Gestructureerde aanpak voor de implementatie van data-engineering die een schaalbare en betrouwbare gegevensinfrastructuur waarborgt.',
          phases: [
            {
              phase: 'Evaluatie & ontwerp',
              duration: '2-3 weken',
              description: 'Uitgebreide gegevensevaluatie, architectuurontwerp en implementatieplanning.',
              deliverables: ['Rapport van de gegevensevaluatie', 'Architectuurontwerp', 'Technologieaanbevelingen', 'Implementatieroadmap']
            },
            {
              phase: 'Inrichting van de infrastructuur',
              duration: '2-4 weken',
              description: 'Inrichting van de gegevensinfrastructuur, platformconfiguratie en ontwikkeling van de eerste pijplijnen.',
              deliverables: ['Implementatie van de infrastructuur', 'Platformconfiguratie', 'Eerste pijplijnen', 'Inrichting van beveiliging']
            },
            {
              phase: 'Ontwikkeling van pijplijnen',
              duration: '3-6 weken',
              description: 'Ontwikkeling van datapijplijnen, ETL-processen en implementatie van gegevenstransformaties.',
              deliverables: ['Datapijplijnen', 'ETL-processen', 'Datakwaliteitskaders', 'Inrichting van monitoring']
            },
            {
              phase: 'Optimalisatie & ondersteuning',
              duration: 'Doorlopend',
              description: 'Continue optimalisatie, prestatietuning en doorlopende ondersteuning voor de gegevensinfrastructuur.',
              deliverables: ['Prestatieoptimalisatie', 'Monitoring en alerting', '24/7-ondersteuning', 'Continue verbetering']
            }
          ]
        },
        benefits: {
          title: 'Bedrijfsimpact',
          description: 'Meetbare verbeteringen in de efficiëntie van gegevensverwerking en analytics.',
          outcomes: [
            {
              label: 'Snellere gegevensverwerking',
              description: 'Geoptimaliseerde pijplijnen en infrastructuur verkorten de verwerkingstijden aanzienlijk.'
            },
            {
              label: 'Kostenreductie',
              description: 'Efficiënte gegevensinfrastructuur en optimalisatie verlagen de kosten voor gegevensverwerking en -opslag.'
            },
            {
              label: 'Betere datakwaliteit',
              description: 'Uitgebreide datakwaliteitskaders zorgen voor betrouwbare gegevens voor analytics.'
            },
            {
              label: 'Sneller tot inzicht',
              description: 'Gestroomlijnde datapijplijnen en realtime verwerking zorgen dat u sneller tot bruikbare inzichten komt.'
            }
          ]
        }
      }
    }
  }
}
